{
  "$id": "urn:dm:schemas:document_data.json",
  "Direction": {
    "type": "string",
    "enum": [
      "ltr",
      "rtl",
      "inherit"
    ]
  },
  "AppVars": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "vars": {
        "type": "object",
        "additionalProperties": {
          "type": "object",
          "additionalProperties": false,
          "properties": {
            "value": {
              "type": "string",
              "maxLength": 100
            },
            "type": {
              "type": "string",
              "enum": [
                "AppPartParam"
              ]
            }
          }
        }
      },
      "appDefId": {
        "type": "string",
        "maxLength": 100
      }
    }
  },
  "SVGItem": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "svgId": {
        "type": "string",
        "maxLength": 100
      }
    }
  },
  "SVGReference": {
    "type": [
      "null",
      "string"
    ]
  },
  "BackgroundImage": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "url": {
        "type": "string"
      },
      "positionx": {
        "type": "string",
        "enum": [
          "left",
          "right",
          "center"
        ],
        "default": "center"
      },
      "imagesizew": {
        "type": "number",
        "default": 0,
        "multipleOf": 1,
        "minimum": -2147483648,
        "maximum": 2147483647
      },
      "imagesizeh": {
        "type": [
          "number",
          "null"
        ],
        "multipleOf": 1
      },
      "positiony": {
        "type": "string",
        "enum": [
          "top",
          "bottom",
          "center"
        ],
        "default": "center"
      },
      "width": {
        "type": "string"
      },
      "repeatx": {
        "type": "string",
        "enum": [
          "no_repeat",
          "repeat"
        ],
        "default": "repeat"
      },
      "repeaty": {
        "type": "string",
        "enum": [
          "no_repeat",
          "repeat"
        ],
        "default": "repeat"
      },
      "attachment": {
        "type": "string",
        "enum": [
          "scroll",
          "fixed",
          "inherit",
          "local"
        ],
        "default": "inherit"
      },
      "color": {
        "type": "string"
      }
    }
  },
  "BackgroundMedia": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "mediaRef": {
        "type": [
          "null",
          "string"
        ]
      },
      "mediaTransforms": {
        "type": "object",
        "properties": {
          "scale": {
            "type": "number",
            "minimum": 0
          },
          "opacity": {
            "type": "number",
            "minimum": 0,
            "maximum": 1
          }
        },
        "additionalProperties": false
      },
      "overlayTransforms": {
        "type": "object",
        "properties": {
          "scale": {
            "type": "number",
            "minimum": 0
          },
          "opacity": {
            "type": "number",
            "minimum": 0,
            "maximum": 1
          }
        },
        "additionalProperties": false
      },
      "color": {
        "oneOf": [
          {
            "enum": [
              "transparent",
              "noColor"
            ]
          },
          {
            "type": "string",
            "pattern": "^$|^((((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5])(,0*(0?\\.\\d+|0|1))?)|(color_([0-9]{1,2}|100))|(\\{color_([0-9]{1,2}|100)\\})|(\\[color_([0-9]{1,2}|100)\\])|(#(([0-9|a-f|A-F]){3}){1,2}))$"
          }
        ]
      },
      "colorOpacity": {
        "type": "number"
      },
      "alignType": {
        "type": "string",
        "enum": [
          "top",
          "bottom",
          "left",
          "right",
          "center",
          "top_left",
          "top_right",
          "bottom_left",
          "bottom_right"
        ]
      },
      "fittingType": {
        "type": "string",
        "enum": [
          "fill",
          "fit",
          "stretch",
          "actual_size",
          "original_size",
          "tile",
          "tile_horizontal",
          "tile_vertical",
          "fit_and_tile",
          "legacy_tile",
          "legacy_tile_horizontal",
          "legacy_tile_vertical",
          "legacy_normal"
        ]
      },
      "scrollType": {
        "type": "string",
        "enum": [
          "none",
          "fixed",
          "scroll",
          "local",
          "parallax"
        ]
      },
      "showOverlayForMediaType": {
        "type": "string",
        "enum": [
          "all",
          "WixVideo",
          "Image"
        ],
        "default": "WixVideo"
      },
      "imageOverlay": {
        "type": [
          "null",
          "string"
        ]
      },
      "colorOverlay": {
        "type": "string",
        "pattern": "^$|^((((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5])(,0*(0?\\.\\d+|0|1))?)|(color_([0-9]{1,2}|100))|(\\{color_([0-9]{1,2}|100)\\})|(\\[color_([0-9]{1,2}|100)\\])|(#(([0-9|a-f|A-F]){3}){1,2}))$"
      },
      "colorOverlayOpacity": {
        "type": "number"
      },
      "overlayBlending": {
        "type": "object",
        "properties": {
          "color": {
            "type": "string"
          },
          "opacity": {
            "type": "number",
            "minimum": 0,
            "maximum": 1
          },
          "contrast": {
            "type": "number",
            "minimum": 0,
            "maximum": 2
          },
          "saturate": {
            "type": "number",
            "minimum": 0,
            "maximum": 2
          },
          "blendMode": {
            "type": "string",
            "enum": [
              "normal",
              "multiply",
              "screen",
              "darken",
              "lighten",
              "overlay",
              "colorDodge",
              "colorBurn",
              "hardLight",
              "softLight",
              "difference",
              "exclusion",
              "hue",
              "saturation",
              "color",
              "luminosity"
            ]
          }
        },
        "additionalProperties": false
      },
      "filterEffect": {
        "type": [
          "object",
          "null"
        ],
        "properties": {
          "effectType": {
            "type": "string",
            "enum": [
              "none",
              "normal",
              "ink",
              "kennedy",
              "feathered",
              "blur",
              "whistler",
              "3d",
              "blueray",
              "lighten",
              "darken",
              "pinkrinse",
              "redrum",
              "greenwash",
              "yellowstreak",
              "neonsky",
              "seaweed",
              "soledad",
              "sangria",
              "malibu",
              "candyfloss",
              "elmo",
              "unicorn",
              "kerouac",
              "koolaid",
              "hydra",
              "pixie",
              "nightrain",
              "bauhaus",
              "neptune",
              "orca",
              "manhattan",
              "goldie",
              "flamingo",
              "faded",
              "gotham",
              "hulk",
              "midnight",
              "lucille",
              "organic",
              "grayscale",
              "tvDuotone",
              "tvMonotoneDark",
              "tvMonotoneLight",
              "tvHue"
            ]
          },
          "brightness": {
            "type": "number",
            "minimum": 0,
            "maximum": 10
          },
          "contrast": {
            "type": "number",
            "minimum": 0,
            "maximum": 10
          },
          "saturation": {
            "type": "number",
            "minimum": 0,
            "maximum": 10
          },
          "hue": {
            "type": "number",
            "minimum": -180,
            "maximum": 180
          },
          "duotoneDark": {
            "type": "string"
          },
          "duotoneLight": {
            "type": "string"
          },
          "invert": {
            "type": "boolean",
            "default": false
          },
          "isCustom": {
            "type": "boolean"
          }
        },
        "additionalProperties": false
      },
      "colorLayers": {
        "type": [
          "array",
          "null"
        ],
        "items": [
          {
            "type": [
              "null",
              "string"
            ]
          }
        ]
      }
    }
  },
  "WixVideo": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "title": {
        "type": "string",
        "maxLength": 100
      },
      "alt": {
        "type": "string",
        "maxLength": 1000
      },
      "videoId": {
        "type": "string"
      },
      "generatedPosters": {
        "type": "array",
        "items": {
          "type": "string"
        }
      },
      "qualities": {
        "type": "array",
        "items": {
          "type": "object",
          "properties": {
            "quality": {
              "type": "string"
            },
            "width": {
              "type": "number"
            },
            "height": {
              "type": "number"
            },
            "formats": {
              "type": "array",
              "items": {
                "type": "string"
              },
              "description": "Deprecated, replaced by 'format' and 'url' since we have a unique url for each quality"
            },
            "format": {
              "type": "string",
              "enum": [
                "mp4",
                "webm"
              ]
            },
            "url": {
              "type": "string"
            }
          },
          "additionalProperties": false
        }
      },
      "adaptiveVideo": {
        "type": [
          "array",
          "null"
        ],
        "items": {
          "type": "object",
          "properties": {
            "format": {
              "type": "string",
              "enum": [
                "hls",
                "dash"
              ]
            },
            "url": {
              "type": "string"
            }
          },
          "additionalProperties": false
        }
      },
      "posterImageRef": {
        "type": [
          "null",
          "string"
        ]
      },
      "duration": {
        "type": "number"
      },
      "fps": {
        "type": "string",
        "maxLength": 50
      },
      "hasAudio": {
        "type": "boolean",
        "description": "video has no audio"
      },
      "artist": {
        "type": "object",
        "properties": {
          "name": {
            "type": "string"
          },
          "id": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "loop": {
        "type": "boolean"
      },
      "autoplay": {
        "type": "boolean"
      },
      "playbackSpeed": {
        "type": "number"
      },
      "preload": {
        "type": "string",
        "enum": [
          "auto",
          "metadata",
          "none"
        ]
      },
      "controls": {
        "type": "string",
        "enum": [
          "none",
          "full"
        ]
      },
      "mute": {
        "type": "boolean",
        "description": "deprecated, moved to properties"
      },
      "opacity": {
        "type": "number"
      },
      "mediaFeatures": {
        "type": "array",
        "items": {
          "type": "string",
          "enum": [
            "alpha"
          ]
        }
      },
      "mask": {
        "anyOf": [
          {
            "type": "null"
          },
          {
            "type": "object",
            "description": "CSS mask using an image",
            "properties": {
              "x": {
                "type": "number",
                "minimum": 0,
                "maximum": 100
              },
              "y": {
                "type": "number",
                "minimum": 0,
                "maximum": 100
              },
              "width": {
                "type": "number",
                "minimum": 0,
                "maximum": 100
              },
              "height": {
                "type": "number",
                "minimum": 0,
                "maximum": 100
              },
              "svgId": {
                "type": "string"
              },
              "flip": {
                "type": "string",
                "enum": [
                  "x",
                  "y",
                  "xy",
                  "none"
                ],
                "description": "Defines whether the mask is flipped on the v or h axis"
              },
              "rotate": {
                "type": "number",
                "minimum": 0,
                "maximum": 360
              },
              "mode": {
                "type": "string",
                "enum": [
                  "alpha",
                  "luminance"
                ],
                "default": "alpha"
              }
            },
            "additionalProperties": false
          }
        ]
      }
    }
  },
  "WixVideoData": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "title": {
        "type": "string",
        "maxLength": 100
      },
      "alt": {
        "type": "string",
        "maxLength": 1000
      },
      "videoId": {
        "type": "string"
      },
      "generatedPosters": {
        "type": "array",
        "items": {
          "type": "string"
        }
      },
      "qualities": {
        "type": "array",
        "items": {
          "type": "object",
          "properties": {
            "quality": {
              "type": "string"
            },
            "width": {
              "type": "number"
            },
            "height": {
              "type": "number"
            },
            "formats": {
              "type": "array",
              "items": {
                "type": "string"
              },
              "description": "Deprecated, replaced by 'format' and 'url' since we have a unique url for each quality"
            },
            "format": {
              "type": "string",
              "enum": [
                "mp4",
                "webm"
              ]
            },
            "url": {
              "type": "string"
            }
          },
          "additionalProperties": false
        }
      },
      "adaptiveVideo": {
        "type": [
          "array",
          "null"
        ],
        "items": {
          "type": "object",
          "properties": {
            "format": {
              "type": "string",
              "enum": [
                "hls",
                "dash"
              ]
            },
            "url": {
              "type": "string"
            }
          },
          "additionalProperties": false
        }
      },
      "posterImageRef": {
        "type": [
          "null",
          "string"
        ]
      },
      "duration": {
        "type": "number"
      },
      "fps": {
        "type": "string",
        "maxLength": 50
      },
      "hasAudio": {
        "type": "boolean",
        "description": "video has no audio"
      },
      "artist": {
        "type": "object",
        "properties": {
          "name": {
            "type": "string"
          },
          "id": {
            "type": "string"
          }
        },
        "additionalProperties": false
      }
    }
  },
  "Document": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "siteName": {
        "type": "string",
        "maxLength": 1000
      },
      "usedFonts": {
        "type": "array",
        "items": {
          "type": "string",
          "maxLength": 1000
        }
      },
      "characterSets": {
        "type": "array",
        "items": {
          "type": "string"
        }
      },
      "renderModifiers": {
        "type": "object",
        "properties": {
          "siteWidth": {
            "type": "number",
            "minimum": 0
          },
          "pageAutoShrink": {
            "type": "boolean"
          }
        },
        "additionalProperties": false
      },
      "name": {
        "type": "string"
      },
      "mainPage": {
        "type": [
          "null",
          "string"
        ]
      },
      "mainPageId": {
        "type": "string"
      },
      "smSettings": {
        "type": [
          "object"
        ],
        "additionalProperties": false,
        "properties": {
          "socialLoginGoogleEnabled": {
            "type": "boolean"
          },
          "socialLoginFacebookEnabled": {
            "type": "boolean"
          },
          "privacyNoteType": {
            "type": "string",
            "enum": [
              "CHECKBOX",
              "NOTE"
            ]
          },
          "joinCommunityCheckedByDefault": {
            "type": "boolean"
          },
          "customSignUpPageId": {
            "type": [
              "string",
              "null"
            ]
          },
          "customSignInPageId": {
            "type": [
              "string",
              "null"
            ]
          },
          "customNoPermissionsPageId": {
            "type": [
              "string"
            ]
          },
          "termsOfUse": {
            "type": "object",
            "properties": {
              "enabled": {
                "type": "boolean"
              },
              "link": {
                "pattern": "^$|^#",
                "type": [
                  "null",
                  "string"
                ]
              }
            },
            "additionalProperties": false
          },
          "privacyPolicy": {
            "type": "object",
            "properties": {
              "enabled": {
                "type": "boolean"
              },
              "link": {
                "pattern": "^$|^#",
                "type": [
                  "null",
                  "string"
                ]
              }
            },
            "additionalProperties": false
          },
          "codeOfConduct": {
            "type": "object",
            "properties": {
              "enabled": {
                "type": "boolean"
              },
              "link": {
                "pattern": "^$|^#",
                "type": [
                  "null",
                  "string"
                ]
              }
            },
            "additionalProperties": false
          },
          "smFirstDialogLogin": {
            "type": [
              "boolean",
              "null"
            ]
          }
        }
      },
      "styleSettings": {
        "type": "object",
        "properties": {
          "stylesPerPage": {
            "type": "string",
            "maxLength": 20
          }
        },
        "additionalProperties": false
      },
      "accessibilitySettings": {
        "type": "object",
        "properties": {
          "visualFocusDisabled": {
            "type": [
              "boolean",
              "null"
            ]
          },
          "skipToContent": {
            "default": true,
            "type": [
              "boolean",
              "null"
            ]
          },
          "isRtlSupportEnabled": {
            "default": false,
            "type": [
              "boolean",
              "null"
            ]
          },
          "currentSiteDirection": {
            "type": "string",
            "enum": [
              "ltr",
              "rtl"
            ]
          }
        },
        "additionalProperties": false
      },
      "mobileSettings": {
        "type": "object",
        "properties": {
          "animationsEnabled": {
            "type": [
              "boolean",
              "null"
            ]
          }
        },
        "additionalProperties": false
      },
      "layoutSettings": {
        "type": "object",
        "properties": {
          "useDesktopSectionsLayout": {
            "type": [
              "boolean",
              "null"
            ]
          },
          "isFluid": {
            "type": [
              "boolean"
            ]
          },
          "headerToPagesGap": {
            "type": [
              "number",
              "null"
            ],
            "multipleOf": 1
          },
          "pagesToFooterGap": {
            "type": [
              "number",
              "null"
            ],
            "multipleOf": 1
          },
          "mechanism": {
            "type": [
              "string"
            ],
            "enum": [
              "mesh",
              "anchors"
            ]
          },
          "soapCompsAroundPagesContainer": {
            "type": [
              "boolean",
              "null"
            ]
          }
        },
        "additionalProperties": false
      },
      "appStudioData": {
        "type": [
          "null",
          "string"
        ]
      },
      "ignoreBottomBottomAnchors": {
        "type": [
          "boolean"
        ]
      },
      "anchorLockThreshold": {
        "type": [
          "number",
          "null"
        ],
        "multipleOf": 1
      },
      "supportMobile": {
        "type": "boolean"
      },
      "autoDomReorder": {
        "type": "boolean"
      },
      "appsInstallState": {
        "type": [
          "null",
          "string"
        ]
      },
      "usesNewAnimations": {
        "type": "boolean"
      }
    }
  },
  "AccessibilitySettings": {
    "type": "object",
    "properties": {
      "visualFocusDisabled": {
        "type": [
          "boolean",
          "null"
        ]
      },
      "skipToContent": {
        "default": true,
        "type": [
          "boolean",
          "null"
        ]
      },
      "isRtlSupportEnabled": {
        "default": false,
        "type": [
          "boolean",
          "null"
        ]
      },
      "currentSiteDirection": {
        "type": "string",
        "enum": [
          "ltr",
          "rtl"
        ]
      }
    },
    "additionalProperties": false
  },
  "MobileSettings": {
    "type": "object",
    "properties": {
      "animationsEnabled": {
        "type": [
          "boolean",
          "null"
        ]
      }
    },
    "additionalProperties": false
  },
  "LayoutSettings": {
    "type": "object",
    "properties": {
      "useDesktopSectionsLayout": {
        "type": [
          "boolean",
          "null"
        ]
      },
      "isFluid": {
        "type": [
          "boolean"
        ]
      },
      "headerToPagesGap": {
        "type": [
          "number",
          "null"
        ],
        "multipleOf": 1
      },
      "pagesToFooterGap": {
        "type": [
          "number",
          "null"
        ],
        "multipleOf": 1
      },
      "mechanism": {
        "type": [
          "string"
        ],
        "enum": [
          "mesh",
          "anchors"
        ]
      },
      "soapCompsAroundPagesContainer": {
        "type": [
          "boolean",
          "null"
        ]
      }
    },
    "additionalProperties": false
  },
  "StyleSettings": {
    "type": "object",
    "properties": {
      "stylesPerPage": {
        "type": "string",
        "maxLength": 20
      }
    },
    "additionalProperties": false
  },
  "SiteMembersData": {
    "type": "object",
    "properties": {
      "socialLoginGoogleEnabled": {
        "type": "boolean"
      },
      "socialLoginFacebookEnabled": {
        "type": "boolean"
      },
      "privacyNoteType": {
        "type": "string",
        "enum": [
          "CHECKBOX",
          "NOTE"
        ]
      },
      "joinCommunityCheckedByDefault": {
        "type": "boolean"
      },
      "customSignUpPageId": {
        "type": [
          "string",
          "null"
        ]
      },
      "customSignInPageId": {
        "type": [
          "string",
          "null"
        ]
      },
      "customNoPermissionsPageId": {
        "type": [
          "string"
        ]
      },
      "termsOfUse": {
        "type": "object",
        "properties": {
          "enabled": {
            "type": "boolean"
          },
          "link": {
            "pattern": "^$|^#",
            "type": [
              "null",
              "string"
            ]
          }
        },
        "additionalProperties": false
      },
      "privacyPolicy": {
        "type": "object",
        "properties": {
          "enabled": {
            "type": "boolean"
          },
          "link": {
            "pattern": "^$|^#",
            "type": [
              "null",
              "string"
            ]
          }
        },
        "additionalProperties": false
      },
      "codeOfConduct": {
        "type": "object",
        "properties": {
          "enabled": {
            "type": "boolean"
          },
          "link": {
            "pattern": "^$|^#",
            "type": [
              "null",
              "string"
            ]
          }
        },
        "additionalProperties": false
      },
      "smFirstDialogLogin": {
        "type": [
          "boolean",
          "null"
        ]
      }
    },
    "additionalProperties": false
  },
  "AppStudioData": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "name": {
        "type": "string"
      },
      "description": {
        "type": "string"
      },
      "widgets": {
        "default": [],
        "type": [
          "array",
          "null"
        ],
        "items": [
          {
            "type": [
              "null",
              "string"
            ]
          }
        ]
      },
      "codePackages": {
        "maxItems": 1,
        "type": [
          "array",
          "null"
        ],
        "items": [
          {
            "type": [
              "null",
              "string"
            ]
          }
        ]
      },
      "panels": {
        "default": [],
        "type": [
          "array",
          "null"
        ],
        "items": [
          {
            "type": [
              "null",
              "string"
            ]
          }
        ]
      },
      "dependencies": {
        "type": [
          "null",
          "array"
        ],
        "items": {
          "type": "object",
          "additionalProperties": false,
          "required": [
            "appDefId"
          ],
          "properties": {
            "appDefId": {
              "type": "string",
              "maxLength": 100
            },
            "dependencyData": {
              "type": "array",
              "items": {
                "type": "string",
                "enum": [
                  "PROVISION_ONLY_INSTALLATION",
                  "NOTIFY_USER_ON_DEPENDENCY",
                  "IS_BUNDLE"
                ]
              }
            }
          }
        }
      },
      "dashboards": {
        "default": [],
        "type": [
          "array",
          "null"
        ],
        "items": [
          {
            "type": [
              "null",
              "string"
            ]
          }
        ]
      },
      "customDefinitions": {
        "default": [],
        "type": [
          "array",
          "null"
        ],
        "items": [
          {
            "type": [
              "null",
              "string"
            ]
          }
        ]
      },
      "ssrCache": {
        "type": "boolean"
      }
    }
  },
  "CodePackagesDescriptor": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "displayName": {
        "type": "string",
        "maxLength": 30,
        "minLength": 1
      },
      "name": {
        "type": "string",
        "maxLength": 100,
        "minLength": 3
      },
      "description": {
        "type": "string",
        "maxLength": 100
      }
    }
  },
  "WidgetPropertyDefinition": {
    "additionalProperties": true
  },
  "CustomDefinitionDescriptor": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "structure": {
        "type": "object",
        "additionalProperties": {
          "type": "object",
          "additionalProperties": false,
          "required": [
            "$id",
            "title",
            "description",
            "default",
            "propertiesOrder"
          ],
          "properties": {
            "$id": {
              "type": "string"
            },
            "type": {
              "type": "string",
              "default": "object"
            },
            "title": {
              "type": "string"
            },
            "description": {
              "type": "string"
            },
            "properties": {
              "type": "object",
              "additionalProperties": {
                "additionalProperties": true
              }
            },
            "default": {
              "type": "object",
              "default": {}
            },
            "propertiesOrder": {
              "type": "array",
              "items": {
                "type": "string"
              },
              "default": []
            }
          }
        }
      }
    }
  },
  "WidgetDescriptor": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "name": {
        "type": "string"
      },
      "devCenterWidgetId": {
        "type": [
          "string",
          "null"
        ]
      },
      "devCenterEditorReactComponentId": {
        "type": [
          "string",
          "null"
        ]
      },
      "kind": {
        "type": [
          "string",
          "null"
        ],
        "enum": [
          "container",
          "section"
        ]
      },
      "panels": {
        "default": [],
        "type": [
          "array"
        ],
        "items": [
          {
            "type": [
              "null",
              "string"
            ]
          }
        ]
      },
      "defaultSize": {
        "type": [
          "object",
          "null"
        ],
        "minProperties": 1,
        "properties": {
          "width": {
            "type": "number"
          },
          "height": {
            "type": "number"
          }
        },
        "additionalProperties": false
      },
      "rootCompId": {
        "type": [
          "null",
          "string"
        ]
      },
      "variations": {
        "default": [],
        "type": [
          "array",
          "null"
        ],
        "items": [
          {
            "type": [
              "null",
              "string"
            ]
          }
        ]
      },
      "presets": {
        "type": [
          "array",
          "null"
        ],
        "items": [
          {
            "type": [
              "null",
              "string"
            ]
          }
        ]
      },
      "plugin": {
        "type": "object",
        "properties": {
          "placements": {
            "type": "array",
            "items": {
              "type": "object",
              "properties": {
                "appDefinitionId": {
                  "type": "string",
                  "maxLength": 100
                },
                "widgetId": {
                  "type": "string",
                  "maxLength": 100
                },
                "slotId": {
                  "type": "string",
                  "maxLength": 100
                }
              },
              "additionalProperties": false
            }
          }
        },
        "additionalProperties": false
      },
      "containedWidgets": {
        "type": "array",
        "items": {
          "type": [
            "string"
          ]
        },
        "default": []
      },
      "widgetApi": {
        "type": "object",
        "default": {},
        "properties": {
          "functions": {
            "type": "array",
            "default": [],
            "items": {
              "type": "object",
              "required": [
                "name"
              ],
              "properties": {
                "name": {
                  "type": "string"
                },
                "description": {
                  "type": [
                    "string",
                    "null"
                  ]
                },
                "params": {
                  "type": "array",
                  "items": {
                    "type": "object",
                    "properties": {
                      "name": {
                        "type": "string"
                      },
                      "description": {
                        "type": [
                          "string",
                          "null"
                        ]
                      }
                    },
                    "additionalProperties": false
                  }
                },
                "returnsDescription": {
                  "type": [
                    "string",
                    "null"
                  ]
                }
              },
              "additionalProperties": false
            }
          },
          "propertiesSchemas": {
            "type": "array",
            "default": [],
            "items": {
              "type": "object",
              "properties": {
                "structure": {
                  "type": "object",
                  "additionalProperties": {
                    "additionalProperties": true
                  },
                  "default": {}
                }
              },
              "additionalProperties": false
            }
          },
          "events": {
            "type": "array",
            "default": [],
            "items": {
              "type": "object",
              "required": [
                "name"
              ],
              "properties": {
                "name": {
                  "type": "string"
                },
                "description": {
                  "type": "string"
                },
                "args": {
                  "type": "array",
                  "items": {
                    "properties": {
                      "name": {
                        "type": "string"
                      }
                    },
                    "additionalProperties": false
                  }
                }
              },
              "additionalProperties": false
            }
          }
        },
        "additionalProperties": false
      },
      "structureRef": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "rootCompId": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "compType": {
        "type": "string"
      }
    }
  },
  "DashboardDescriptor": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "rootCompId": {
        "type": [
          "null",
          "string"
        ]
      },
      "title": {
        "type": "string",
        "minLength": 1,
        "maxLength": 100
      },
      "routePath": {
        "type": "string",
        "minLength": 1,
        "maxLength": 100
      },
      "hideInSidebar": {
        "type": "boolean"
      },
      "activeSidebarPageId": {
        "type": [
          "string",
          "null"
        ]
      },
      "isRoutePathConnectedToTitle": {
        "type": "boolean",
        "default": true
      }
    }
  },
  "PanelDescriptor": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "name": {
        "type": "string",
        "minLength": 1,
        "maxLength": 100
      },
      "devCenterPanelId": {
        "type": [
          "string",
          "null"
        ]
      },
      "title": {
        "type": "string",
        "minLength": 1,
        "maxLength": 100
      },
      "kind": {
        "type": "string",
        "enum": [
          "settings"
        ]
      },
      "helpId": {
        "type": "string",
        "maxLength": 100
      },
      "pageUrl": {
        "type": "string",
        "minLength": 1,
        "maxLength": 2048
      },
      "height": {
        "type": "number",
        "minimum": 0,
        "default": 0
      },
      "defaultSize": {
        "type": "object",
        "minProperties": 1,
        "properties": {
          "width": {
            "type": "number"
          },
          "height": {
            "type": "number"
          }
        },
        "additionalProperties": false
      },
      "rootCompId": {
        "type": [
          "null",
          "string"
        ]
      }
    }
  },
  "VariationDescriptor": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "name": {
        "type": "string"
      },
      "rootCompId": {
        "type": [
          "null",
          "string"
        ]
      }
    }
  },
  "PresetDescriptor": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "variableConnections": {
        "type": "array",
        "items": {
          "anyOf": [
            {
              "type": "object",
              "properties": {
                "path": {
                  "type": "string",
                  "pattern": "^(?:defaultSize\\/width|defaultSize\\/height)$"
                },
                "variableId": {
                  "type": [
                    "string"
                  ]
                }
              },
              "additionalProperties": false
            }
          ]
        }
      },
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "presetId": {
        "type": "string",
        "maxLength": 100
      },
      "name": {
        "type": "string",
        "maxLength": 100
      },
      "defaultSize": {
        "type": "object",
        "minProperties": 1,
        "properties": {
          "width": {
            "type": "object",
            "required": [
              "value",
              "type"
            ],
            "properties": {
              "value": {
                "type": "number"
              },
              "type": {
                "enum": [
                  "px",
                  "em",
                  "rem",
                  "fr",
                  "percentage",
                  "vh",
                  "vw",
                  "spx",
                  "siteWidthPercentage"
                ]
              }
            },
            "additionalProperties": false
          },
          "height": {
            "type": "object",
            "required": [
              "value",
              "type"
            ],
            "properties": {
              "value": {
                "type": "number"
              },
              "type": {
                "enum": [
                  "px",
                  "em",
                  "rem",
                  "fr",
                  "percentage",
                  "vh",
                  "vw",
                  "spx",
                  "siteWidthPercentage"
                ]
              }
            },
            "additionalProperties": false
          }
        },
        "additionalProperties": false
      }
    }
  },
  "FlatTheme": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "THEME_DIRECTORY": {
        "default": "base",
        "type": "string",
        "pattern": "^[\\/\\-|0-9|a-z|A-Z]*$"
      },
      "BG_DIRECTORY": {
        "default": "base",
        "type": "string",
        "pattern": "^[\\/\\-|0-9|a-z|A-Z]*$"
      },
      "CONTACT_DIRECTORY": {
        "default": "base",
        "type": "string",
        "pattern": "^[\\/\\-|0-9|a-z|A-Z]*$"
      },
      "NETWORKS_DIRECTORY": {
        "default": "base",
        "type": "string",
        "pattern": "^[\\/\\-|0-9|a-z|A-Z]*$"
      },
      "EXTERNAL_LINKS_DIRECTORY": {
        "default": "base",
        "type": "string",
        "pattern": "^[\\/\\-|0-9|a-z|A-Z]*$"
      },
      "PAGES_DIRECTORY": {
        "default": "base",
        "type": "string",
        "pattern": "^[\\/\\-|0-9|a-z|A-Z]*$"
      },
      "WEB_THEME_DIRECTORY": {
        "default": "base",
        "type": "string",
        "pattern": "^[\\/\\-|0-9|a-z|A-Z]*$"
      },
      "BASE_THEME_DIRECTORY": {
        "default": "base",
        "type": "string",
        "pattern": "^[\\/\\-|0-9|a-z|A-Z]*$"
      },
      "font": {
        "type": "string",
        "format": "font-family",
        "default": "Arial,sans-serif"
      },
      "bgId": {
        "type": "string",
        "default": "BG_USES_THEME_IMAGE"
      },
      "bgSize": {
        "type": "string",
        "default": ","
      },
      "bgType": {
        "type": "string",
        "default": "BG_USES_THEME_IMAGE"
      },
      "siteBg": {
        "type": "string",
        "default": "none 0 0 center center auto repeat no-repeat fixed {color_2}"
      },
      "mobileBg": {
        "type": "string",
        "default": "none 0 0 center center auto repeat no-repeat fixed {color_2}"
      },
      "siteBgColor": {
        "default": "0,0,0,1",
        "type": "string",
        "pattern": "^$|^((((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5])(,0*(0?\\.\\d+|0|1))?)|(color_([0-9]{1,2}|100))|(\\{color_([0-9]{1,2}|100)\\})|(\\[color_([0-9]{1,2}|100)\\])|(#(([0-9|a-f|A-F]){3}){1,2}))$"
      },
      "headerTextColor": {
        "default": "255,255,255,1",
        "type": "string",
        "pattern": "^$|^((((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5])(,0*(0?\\.\\d+|0|1))?)|(color_([0-9]{1,2}|100))|(\\{color_([0-9]{1,2}|100)\\})|(\\[color_([0-9]{1,2}|100)\\])|(#(([0-9|a-f|A-F]){3}){1,2}))$"
      },
      "headerBgColor": {
        "default": "0,0,0,0",
        "type": "string",
        "pattern": "^$|^((((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5])(,0*(0?\\.\\d+|0|1))?)|(color_([0-9]{1,2}|100))|(\\{color_([0-9]{1,2}|100)\\})|(\\[color_([0-9]{1,2}|100)\\])|(#(([0-9|a-f|A-F]){3}){1,2}))$"
      },
      "textColor": {
        "default": "255,255,255,1",
        "type": "string",
        "pattern": "^$|^((((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5])(,0*(0?\\.\\d+|0|1))?)|(color_([0-9]{1,2}|100))|(\\{color_([0-9]{1,2}|100)\\})|(\\[color_([0-9]{1,2}|100)\\])|(#(([0-9|a-f|A-F]){3}){1,2}))$"
      },
      "areaBgColor": {
        "default": "130,81,13,1",
        "type": "string",
        "pattern": "^$|^((((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5])(,0*(0?\\.\\d+|0|1))?)|(color_([0-9]{1,2}|100))|(\\{color_([0-9]{1,2}|100)\\})|(\\[color_([0-9]{1,2}|100)\\])|(#(([0-9|a-f|A-F]){3}){1,2}))$"
      },
      "iconBgColor": {
        "default": "255,255,255,1",
        "type": "string",
        "pattern": "^$|^((((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5])(,0*(0?\\.\\d+|0|1))?)|(color_([0-9]{1,2}|100))|(\\{color_([0-9]{1,2}|100)\\})|(\\[color_([0-9]{1,2}|100)\\])|(#(([0-9|a-f|A-F]){3}){1,2}))$"
      },
      "borderColor": {
        "default": "255,255,255,1",
        "type": "string",
        "pattern": "^$|^((((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5])(,0*(0?\\.\\d+|0|1))?)|(color_([0-9]{1,2}|100))|(\\{color_([0-9]{1,2}|100)\\})|(\\[color_([0-9]{1,2}|100)\\])|(#(([0-9|a-f|A-F]){3}){1,2}))$"
      },
      "fontHeader": {
        "default": "normal normal bold 2.4em/1.0em [font] {headerTextColor}",
        "type": [
          "string"
        ]
      },
      "fontTitle": {
        "default": "italic normal bold 2.0em/2.0em [font] {siteBgColor}",
        "type": [
          "string"
        ]
      },
      "fontSubTitle": {
        "default": "normal normal bold 1.2em/1.4em [font] {siteBgColor}",
        "type": [
          "string"
        ]
      },
      "fontButton": {
        "default": "normal normal bold 1.4em/2.2em [font] {areaBgColor}",
        "type": [
          "string"
        ]
      },
      "fontText": {
        "default": "normal normal normal 1.1em/1.1em [font] {siteBgColor}",
        "type": [
          "string"
        ]
      },
      "fontSmallText": {
        "default": "normal normal normal 0.5em/0.7em [font] {siteBgColor}",
        "type": [
          "string"
        ]
      },
      "borderContainer": {
        "default": "0.15em solid [borderColor]",
        "type": "string",
        "pattern": "^$|^(0|([0-9]*([.][0-9]+){0,1}(px|em)[\\s]*){1,4})([Ss][Oo][Ll][Ii][Dd]|[Dd][Aa][Ss][Hh][Ee][Dd]|[Dd][Oo][Tt][Tt][Ee][Dd]|[Dd][Oo][Uu][Bb][Ll][Ee]|[Gg][Rr][Oo][Oo][Vv][Ee]|[Ii][Nn][Ss][Ee][Tt]|[Nn][Oo][Nn][Ee]|[Oo][Uu][Tt][Ss][Ee][Tt]|[Rr][Ii][Dd][Gg][Ee]){0,1}[\\s]*([{\\[]color_([0-9]{1,2}|100)[}\\]]|(#(([0-9|a-f]){3}){1,2}){0,1})|\\[borderColor\\]?$"
      },
      "borderThumb": {
        "default": "0.15em solid [borderColor]",
        "type": "string",
        "pattern": "^$|^(0|([0-9]*([.][0-9]+){0,1}(px|em)[\\s]*){1,4})([Ss][Oo][Ll][Ii][Dd]|[Dd][Aa][Ss][Hh][Ee][Dd]|[Dd][Oo][Tt][Tt][Ee][Dd]|[Dd][Oo][Uu][Bb][Ll][Ee]|[Gg][Rr][Oo][Oo][Vv][Ee]|[Ii][Nn][Ss][Ee][Tt]|[Nn][Oo][Nn][Ee]|[Oo][Uu][Tt][Ss][Ee][Tt]|[Rr][Ii][Dd][Gg][Ee]){0,1}[\\s]*([{\\[]color_([0-9]{1,2}|100)[}\\]]|(#(([0-9|a-f]){3}){1,2}){0,1})|\\[borderColor\\]?$"
      },
      "borderButton": {
        "default": "0.15em solid [borderColor]",
        "type": "string",
        "pattern": "^$|^(0|([0-9]*([.][0-9]+){0,1}(px|em)[\\s]*){1,4})([Ss][Oo][Ll][Ii][Dd]|[Dd][Aa][Ss][Hh][Ee][Dd]|[Dd][Oo][Tt][Tt][Ee][Dd]|[Dd][Oo][Uu][Bb][Ll][Ee]|[Gg][Rr][Oo][Oo][Vv][Ee]|[Ii][Nn][Ss][Ee][Tt]|[Nn][Oo][Nn][Ee]|[Oo][Uu][Tt][Ss][Ee][Tt]|[Rr][Ii][Dd][Gg][Ee]){0,1}[\\s]*([{\\[]color_([0-9]{1,2}|100)[}\\]]|(#(([0-9|a-f]){3}){1,2}){0,1})|\\[borderColor\\]?$"
      },
      "borderIcon": {
        "default": "0.15em solid [borderColor]",
        "type": "string",
        "pattern": "^$|^(0|([0-9]*([.][0-9]+){0,1}(px|em)[\\s]*){1,4})([Ss][Oo][Ll][Ii][Dd]|[Dd][Aa][Ss][Hh][Ee][Dd]|[Dd][Oo][Tt][Tt][Ee][Dd]|[Dd][Oo][Uu][Bb][Ll][Ee]|[Gg][Rr][Oo][Oo][Vv][Ee]|[Ii][Nn][Ss][Ee][Tt]|[Nn][Oo][Nn][Ee]|[Oo][Uu][Tt][Ss][Ee][Tt]|[Rr][Ii][Dd][Gg][Ee]){0,1}[\\s]*([{\\[]color_([0-9]{1,2}|100)[}\\]]|(#(([0-9|a-f]){3}){1,2}){0,1})|\\[borderColor\\]?$"
      },
      "radiusContainer": {
        "default": "0.6em 0.6em 0.6em 0.6em",
        "type": "string",
        "pattern": "^$|^\\d*(.\\d+)?$|^(\\d+(.\\d+)?(em|px)|0(.0+)?)( +(\\d+(.\\d+)?(em|px)|0(.0+)?)){0,3}$"
      },
      "radiusThumb": {
        "default": "0.6em 0.6em 0.6em 0.6em",
        "type": "string",
        "pattern": "^$|^\\d*(.\\d+)?$|^(\\d+(.\\d+)?(em|px)|0(.0+)?)( +(\\d+(.\\d+)?(em|px)|0(.0+)?)){0,3}$"
      },
      "radiusButton": {
        "default": "0.6em 0.6em 0.6em 0.6em",
        "type": "string",
        "pattern": "^$|^\\d*(.\\d+)?$|^(\\d+(.\\d+)?(em|px)|0(.0+)?)( +(\\d+(.\\d+)?(em|px)|0(.0+)?)){0,3}$"
      },
      "radiusIcon": {
        "default": "0.6em 0.0em 0.0em 0.6em",
        "type": "string",
        "pattern": "^$|^\\d*(.\\d+)?$|^(\\d+(.\\d+)?(em|px)|0(.0+)?)( +(\\d+(.\\d+)?(em|px)|0(.0+)?)){0,3}$"
      },
      "padding1": {
        "default": "1em 1em 1em 1em",
        "type": "string",
        "pattern": "^$|^\\d*(.\\d+)?$|^(\\d+(.\\d+)?(em|px)|0(.0+)?)( +(\\d+(.\\d+)?(em|px)|0(.0+)?)){0,3}$"
      },
      "padding2": {
        "default": "0.0em 0.5em 0.0em 0.5em",
        "type": "string",
        "pattern": "^$|^\\d*(.\\d+)?$|^(\\d+(.\\d+)?(em|px)|0(.0+)?)( +(\\d+(.\\d+)?(em|px)|0(.0+)?)){0,3}$"
      },
      "padding3": {
        "default": "1.0em 0.0em 1.0em 0.0em",
        "type": "string",
        "pattern": "^$|^\\d*(.\\d+)?$|^(\\d+(.\\d+)?(em|px)|0(.0+)?)( +(\\d+(.\\d+)?(em|px)|0(.0+)?)){0,3}$"
      },
      "iconSize": {
        "default": "3.2",
        "type": "string",
        "pattern": "^\\d+(.\\d+)?(em|px)?$"
      },
      "bulletSize": {
        "default": "1.5",
        "type": "string",
        "pattern": "^\\d+(.\\d+)?(em|px)?$"
      },
      "headerSpacing": {
        "default": "0em",
        "type": "string",
        "pattern": "^\\d+(.\\d+)?(em|px)?$"
      },
      "componentSpacing": {
        "default": "0.45em",
        "type": "string",
        "pattern": "^\\d+(.\\d+)?(em|px)?$"
      },
      "itemSpacing": {
        "default": "0.75em",
        "type": "string",
        "pattern": "^\\d+(.\\d+)?(em|px)?$"
      },
      "thumbSpacing": {
        "default": "0.23em",
        "type": "string",
        "pattern": "^\\d+(.\\d+)?(em|px)?$"
      },
      "iconSpacing": {
        "default": "0.75em",
        "type": "string",
        "pattern": "^\\d+(.\\d+)?(em|px)?$"
      }
    }
  },
  "Image": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "link": {
        "pattern": "^$|^#",
        "type": [
          "null",
          "string"
        ]
      },
      "title": {
        "type": "string",
        "default": "",
        "maxLength": 100,
        "description": "Title or caption for the image."
      },
      "name": {
        "type": "string",
        "maxLength": 100,
        "description": "Name identifier for the image."
      },
      "uri": {
        "type": "string",
        "pattern": "^[\\w:~\\-_+%.\\/,\\?=\\()]+$",
        "default": "3963cf22f5e14a25a77ebe37298a8d3b.png",
        "description": "Represents the URI or path to the image."
      },
      "description": {
        "type": "string",
        "maxLength": 1200,
        "description": "Textual description or details about the image."
      },
      "height": {
        "type": "number",
        "default": 200,
        "description": "Height dimension of the image."
      },
      "width": {
        "type": "number",
        "default": 200,
        "description": "Width dimension of the image."
      },
      "borderSize": {
        "type": "string",
        "description": "Size of the border around the image."
      },
      "alt": {
        "type": "string",
        "default": "",
        "description": "Alternative text for the image (for accessibility purposes)."
      },
      "decorative": {
        "type": "boolean"
      },
      "hasAnimation": {
        "type": "boolean",
        "description": "Indicates whether the image has animation valid for images in webP format"
      },
      "originalImageDataRef": {
        "description": "Original Image before edit",
        "type": [
          "null",
          "string"
        ]
      },
      "opacity": {
        "type": "number",
        "description": "Opacity level of the image."
      },
      "crop": {
        "oneOf": [
          {
            "type": "null"
          },
          {
            "type": "object",
            "minProperties": 4,
            "properties": {
              "x": {
                "type": "number",
                "minimum": 0
              },
              "y": {
                "type": "number",
                "minimum": 0
              },
              "width": {
                "type": "number",
                "minimum": 0
              },
              "height": {
                "type": "number",
                "minimum": 0
              },
              "svgId": {
                "type": "string",
                "description": "Defines an svg uri for a mask inside the crop boundaries"
              },
              "flip": {
                "type": "string",
                "enum": [
                  "x",
                  "y",
                  "xy",
                  "none"
                ],
                "description": "Defines whether the mask is flipped on the v or h axis"
              },
              "rotate": {
                "type": "number",
                "minimum": 0,
                "maximum": 360,
                "description": "Defines a rotation angle for the mask"
              }
            },
            "additionalProperties": false
          }
        ],
        "description": "Defines cropping boundaries and additional transformations for the image."
      },
      "upscaleMethod": {
        "type": "string",
        "description": "used for upscaling method when building an image url , expected values default|super"
      },
      "focalPoint": {
        "oneOf": [
          {
            "type": "null"
          },
          {
            "type": "object",
            "minProperties": 2,
            "properties": {
              "x": {
                "type": "number",
                "minimum": 0,
                "maximum": 100
              },
              "y": {
                "type": "number",
                "minimum": 0,
                "maximum": 100
              }
            },
            "additionalProperties": false
          }
        ],
        "description": "Specifies the focal point within the image."
      },
      "artist": {
        "type": "object",
        "description": "Information about the artist of the image.",
        "properties": {
          "name": {
            "type": "string"
          },
          "id": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "a11y": {
        "type": [
          "null",
          "string"
        ]
      }
    }
  },
  "ImageA11y": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "label": {
        "type": "string",
        "maxLength": 1000
      }
    }
  },
  "ImageReference": {
    "type": [
      "null",
      "string"
    ]
  },
  "GlobalImageQuality": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "quality": {
        "minimum": 0,
        "maximum": 100,
        "type": "number",
        "multipleOf": 1
      },
      "unsharpMask": {
        "type": "object",
        "minProperties": 3,
        "additionalProperties": false,
        "properties": {
          "radius": {
            "type": "number",
            "minimum": 0,
            "maximum": 500
          },
          "amount": {
            "type": "number",
            "minimum": 0,
            "maximum": 10
          },
          "threshold": {
            "type": "number",
            "minimum": 0,
            "maximum": 255
          }
        }
      }
    }
  },
  "ImageQuality": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "quality": {
        "minimum": 0,
        "maximum": 100,
        "type": "number",
        "multipleOf": 1
      },
      "unsharpMask": {
        "type": "object",
        "minProperties": 3,
        "additionalProperties": false,
        "properties": {
          "radius": {
            "type": "number",
            "minimum": 0,
            "maximum": 500
          },
          "amount": {
            "type": "number",
            "minimum": 0,
            "maximum": 10
          },
          "threshold": {
            "type": "number",
            "minimum": 0,
            "maximum": 255
          }
        }
      }
    }
  },
  "ClassicSectionA11y": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "label": {
        "type": "string",
        "maxLength": 1000
      },
      "tabindex": {
        "type": "number",
        "minimum": -1,
        "maximum": 0
      },
      "live": {
        "type": "string",
        "enum": [
          "polite",
          "assertive"
        ]
      },
      "role": {
        "type": "string",
        "enum": [
          "heading",
          "status",
          "alert"
        ]
      },
      "atomic": {
        "type": "boolean"
      },
      "hidden": {
        "type": "boolean"
      },
      "current": {
        "type": "string",
        "enum": [
          "step",
          "page",
          "true",
          "false"
        ]
      },
      "level": {
        "type": "number"
      }
    }
  },
  "StripColumnsContainerA11y": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "label": {
        "type": "string",
        "maxLength": 1000
      },
      "tabindex": {
        "type": "number",
        "minimum": -1,
        "maximum": 0
      },
      "live": {
        "type": "string",
        "enum": [
          "polite",
          "assertive"
        ]
      },
      "role": {
        "type": "string",
        "enum": [
          "heading",
          "status",
          "alert"
        ]
      },
      "atomic": {
        "type": "boolean"
      },
      "hidden": {
        "type": "boolean"
      },
      "current": {
        "type": "string",
        "enum": [
          "step",
          "page",
          "true",
          "false"
        ]
      },
      "level": {
        "type": "number",
        "default": 0,
        "multipleOf": 1,
        "minimum": -2147483648,
        "maximum": 2147483647
      }
    }
  },
  "StripColumnsContainer": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "a11y": {
        "type": [
          "null",
          "string"
        ]
      },
      "itemsDirection": {
        "type": "string",
        "enum": [
          "rtl",
          "ltr"
        ],
        "default": "ltr"
      },
      "direction": {
        "type": [
          "string"
        ],
        "enum": [
          "ltr",
          "rtl",
          "inherit"
        ],
        "description": "direction"
      }
    }
  },
  "ClassicSection": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "a11y": {
        "type": [
          "null",
          "string"
        ]
      }
    }
  },
  "StripContainer": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "background": {
        "type": [
          "null",
          "string"
        ]
      }
    }
  },
  "ImageList": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "items": {
        "default": [],
        "type": [
          "array",
          "null"
        ],
        "items": [
          {
            "type": [
              "null",
              "string"
            ]
          }
        ]
      },
      "direction": {
        "description": "direction of the component",
        "type": "string",
        "enum": [
          "ltr",
          "rtl",
          "inherit"
        ]
      }
    }
  },
  "Link": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "linkType": {
        "type": "string",
        "enum": [
          "SMS",
          "CALL",
          "SKYPE",
          "MAP",
          "EMAIL",
          "FACEBOOK",
          "FLICKR",
          "BLOGGER",
          "MYSPACE",
          "LINKEDIN",
          "TWITTER",
          "TUMBLR",
          "YOUTUBE",
          "VIMEO",
          "PAGE",
          "FREE_LINK",
          "TEXT",
          "DELICIOUS",
          "WEBSITE",
          "DOCUMENT",
          "ADMIN_LOGIN",
          "LOGIN"
        ],
        "default": "FREE_LINK"
      },
      "href": {
        "type": "string"
      },
      "text": {
        "type": "string",
        "maxLength": 1200
      },
      "target": {
        "type": "string"
      },
      "icon": {
        "type": "string"
      }
    }
  },
  "TextLink": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "linkType": {
        "type": "string",
        "enum": [
          "SMS",
          "CALL",
          "SKYPE",
          "MAP",
          "EMAIL",
          "FACEBOOK",
          "FLICKR",
          "BLOGGER",
          "MYSPACE",
          "LINKEDIN",
          "TWITTER",
          "TUMBLR",
          "YOUTUBE",
          "VIMEO",
          "PAGE",
          "FREE_LINK",
          "TEXT",
          "DELICIOUS",
          "WEBSITE",
          "DOCUMENT",
          "ADMIN_LOGIN",
          "LOGIN"
        ],
        "default": "FREE_LINK"
      },
      "href": {
        "type": "string"
      },
      "text": {
        "type": "string",
        "maxLength": 1200
      },
      "target": {
        "type": "string"
      },
      "icon": {
        "type": "string"
      }
    }
  },
  "AnchorLink": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "anchorName": {
        "type": "string"
      },
      "anchorDataId": {
        "anyOf": [
          {
            "type": [
              "null",
              "string"
            ]
          },
          {
            "enum": [
              "SCROLL_TO_TOP"
            ]
          }
        ]
      },
      "pageId": {
        "type": [
          "null",
          "string"
        ]
      },
      "rel": {
        "type": "array",
        "items": {
          "type": "string",
          "enum": [
            "nofollow",
            "noopener",
            "noreferrer",
            "sponsored"
          ]
        },
        "default": []
      }
    }
  },
  "DocumentLink": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "docId": {
        "type": "string"
      },
      "name": {
        "type": "string"
      },
      "indexable": {
        "type": "boolean"
      }
    }
  },
  "PhoneLink": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "phoneNumber": {
        "type": "string",
        "maxLength": 100
      }
    }
  },
  "WhatsAppLink": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "phoneNumber": {
        "type": "string",
        "maxLength": 100
      }
    }
  },
  "AddressLink": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "address": {
        "type": "string",
        "maxLength": 200
      }
    }
  },
  "EmailLink": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "recipient": {
        "type": "string",
        "description": "Email address of the recipient."
      },
      "subject": {
        "type": "string",
        "description": "Subject of the email."
      },
      "body": {
        "type": "string",
        "description": "Body or content of the email."
      }
    }
  },
  "FormSubmitButtonLink": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      }
    }
  },
  "ExternalLink": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "url": {
        "allOf": [
          {
            "type": "string"
          },
          {
            "not": {
              "type": "string",
              "pattern": ".*script://.*"
            }
          }
        ],
        "description": "URL of the external link."
      },
      "target": {
        "type": "string",
        "enum": [
          "_self",
          "_blank"
        ],
        "default": "_blank",
        "description": "Specifies where to open the linked document."
      },
      "rel": {
        "default": [
          "noreferrer",
          "noopener"
        ],
        "description": "Specifies the relationship between the current document and the linked document.",
        "type": "array",
        "items": {
          "type": "string",
          "enum": [
            "nofollow",
            "noopener",
            "noreferrer",
            "sponsored"
          ]
        }
      }
    }
  },
  "LinkRelAttribute": {
    "type": "array",
    "items": {
      "type": "string",
      "enum": [
        "nofollow",
        "noopener",
        "noreferrer",
        "sponsored"
      ]
    },
    "default": []
  },
  "DynamicPageLink": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "routerId": {
        "type": "string"
      },
      "innerRoute": {
        "type": "string"
      },
      "anchorDataId": {
        "type": [
          "null",
          "string"
        ]
      },
      "isTpaRoute": {
        "type": "boolean"
      },
      "target": {
        "type": "string",
        "enum": [
          "_self",
          "_blank"
        ],
        "default": "_self"
      },
      "rel": {
        "type": "array",
        "items": {
          "type": "string",
          "enum": [
            "nofollow",
            "noopener",
            "noreferrer",
            "sponsored"
          ]
        },
        "default": []
      }
    }
  },
  "TpaPageLink": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "itemTypeIdentifier": {
        "type": "string"
      },
      "itemId": {
        "type": "string"
      },
      "pageId": {
        "type": [
          "null",
          "string"
        ]
      },
      "appDefinitionId": {
        "type": "string"
      },
      "path": {
        "type": "string"
      },
      "target": {
        "type": "string",
        "enum": [
          "_self",
          "_blank"
        ],
        "default": "_self"
      },
      "rel": {
        "type": "array",
        "items": {
          "type": "string",
          "enum": [
            "nofollow",
            "noopener",
            "noreferrer",
            "sponsored"
          ]
        },
        "default": []
      }
    },
    "required": [
      "itemTypeIdentifier",
      "itemId",
      "pageId",
      "appDefinitionId",
      "path"
    ]
  },
  "LoginToWixLink": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "postLoginUrl": {
        "type": "string"
      },
      "postSignupUrl": {
        "type": "string"
      },
      "dialog": {
        "type": "string",
        "enum": [
          "createUser",
          "login",
          "showLogin"
        ],
        "default": "login"
      },
      "sendMail": {
        "type": "boolean",
        "default": true
      },
      "mailTemplate": {
        "type": "string"
      },
      "userColor": {
        "type": "string"
      },
      "loginCompName": {
        "type": "string",
        "default": ""
      }
    }
  },
  "PageLink": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "pageId": {
        "description": "Page ID of the page to link to.",
        "type": [
          "null",
          "string"
        ]
      },
      "target": {
        "type": "string",
        "enum": [
          "_self",
          "_blank"
        ],
        "default": "_self",
        "description": "Specifies where to open the linked document."
      },
      "rel": {
        "description": "Specifies the relationship between the current document and the linked document.",
        "type": "array",
        "items": {
          "type": "string",
          "enum": [
            "nofollow",
            "noopener",
            "noreferrer",
            "sponsored"
          ]
        },
        "default": []
      }
    }
  },
  "MediaItem": {
    "type": "object",
    "properties": {
      "componentType": {
        "type": "string"
      },
      "dateCreated": {
        "type": "string"
      },
      "description": {
        "type": "string"
      },
      "fileName": {
        "type": "string"
      },
      "fileSize": {
        "type": "number"
      },
      "height": {
        "type": "number"
      },
      "width": {
        "type": "number"
      },
      "iconURL": {
        "type": "string"
      },
      "mediaType": {
        "type": "string"
      },
      "mimeType": {
        "type": "string"
      },
      "originalFileName": {
        "type": "string"
      },
      "sourceURL": {
        "type": [
          "null",
          "string"
        ]
      },
      "tags": {
        "type": [
          "null",
          "string"
        ]
      },
      "title": {
        "type": "string"
      },
      "version": {
        "type": [
          "null",
          "string"
        ]
      }
    },
    "additionalProperties": false
  },
  "MediaRichText": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "text": {
        "type": "string",
        "maxLength": 120000
      },
      "stylesMapId": {
        "type": "string"
      },
      "linkList": {
        "type": [
          "array",
          "null"
        ],
        "items": [
          {
            "type": [
              "null",
              "string"
            ]
          }
        ]
      },
      "componentDataList": {
        "type": [
          "array",
          "null"
        ],
        "items": [
          {
            "type": [
              "null",
              "string"
            ]
          }
        ]
      }
    }
  },
  "Page": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "title": {
        "type": "string",
        "minLength": 1,
        "maxLength": 100
      },
      "hideTitle": {
        "type": "boolean"
      },
      "icon": {
        "type": "string"
      },
      "windowTitle": {
        "type": "string",
        "minLength": 1,
        "maxLength": 512
      },
      "descriptionSEO": {
        "type": "string",
        "maxLength": 1024
      },
      "advancedSeoData": {
        "type": "string",
        "maxLength": 10000
      },
      "metaKeywordsSEO": {
        "type": "string",
        "maxLength": 512
      },
      "pageTitleSEO": {
        "type": "string"
      },
      "pageUriSEO": {
        "type": "string"
      },
      "hidePage": {
        "type": "boolean"
      },
      "underConstruction": {
        "type": "boolean"
      },
      "tpaApplicationId": {
        "type": "number"
      },
      "appDefinitionId": {
        "type": "string"
      },
      "managingAppDefId": {
        "type": [
          "string",
          "null"
        ]
      },
      "tpaPageId": {
        "type": "string"
      },
      "parentPageId": {
        "type": [
          "null",
          "string"
        ]
      },
      "pageSecurity": {
        "type": [
          "object",
          "null"
        ],
        "default": {
          "requireLogin": false,
          "passwordDigest": "",
          "dialogLanguage": ""
        },
        "properties": {
          "requireLogin": {
            "type": "boolean"
          },
          "passwordDigest": {
            "type": "string"
          },
          "dialogLanguage": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "indexable": {
        "type": "boolean",
        "default": true
      },
      "mobileHidePage": {
        "type": [
          "boolean",
          "null"
        ]
      },
      "pageBackgrounds": {
        "type": "object",
        "properties": {
          "desktop": {
            "type": "object",
            "properties": {
              "custom": {
                "type": "boolean"
              },
              "mediaSizing": {
                "type": "string",
                "enum": [
                  "document",
                  "viewport"
                ]
              },
              "ref": {
                "type": [
                  "null",
                  "string"
                ]
              },
              "isPreset": {
                "type": "boolean"
              }
            },
            "additionalProperties": false
          },
          "mobile": {
            "type": "object",
            "properties": {
              "custom": {
                "type": "boolean"
              },
              "mediaSizing": {
                "type": "string",
                "enum": [
                  "document",
                  "viewport"
                ],
                "default": "viewport"
              },
              "ref": {
                "type": [
                  "null",
                  "string"
                ]
              },
              "isPreset": {
                "type": "boolean"
              }
            },
            "additionalProperties": false
          }
        },
        "additionalProperties": false
      },
      "isLandingPage": {
        "type": "boolean",
        "default": false
      },
      "isMobileLandingPage": {
        "type": "boolean",
        "default": false
      },
      "isPopup": {
        "type": "boolean",
        "default": false
      },
      "translationData": {
        "type": "object",
        "properties": {
          "uriSEOTranslated": {
            "type": "boolean",
            "default": false
          }
        },
        "additionalProperties": false
      },
      "ogImage": {
        "type": [
          "string",
          "null"
        ]
      },
      "ogImageRef": {
        "type": [
          "null",
          "string"
        ]
      },
      "ignoreBottomBottomAnchors": {
        "type": [
          "boolean",
          "null"
        ]
      },
      "cacheMode": {
        "enum": [
          "auto",
          "manual",
          "disabled"
        ]
      },
      "cacheMaxAgeHours": {
        "type": [
          "number",
          "null"
        ],
        "multipleOf": 1
      }
    }
  },
  "Text": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "text": {
        "type": "string",
        "maxLength": 4000
      }
    }
  },
  "RichText": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "text": {
        "type": "string",
        "maxLength": 120000,
        "default": ""
      },
      "defaultStyle": {
        "type": "string"
      }
    }
  },
  "RichTextImage": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "text": {
        "type": [
          "null",
          "string"
        ]
      },
      "image": {
        "type": [
          "null",
          "string"
        ]
      }
    }
  },
  "BaseInput": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "name": {
        "type": "string",
        "maxLength": 400
      },
      "formGroup": {
        "type": "string",
        "description": "form group that this component belongs to",
        "maxLength": 4000
      }
    }
  },
  "BaseTextInput": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "value": {
        "type": "string",
        "default": "",
        "maxLength": 4000
      },
      "name": {
        "type": "string",
        "maxLength": 400
      },
      "formGroup": {
        "type": "string",
        "description": "form group that this component belongs to",
        "maxLength": 4000
      }
    }
  },
  "TextInputA11y": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "label": {
        "type": "string",
        "maxLength": 1000
      },
      "tabindex": {
        "type": "number",
        "minimum": -1,
        "maximum": 0
      },
      "invalid": {
        "type": "boolean"
      },
      "multiline": {
        "type": "boolean"
      },
      "autocomplete": {
        "type": "boolean"
      },
      "live": {
        "type": "string",
        "enum": [
          "polite",
          "assertive"
        ]
      },
      "atomic": {
        "type": "boolean"
      }
    }
  },
  "TextInput": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "direction": {
        "type": [
          "string"
        ],
        "enum": [
          "ltr",
          "rtl",
          "inherit"
        ],
        "description": "direction"
      },
      "labelDirection": {
        "type": [
          "string"
        ],
        "enum": [
          "ltr",
          "rtl",
          "inherit"
        ],
        "description": "direction"
      },
      "inputDirection": {
        "type": [
          "string"
        ],
        "enum": [
          "ltr",
          "rtl",
          "inherit"
        ],
        "description": "direction"
      },
      "errorDirection": {
        "type": [
          "string"
        ],
        "enum": [
          "ltr",
          "rtl",
          "inherit"
        ],
        "description": "direction"
      },
      "textType": {
        "type": "string",
        "default": "text",
        "enum": [
          "text",
          "email",
          "url",
          "number",
          "tel",
          "password"
        ],
        "description": "input data type"
      },
      "maxLength": {
        "type": [
          "number",
          "null"
        ],
        "description": "maximum number of characters allowed"
      },
      "min": {
        "type": [
          "number",
          "null"
        ],
        "minimum": -2147483648,
        "maximum": 2147483647,
        "description": "minimum allowed value for a numeric type field"
      },
      "max": {
        "type": [
          "number",
          "null"
        ],
        "minimum": -2147483648,
        "maximum": 2147483647,
        "description": "maximum allowed value for a numeric type field"
      },
      "pattern": {
        "type": [
          "string",
          "null"
        ],
        "description": "specifies a regular expression against which the control's value will be validate",
        "maxLength": 500
      },
      "phoneFormat": {
        "type": [
          "string",
          "null"
        ],
        "description": "specifies a phone number format against which the control's value will be validated",
        "pattern": "^#*(((#+-)*)#+$)",
        "maxLength": 100
      },
      "label": {
        "type": [
          "null",
          "string"
        ],
        "default": "",
        "maxLength": 400
      },
      "placeholder": {
        "type": [
          "string",
          "null"
        ],
        "maxLength": 4000,
        "description": "the placeholder option in case nothing is selected"
      },
      "a11y": {
        "type": [
          "null",
          "string"
        ]
      },
      "prefix": {
        "type": [
          "null",
          "string"
        ],
        "maxLength": 10
      },
      "step": {
        "type": "number"
      },
      "autoComplete": {
        "type": [
          "null",
          "string"
        ],
        "maxLength": 400
      },
      "value": {
        "type": "string",
        "default": "",
        "maxLength": 4000
      },
      "name": {
        "type": "string",
        "maxLength": 400
      },
      "formGroup": {
        "type": "string",
        "description": "form group that this component belongs to",
        "maxLength": 4000
      }
    }
  },
  "TextAreaInput": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "direction": {
        "type": [
          "string"
        ],
        "enum": [
          "ltr",
          "rtl",
          "inherit"
        ],
        "description": "direction"
      },
      "labelDirection": {
        "type": [
          "string"
        ],
        "enum": [
          "ltr",
          "rtl",
          "inherit"
        ],
        "description": "direction"
      },
      "inputDirection": {
        "type": [
          "string"
        ],
        "enum": [
          "ltr",
          "rtl",
          "inherit"
        ],
        "description": "direction"
      },
      "errorDirection": {
        "type": [
          "string"
        ],
        "enum": [
          "ltr",
          "rtl",
          "inherit"
        ],
        "description": "direction"
      },
      "maxLength": {
        "type": [
          "number"
        ],
        "description": "maximum number of characters allowed"
      },
      "label": {
        "type": [
          "string"
        ],
        "default": "",
        "maxLength": 400
      },
      "placeholder": {
        "type": [
          "string"
        ],
        "maxLength": 4000,
        "description": "the placeholder option in case nothing is selected"
      },
      "value": {
        "type": "string",
        "default": "",
        "maxLength": 4000
      },
      "name": {
        "type": "string",
        "maxLength": 400
      },
      "formGroup": {
        "type": "string",
        "description": "form group that this component belongs to",
        "maxLength": 4000
      }
    }
  },
  "CheckboxInput": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "checked": {
        "description": "The checked status of the input",
        "type": "boolean",
        "default": false
      },
      "linkLabel": {
        "type": "string",
        "default": "",
        "maxLength": 1000
      },
      "link": {
        "pattern": "^$|^#",
        "type": [
          "null",
          "string"
        ]
      },
      "label": {
        "type": "string",
        "default": "",
        "maxLength": 4000
      },
      "indeterminate": {
        "description": "Used for three state check box",
        "type": "boolean",
        "default": false
      },
      "direction": {
        "description": "direction of the component",
        "type": "string",
        "enum": [
          "ltr",
          "rtl",
          "inherit"
        ]
      },
      "value": {
        "type": "string",
        "default": "",
        "maxLength": 4000
      },
      "name": {
        "type": "string",
        "maxLength": 400
      },
      "formGroup": {
        "type": "string",
        "description": "form group that this component belongs to",
        "maxLength": 4000
      }
    }
  },
  "DateItem": {
    "type": "string",
    "format": "date-time"
  },
  "DateString": {
    "type": "string",
    "format": "date"
  },
  "DateRange": {
    "type": "object",
    "additionalProperties": false,
    "required": [
      "startDate",
      "endDate"
    ],
    "properties": {
      "startDate": {
        "type": "string",
        "format": "date"
      },
      "endDate": {
        "type": "string",
        "format": "date"
      }
    }
  },
  "DateRanges": {
    "type": "array",
    "default": [],
    "items": {
      "type": "object",
      "additionalProperties": false,
      "required": [
        "startDate",
        "endDate"
      ],
      "properties": {
        "startDate": {
          "type": "string",
          "format": "date"
        },
        "endDate": {
          "type": "string",
          "format": "date"
        }
      }
    }
  },
  "DatePicker": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "direction": {
        "type": [
          "string"
        ],
        "enum": [
          "ltr",
          "rtl",
          "inherit"
        ],
        "description": "direction"
      },
      "labelDirection": {
        "type": [
          "string"
        ],
        "enum": [
          "ltr",
          "rtl",
          "inherit"
        ],
        "description": "direction"
      },
      "inputDirection": {
        "type": [
          "string"
        ],
        "enum": [
          "ltr",
          "rtl",
          "inherit"
        ],
        "description": "direction"
      },
      "disabledDates": {
        "type": "array",
        "items": {
          "type": "string",
          "format": "date-time"
        },
        "default": [],
        "description": "array of disabled dates"
      },
      "disabledDaysOfWeek": {
        "type": "array",
        "items": {
          "type": [
            "number"
          ],
          "enum": [
            0,
            1,
            2,
            3,
            4,
            5,
            6
          ]
        },
        "default": [],
        "description": "array of disabled days"
      },
      "minDate": {
        "oneOf": [
          {
            "type": "null"
          },
          {
            "type": "string",
            "format": "date-time"
          }
        ],
        "description": "date input minimum date value"
      },
      "maxDate": {
        "oneOf": [
          {
            "type": "null"
          },
          {
            "type": "string",
            "format": "date-time"
          }
        ],
        "description": "date input maximum date value"
      },
      "allowPastDates": {
        "type": "boolean",
        "default": true,
        "description": "if true all past days are enabled, false otherwise"
      },
      "allowFutureDates": {
        "type": "boolean",
        "default": true,
        "description": "if true all future days are enabled, false otherwise"
      },
      "label": {
        "type": [
          "null",
          "string"
        ],
        "default": "",
        "maxLength": 400
      },
      "placeholder": {
        "type": [
          "string",
          "null"
        ],
        "maxLength": 200,
        "description": "the placeholder option in case nothing is selected"
      },
      "enabledDateRanges": {
        "description": "array of enabled dates. each date in the format YYYY/MM/DD",
        "type": "array",
        "default": [],
        "items": {
          "type": "object",
          "additionalProperties": false,
          "required": [
            "startDate",
            "endDate"
          ],
          "properties": {
            "startDate": {
              "type": "string",
              "format": "date"
            },
            "endDate": {
              "type": "string",
              "format": "date"
            }
          }
        }
      },
      "disabledDateRanges": {
        "description": "array of disabled dates. each date in the format YYYY/MM/DD",
        "type": "array",
        "default": [],
        "items": {
          "type": "object",
          "additionalProperties": false,
          "required": [
            "startDate",
            "endDate"
          ],
          "properties": {
            "startDate": {
              "type": "string",
              "format": "date"
            },
            "endDate": {
              "type": "string",
              "format": "date"
            }
          }
        }
      },
      "name": {
        "type": "string",
        "maxLength": 400
      },
      "formGroup": {
        "type": "string",
        "description": "form group that this component belongs to",
        "maxLength": 4000
      }
    }
  },
  "Theme": {
    "additionalProperties": false,
    "type": [
      "object",
      "null"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "properties": {
        "type": [
          "object",
          "null"
        ],
        "additionalProperties": true,
        "default": {}
      }
    }
  },
  "TwitterFollow": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "accountToFollow": {
        "type": "string",
        "default": "wix"
      }
    }
  },
  "TwitterTweet": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "defaultText": {
        "type": "string"
      },
      "accountToFollow": {
        "type": "string"
      },
      "isHttpsEnabled": {
        "type": "boolean",
        "default": false
      },
      "urlFormat": {
        "type": "string",
        "enum": [
          "hashBang",
          "slash"
        ],
        "default": "slash"
      }
    }
  },
  "MobileMetaData": {
    "type": "object",
    "required": [
      "adaptiveMobileOn"
    ],
    "properties": {
      "adaptiveMobileOn": {
        "type": "boolean",
        "default": true
      }
    },
    "additionalProperties": false
  },
  "Preloader": {
    "type": "object",
    "required": [
      "enabled",
      "uri"
    ],
    "properties": {
      "enabled": {
        "type": "boolean",
        "default": false
      },
      "uri": {
        "type": "string",
        "default": ""
      }
    },
    "additionalProperties": false
  },
  "ContactInfo": {
    "type": "object",
    "required": [
      "companyName",
      "phone",
      "email",
      "address",
      "fax"
    ],
    "properties": {
      "companyName": {
        "type": "string",
        "default": ""
      },
      "phone": {
        "type": "string",
        "default": ""
      },
      "email": {
        "type": "string",
        "default": ""
      },
      "address": {
        "type": "string",
        "default": ""
      },
      "fax": {
        "type": "string",
        "default": ""
      }
    },
    "additionalProperties": false
  },
  "SocialLink": {
    "type": "object",
    "required": [
      "id",
      "url"
    ],
    "properties": {
      "id": {
        "type": "string",
        "enum": [
          "facebook",
          "twitter",
          "pinterest",
          "google_plus",
          "tumblr",
          "blogger",
          "linkedin",
          "youtube",
          "vimeo",
          "flickr"
        ]
      },
      "url": {
        "type": "string",
        "default": ""
      }
    },
    "additionalProperties": false
  },
  "QuickActions": {
    "type": "object",
    "required": [
      "colorScheme",
      "configuration",
      "socialLinks"
    ],
    "properties": {
      "colorScheme": {
        "type": "string",
        "enum": [
          "dark",
          "light"
        ],
        "default": "dark"
      },
      "configuration": {
        "type": "object",
        "default": {
          "addressEnabled": false,
          "emailEnabled": false,
          "navigationMenuEnabled": true,
          "phoneEnabled": false,
          "quickActionsMenuEnabled": false,
          "socialLinksEnabled": false
        },
        "properties": {
          "addressEnabled": {
            "type": "boolean",
            "default": false
          },
          "emailEnabled": {
            "type": "boolean",
            "default": false
          },
          "navigationMenuEnabled": {
            "type": "boolean",
            "default": true
          },
          "phoneEnabled": {
            "type": "boolean",
            "default": false
          },
          "quickActionsMenuEnabled": {
            "type": "boolean",
            "default": false
          },
          "socialLinksEnabled": {
            "type": "boolean",
            "default": false
          }
        },
        "additionalProperties": false
      },
      "socialLinks": {
        "type": "array",
        "items": {
          "type": "object",
          "required": [
            "id",
            "url"
          ],
          "properties": {
            "id": {
              "type": "string",
              "enum": [
                "facebook",
                "twitter",
                "pinterest",
                "google_plus",
                "tumblr",
                "blogger",
                "linkedin",
                "youtube",
                "vimeo",
                "flickr"
              ]
            },
            "url": {
              "type": "string",
              "default": ""
            }
          },
          "additionalProperties": false
        },
        "default": []
      }
    },
    "additionalProperties": false
  },
  "QuickActionBarItem": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "link": {
        "pattern": "^$|^#",
        "type": [
          "null",
          "string"
        ]
      },
      "itemType": {
        "maxLength": 50,
        "type": "string"
      },
      "text": {
        "maxLength": 40,
        "type": "string",
        "default": ""
      },
      "icon": {
        "maxLength": 200,
        "type": "string",
        "default": ""
      }
    },
    "required": [
      "itemType"
    ]
  },
  "SiteSettings": {
    "type": "object",
    "properties": {
      "siteName": {
        "type": "string",
        "default": ""
      },
      "siteTitleSEO": {
        "type": "string",
        "default": ""
      },
      "siteDescriptionSEO": {
        "type": "string",
        "default": ""
      },
      "keywordsSEO": {
        "type": "string",
        "default": ""
      },
      "allowSEFindSite": {
        "type": "boolean",
        "default": false
      },
      "favicon": {
        "type": "string",
        "default": ""
      },
      "thumbnail": {
        "type": "string",
        "default": ""
      },
      "googleAnalyticsID": {
        "type": "string",
        "default": ""
      },
      "fbAdminsUserId": {
        "type": "string",
        "default": ""
      },
      "suppressTrackingCookies": {
        "type": "boolean",
        "default": false
      }
    },
    "additionalProperties": false
  },
  "AdvancedSeoSettingsDialog": {
    "type": "object",
    "properties": {
      "userMetaTags": {
        "type": "string",
        "default": ""
      }
    },
    "additionalProperties": false
  },
  "Anchor": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "name": {
        "type": "string"
      },
      "compId": {
        "type": "string"
      },
      "urlFragment": {
        "type": "string",
        "maxLength": 60
      }
    }
  },
  "BasicMenuItem": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "link": {
        "pattern": "^$|^#",
        "type": [
          "null",
          "string"
        ]
      },
      "items": {
        "default": [],
        "type": [
          "array",
          "null"
        ],
        "items": [
          {
            "type": [
              "null",
              "string"
            ]
          }
        ]
      },
      "slot": {
        "type": "string"
      },
      "label": {
        "type": "string"
      },
      "isVisible": {
        "type": "boolean",
        "default": true
      },
      "isVisibleMobile": {
        "type": "boolean",
        "default": true
      },
      "displayCount": {
        "type": [
          "number",
          "null"
        ],
        "multipleOf": 1
      },
      "iconRef": {
        "type": [
          "null",
          "string"
        ]
      }
    }
  },
  "CustomMenu": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "name": {
        "type": "string"
      },
      "menuType": {
        "type": "string",
        "maxLength": 100
      },
      "syncWithPages": {
        "type": "boolean",
        "default": false
      },
      "appId": {
        "type": "number",
        "default": 0,
        "multipleOf": 1,
        "minimum": -2147483648,
        "maximum": 2147483647
      },
      "appDefinitionId": {
        "type": "string"
      },
      "items": {
        "default": [],
        "type": [
          "array",
          "null"
        ],
        "items": [
          {
            "type": [
              "null",
              "string"
            ]
          }
        ]
      }
    }
  },
  "CustomMenusCollection": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "menus": {
        "type": [
          "array",
          "null"
        ],
        "items": [
          {
            "type": [
              "null",
              "string"
            ]
          }
        ]
      }
    }
  },
  "CustomMenuDataRef": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "menuRef": {
        "default": "#CUSTOM_MAIN_MENU",
        "type": [
          "null",
          "string"
        ]
      },
      "a11y": {
        "type": [
          "null",
          "string"
        ]
      },
      "direction": {
        "description": "direction of the component",
        "type": "string",
        "enum": [
          "ltr",
          "rtl",
          "inherit"
        ]
      },
      "itemDirection": {
        "description": "direction of the 1st (top) level menu items",
        "type": "string",
        "enum": [
          "ltr",
          "rtl",
          "inherit"
        ]
      },
      "submenuDirection": {
        "description": "direction of the 2nd level menu item (submenu)",
        "type": "string",
        "enum": [
          "ltr",
          "rtl",
          "inherit"
        ]
      },
      "submenuSubItemDirection": {
        "description": "direction of the 3rd level menu item (submenuSubItem)",
        "type": "string",
        "enum": [
          "ltr",
          "rtl",
          "inherit"
        ]
      }
    }
  },
  "CustomMenuDataRefA11y": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "label": {
        "type": "string",
        "maxLength": 1000
      }
    }
  },
  "Menu": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "items": {
        "default": [],
        "type": [
          "array",
          "null"
        ],
        "items": [
          {
            "type": [
              "null",
              "string"
            ]
          }
        ]
      }
    }
  },
  "FacebookLikeBox": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "facebookPageId": {
        "type": "string",
        "default": "wix",
        "description": "Facebook page id"
      },
      "showFaces": {
        "type": "boolean",
        "default": true,
        "description": "Show profile photos in the plugin"
      },
      "colorScheme": {
        "type": "string",
        "default": "light",
        "enum": [
          "light",
          "dark"
        ],
        "description": "The color scheme of the plugin. Note that the background is always transparent to match your background color. This setting changes the foreground colors to work well on light or dark backgrounds."
      },
      "showStream": {
        "type": "boolean",
        "default": true,
        "description": "Show the profile stream for the public profile"
      },
      "showBorder": {
        "type": "boolean",
        "default": true,
        "description": "Show a border around the plugin"
      },
      "showHeader": {
        "type": "boolean",
        "default": true,
        "description": "Show the 'Find us on Facebook' bar at top. Only shown when either stream or faces are present"
      }
    }
  },
  "ImageButtonA11y": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "label": {
        "type": "string",
        "maxLength": 1000
      }
    }
  },
  "ImageButton": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "link": {
        "pattern": "^$|^#",
        "type": [
          "null",
          "string"
        ]
      },
      "alt": {
        "type": "string"
      },
      "a11y": {
        "type": [
          "null",
          "string"
        ]
      },
      "defaultImage": {
        "type": [
          "null",
          "string"
        ]
      },
      "hoverImage": {
        "type": [
          "null",
          "string"
        ]
      },
      "activeImage": {
        "type": [
          "null",
          "string"
        ]
      }
    }
  },
  "NumericStepper": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "value": {
        "type": "string",
        "default": "1"
      }
    }
  },
  "PinItPinWidget": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "pinId": {
        "type": "string",
        "default": "http://www.pinterest.com/pin/204421270560540859/"
      }
    }
  },
  "PinterestPinIt": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "uri": {
        "type": "string",
        "default": ""
      },
      "description": {
        "type": "string",
        "default": "Check it out!"
      },
      "isHttpsEnabled": {
        "type": "boolean",
        "default": false
      },
      "urlFormat": {
        "type": "string",
        "enum": [
          "hashBang",
          "slash"
        ],
        "default": "slash"
      }
    }
  },
  "SingleAudioPlayer": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "uri": {
        "type": "string",
        "default": "",
        "description": "MP3 uri"
      },
      "originalFileName": {
        "type": "string",
        "default": "",
        "description": "Original MP3 file name"
      },
      "artist": {
        "type": "string",
        "default": "Unknown Artist",
        "description": "Artist Name"
      },
      "track": {
        "type": "string",
        "default": "Unknown Track",
        "description": "Track Name"
      }
    }
  },
  "SkypeCallButton": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "skypeName": {
        "type": "string"
      },
      "buttonType": {
        "type": "string",
        "enum": [
          "call",
          "chat"
        ],
        "default": "call"
      }
    }
  },
  "SpotifyFollow": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "uri": {
        "type": "string",
        "default": ""
      }
    }
  },
  "SpotifyPlayer": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "uri": {
        "type": "string",
        "default": "",
        "description": "Spotify URI"
      }
    }
  },
  "SubscribeForm": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "toEmailAddress": {
        "type": "string",
        "default": ""
      },
      "bccEmailAddress": {
        "type": "string",
        "default": ""
      },
      "firstNameFieldLabel": {
        "type": "string",
        "default": "First Name"
      },
      "lastNameFieldLabel": {
        "type": "string",
        "default": "Last Name"
      },
      "emailFieldLabel": {
        "type": "string",
        "default": "Email"
      },
      "phoneFieldLabel": {
        "type": "string",
        "default": "Mobile number"
      },
      "subscribeFormTitle": {
        "type": "string",
        "default": "Subscribe for Updates"
      },
      "textDirection": {
        "type": "string",
        "default": "left",
        "enum": [
          "left",
          "right"
        ]
      },
      "submitButtonLabel": {
        "type": "string",
        "default": "Subscribe Now"
      },
      "successMessage": {
        "type": "string",
        "default": "Congrats! You’re subscribed"
      },
      "errorMessage": {
        "type": "string",
        "default": "Forgot your email? Try again."
      },
      "validationErrorMessage": {
        "type": "string",
        "default": "To subscribe please fill in all the required info"
      },
      "onSubmitBehavior": {
        "type": "string",
        "default": "message",
        "enum": [
          "message",
          "link"
        ]
      },
      "link": {
        "pattern": "^$|^#",
        "type": [
          "null",
          "string"
        ]
      }
    }
  },
  "YouTubeSubscribeButton": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "youtubeChannelId": {
        "type": "string",
        "default": "wix",
        "description": "youtube channel id"
      }
    }
  },
  "AudioPlayer": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "uri": {
        "type": "string",
        "default": ""
      },
      "autoPlay": {
        "type": "boolean",
        "default": false
      },
      "loop": {
        "type": "boolean",
        "default": false
      },
      "visible": {
        "type": "boolean",
        "default": true
      },
      "volume": {
        "type": "number",
        "default": 100
      },
      "title": {
        "type": "string",
        "default": ""
      },
      "description": {
        "type": "string",
        "default": ""
      },
      "icon_uri": {
        "type": "string",
        "default": ""
      },
      "originalFileName": {
        "type": "string",
        "default": ""
      },
      "showToolTip": {
        "type": "boolean",
        "default": false
      }
    }
  },
  "Boolean": {
    "type": "object",
    "properties": {
      "value": {
        "type": "boolean"
      }
    },
    "additionalProperties": false
  },
  "CheckBox": {
    "type": "object",
    "properties": {
      "value": {
        "type": "boolean"
      },
      "indeterminate": {
        "type": "boolean",
        "default": false,
        "description": "Used for three state check box"
      }
    },
    "additionalProperties": false
  },
  "Grid": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "dataSource": {
        "type": "object",
        "properties": {
          "type": {
            "type": "string",
            "enum": [
              "static",
              "dynamic"
            ]
          },
          "revision": {
            "type": "number",
            "multipleOf": 1
          }
        },
        "additionalProperties": false
      },
      "rows": {
        "type": "array",
        "items": {
          "type": "object"
        }
      },
      "rowsCount": {
        "type": "number"
      },
      "revision": {
        "type": "number"
      },
      "direction": {
        "type": [
          "string"
        ],
        "enum": [
          "ltr",
          "rtl",
          "inherit"
        ],
        "description": "direction"
      }
    }
  },
  "ContactForm": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "toEmailAddress": {
        "type": "string",
        "default": ""
      },
      "bccEmailAddress": {
        "type": "string",
        "default": ""
      },
      "nameFieldLabel": {
        "type": "string",
        "default": "Name"
      },
      "emailFieldLabel": {
        "type": "string",
        "default": "Email"
      },
      "phoneFieldLabel": {
        "type": "string",
        "default": "Phone"
      },
      "addressFieldLabel": {
        "type": "string",
        "default": "Address"
      },
      "subjectFieldLabel": {
        "type": "string",
        "default": "Subject"
      },
      "messageFieldLabel": {
        "type": "string",
        "default": "Message"
      },
      "submitButtonLabel": {
        "type": "string",
        "default": "Send"
      },
      "successMessage": {
        "type": "string",
        "default": "Your details were sent successfully!"
      },
      "errorMessage": {
        "type": "string",
        "default": "Please provide a valid email"
      },
      "textDirection": {
        "type": "string",
        "default": "left",
        "enum": [
          "left",
          "right"
        ]
      },
      "validationErrorMessage": {
        "type": "string",
        "default": "Please fill in all required fields."
      },
      "onSubmitBehavior": {
        "type": "string",
        "default": "message",
        "enum": [
          "message",
          "link"
        ]
      },
      "link": {
        "pattern": "^$|^#",
        "type": [
          "null",
          "string"
        ]
      }
    }
  },
  "DynamicContactForm": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "toEmailAddress": {
        "type": "string",
        "default": ""
      },
      "bccEmailAddress": {
        "type": "string",
        "default": ""
      },
      "submitButtonLabel": {
        "type": "string",
        "default": "Send"
      },
      "successMessage": {
        "type": "string",
        "default": "Your details were sent successfully!"
      },
      "errorMessage": {
        "type": "string",
        "default": "Please provide a valid email"
      },
      "textDirection": {
        "type": "string",
        "default": "left",
        "enum": [
          "left",
          "right"
        ]
      },
      "validationErrorMessage": {
        "type": "string",
        "default": "Please fill in all required fields."
      },
      "onSubmitBehavior": {
        "type": "string",
        "default": "message",
        "enum": [
          "message",
          "link"
        ]
      },
      "link": {
        "pattern": "^$|^#",
        "type": [
          "null",
          "string"
        ]
      },
      "formName": {
        "type": "string",
        "default": ""
      },
      "dynamicFields": {
        "type": "array",
        "default": [
          {
            "name": "email",
            "inputType": "email",
            "displayLabel": "Email",
            "required": true
          },
          {
            "name": "name",
            "inputType": "text",
            "displayLabel": "Name",
            "required": true
          },
          {
            "name": "subject",
            "inputType": "text",
            "displayLabel": "Subject",
            "required": false
          },
          {
            "name": "message",
            "inputType": "text",
            "displayLabel": "Message",
            "required": false
          }
        ],
        "items": {
          "type": "object",
          "properties": {
            "name": {
              "type": "string",
              "maxLength": 50
            },
            "inputType": {
              "type": "string",
              "maxLength": 50
            },
            "displayLabel": {
              "type": "string",
              "maxLength": 200
            },
            "required": {
              "type": "boolean",
              "default": false
            },
            "displayed": {
              "type": "boolean",
              "default": false
            }
          },
          "additionalProperties": false
        }
      }
    }
  },
  "EbayItemsBySeller": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "sellerId": {
        "type": "string"
      },
      "registrationSite": {
        "type": "string"
      }
    }
  },
  "FacebookShareButton": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "urlChoice": {
        "type": "string",
        "enum": [
          "Current page",
          "Site"
        ],
        "default": "Current page",
        "description": "Share: current/site url"
      },
      "label": {
        "type": "string",
        "default": "Share",
        "description": ""
      },
      "isHttpsEnabled": {
        "type": "boolean",
        "default": false
      },
      "urlFormat": {
        "type": "string",
        "enum": [
          "hashBang",
          "slash"
        ],
        "default": "slash"
      }
    }
  },
  "FlashComponent": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "linkType": {
        "type": "string",
        "enum": [
          "SMS",
          "CALL",
          "SKYPE",
          "MAP",
          "EMAIL",
          "FACEBOOK",
          "FLICKR",
          "BLOGGER",
          "MYSPACE",
          "LINKEDIN",
          "TWITTER",
          "TUMBLR",
          "YOUTUBE",
          "VIMEO",
          "PAGE",
          "FREE_LINK",
          "TEXT",
          "DELICIOUS",
          "WEBSITE",
          "DOCUMENT",
          "ADMIN_LOGIN",
          "LOGIN"
        ],
        "default": "FREE_LINK"
      },
      "href": {
        "type": "string"
      },
      "text": {
        "type": "string"
      },
      "target": {
        "type": "string"
      },
      "icon": {
        "type": "string"
      },
      "title": {
        "type": "string",
        "maxLength": 100
      },
      "uri": {
        "type": "string"
      },
      "description": {
        "type": "string",
        "maxLength": 1000
      },
      "height": {
        "type": "number",
        "default": 0
      },
      "width": {
        "type": "number",
        "default": 0
      },
      "placeHolderImage": {
        "type": [
          "null",
          "string"
        ]
      }
    }
  },
  "FlickrBadgeWidget": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "userId": {
        "type": "string",
        "default": "74009459@N07"
      },
      "userName": {
        "type": "string"
      },
      "tag": {
        "type": "string"
      },
      "imageCount": {
        "type": [
          "string",
          "number"
        ],
        "default": 3
      },
      "whichImages": {
        "type": "string",
        "default": "latest"
      },
      "imageSize": {
        "type": "string",
        "default": "t"
      },
      "layoutOrientation": {
        "type": "string",
        "default": "v"
      }
    }
  },
  "GeoMapLocation": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "address": {
        "type": "string",
        "default": "500 Terry Francois Street, 6th Floor. San Francisco, CA 94158",
        "maxLength": 1000
      },
      "latitude": {
        "type": "number",
        "default": 37.77065
      },
      "longitude": {
        "type": "number",
        "default": -122.387301
      },
      "title": {
        "type": "string",
        "default": "Wix Office",
        "maxLength": 10000
      },
      "description": {
        "type": "string",
        "default": "Wix HQ",
        "maxLength": 350
      },
      "link": {
        "pattern": "^$|^#",
        "type": [
          "null",
          "string"
        ]
      },
      "linkTitle": {
        "type": "string",
        "default": "Visit Wix's Site",
        "maxLength": 140
      },
      "pinIcon": {
        "type": "string",
        "default": "https://static.parastorage.com/services/santa-resources/resources/editor/designPanel/panelTypes/default_pin_icon.png",
        "maxLength": 1000
      },
      "pinColor": {
        "type": "string",
        "default": "#2A3688",
        "maxLength": 20
      }
    }
  },
  "GeoMap": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "language": {
        "type": "string",
        "enum": [
          "af",
          "sq",
          "am",
          "ar",
          "hy",
          "az",
          "eu",
          "be",
          "bn",
          "bs",
          "bg",
          "my",
          "ca",
          "zh",
          "zh-CN",
          "zh-HK",
          "zh-TW",
          "hr",
          "cs",
          "da",
          "nl",
          "en",
          "en-AU",
          "en-GB",
          "et",
          "fa",
          "fi",
          "fil",
          "fr",
          "fr-CA",
          "gl",
          "ka",
          "de",
          "el",
          "gu",
          "iw",
          "hi",
          "hu",
          "is",
          "id",
          "it",
          "ja",
          "kn",
          "kk",
          "km",
          "ko",
          "ky",
          "lo",
          "lv",
          "lt",
          "mk",
          "ms",
          "ml",
          "mr",
          "mn",
          "ne",
          "no",
          "pl",
          "pt",
          "pt-BR",
          "pt-PT",
          "pa",
          "ro",
          "ru",
          "sr",
          "si",
          "sk",
          "sl",
          "es",
          "es-419",
          "sw",
          "sv",
          "ta",
          "te",
          "th",
          "tr",
          "uk",
          "ur",
          "uz",
          "vi",
          "zu"
        ]
      },
      "locations": {
        "minItems": 0,
        "type": [
          "array"
        ],
        "items": [
          {
            "type": [
              "null",
              "string"
            ]
          }
        ]
      },
      "address": {
        "type": "string",
        "default": "500 Terry Francois Street, 6th Floor. San Francisco, CA 94158"
      },
      "latitude": {
        "type": "number",
        "default": 37.77065
      },
      "longitude": {
        "type": "number",
        "default": -122.387301
      },
      "addressInfo": {
        "type": "string",
        "default": "Wix Office"
      },
      "defaultLocation": {
        "type": "number",
        "default": 0
      },
      "mapStyle": {
        "type": "array",
        "items": {
          "type": "object",
          "required": [
            "stylers"
          ],
          "properties": {
            "elementType": {
              "type": "string",
              "enum": [
                "all",
                "geometry",
                "geometry.fill",
                "geometry.stroke",
                "labels",
                "labels.icon",
                "labels.text",
                "labels.text.fill",
                "labels.text.stroke"
              ],
              "description": "Selects the element type to which a styler should be applied. An element type distinguishes between the different representations of a feature."
            },
            "featureType": {
              "type": "string",
              "enum": [
                "administrative",
                "administrative.country",
                "administrative.land_parcel",
                "administrative.locality",
                "administrative.neighborhood",
                "administrative.province",
                "all",
                "landscape",
                "landscape.man_made",
                "landscape.natural",
                "landscape.natural.landcover",
                "landscape.natural.terrain",
                "poi",
                "poi.attraction",
                "poi.business",
                "poi.government",
                "poi.medical",
                "poi.park",
                "poi.place_of_worship",
                "poi.school",
                "poi.sports_complex",
                "road",
                "road.arterial",
                "road.highway",
                "road.highway.controlled_access",
                "road.local",
                "transit",
                "transit.line",
                "transit.station",
                "transit.station.airport",
                "transit.station.bus",
                "transit.station.rail",
                "water"
              ],
              "description": "Selects the feature, or group of features, to which a styler should be applied."
            },
            "stylers": {
              "type": "array",
              "items": {
                "type": "object",
                "maxProperties": 1,
                "additionalProperties": false,
                "description": "The style rules to apply to the selectors. The rules are applied to the map's elements in the order they are listed in this array.",
                "properties": {
                  "color": {
                    "type": "string",
                    "maxLength": 100,
                    "description": "Sets the color of the feature. Valid values: An RGB hex string, i.e. '#ff0000'."
                  },
                  "gamma": {
                    "type": "number",
                    "description": "Modifies the gamma by raising the lightness to the given power.Valid values: Floating point numbers, [0.01, 10], with 1.0 representing no change."
                  },
                  "hue": {
                    "type": "string",
                    "maxLength": 100,
                    "description": "Sets the hue of the feature to match the hue of the color supplied. Note that the saturation and lightness of the feature is conserved, which means that the feature will not match the color supplied exactly. Valid values: An RGB hex string, i.e. '#ff0000'."
                  },
                  "invert_lightness": {
                    "type": "boolean",
                    "description": "A value of true will invert the lightness of the feature while preserving the hue and saturation."
                  },
                  "lightness": {
                    "type": "number",
                    "description": "Shifts lightness of colors by a percentage of the original value if decreasing and a percentage of the remaining value if increasing. Valid values: [-100, 100]."
                  },
                  "saturation": {
                    "type": "number",
                    "description": "Shifts the saturation of colors by a percentage of the original value if decreasing and a percentage of the remaining value if increasing. Valid values: [-100, 100]."
                  },
                  "visibility": {
                    "type": "string",
                    "enum": [
                      "on",
                      "off",
                      "simplified"
                    ],
                    "description": "Sets the visibility of the feature. Valid values: 'on', 'off' or 'simplified'."
                  },
                  "weight": {
                    "type": "number",
                    "description": "Sets the weight of the feature, in pixels. Valid values: Integers greater than or equal to zero."
                  }
                }
              }
            }
          },
          "additionalProperties": false
        }
      }
    }
  },
  "HtmlComponent": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "sourceType": {
        "type": "string",
        "default": ""
      },
      "url": {
        "type": "string",
        "default": ""
      },
      "title": {
        "type": "string"
      },
      "freezeFrame": {
        "type": "boolean",
        "default": false
      },
      "allowFullScreen": {
        "type": "boolean",
        "default": false
      },
      "componentConsentPolicy": {
        "type": "string",
        "default": "essential",
        "enum": [
          "essential",
          "functional",
          "analytics",
          "advertising",
          "dataToThirdParty"
        ]
      }
    }
  },
  "DisqusComments": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "disqusId": {
        "type": "string",
        "default": ""
      }
    }
  },
  "ItunesButton": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "downloadUrl": {
        "type": "string",
        "default": "",
        "description": "Insert band URL"
      }
    }
  },
  "LinkableFlashComponent": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "link": {
        "pattern": "^$|^#",
        "type": [
          "null",
          "string"
        ]
      },
      "title": {
        "type": "string"
      },
      "uri": {
        "type": "string"
      },
      "description": {
        "type": "string"
      },
      "height": {
        "type": "number",
        "default": 0,
        "multipleOf": 1,
        "minimum": -2147483648,
        "maximum": 2147483647
      },
      "width": {
        "type": "number",
        "default": 0,
        "multipleOf": 1,
        "minimum": -2147483648,
        "maximum": 2147483647
      },
      "placeHolderImage": {
        "type": [
          "null",
          "string"
        ]
      }
    }
  },
  "LinkableButton": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "link": {
        "pattern": "^$|^#",
        "type": [
          "null",
          "string"
        ]
      },
      "direction": {
        "description": "direction of the component",
        "type": "string",
        "enum": [
          "ltr",
          "rtl",
          "inherit"
        ]
      },
      "label": {
        "type": "string",
        "default": "MY BUTTON"
      },
      "a11y": {
        "type": [
          "null",
          "string"
        ]
      }
    }
  },
  "LoginButton": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "language": {
        "type": "string",
        "default": ""
      }
    }
  },
  "TinyMenu": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "loginSocialBarRef": {
        "type": [
          "null",
          "string"
        ]
      },
      "menuRef": {
        "type": [
          "null",
          "string"
        ]
      }
    }
  },
  "LoginSocialBar": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "menuItemsRef": {
        "type": [
          "null",
          "string"
        ]
      },
      "iconItemsRef": {
        "type": [
          "null",
          "string"
        ]
      },
      "language": {
        "type": "string",
        "default": "en",
        "maxLength": 10
      },
      "loggedInMember": {
        "type": "string",
        "enum": [
          "avatarOnly",
          "textOnly",
          "avatarAndText",
          "memberInitials"
        ],
        "default": "avatarAndText"
      },
      "loggedOutMember": {
        "type": "string",
        "enum": [
          "avatarOnly",
          "textOnly",
          "avatarAndText"
        ]
      },
      "loggedInAvatarIcon": {
        "type": "string",
        "enum": [
          "profileImage",
          "initials",
          "custom"
        ]
      },
      "loggedOutAvatarIcon": {
        "type": "string",
        "enum": [
          "profileImage",
          "initials",
          "custom"
        ],
        "default": "profileImage"
      },
      "loggedInCustomAvatar": {
        "type": "string",
        "default": "",
        "maxLength": 400
      },
      "loggedOutCustomAvatar": {
        "type": "string",
        "default": "",
        "maxLength": 400
      },
      "loggedOutText": {
        "type": "string",
        "default": "Log In",
        "maxLength": 50
      },
      "showLoggedInText": {
        "type": "boolean",
        "default": true
      },
      "loggedInTextState": {
        "type": "string",
        "enum": [
          "memberName",
          "custom"
        ]
      },
      "loggedInText": {
        "type": "string",
        "default": "Hello",
        "maxLength": 50
      },
      "customLoggedInText": {
        "type": "string",
        "maxLength": 50
      },
      "logOutText": {
        "type": "string",
        "default": "Log Out",
        "maxLength": 50
      }
    }
  },
  "PagesGroupData": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "appId": {
        "type": [
          "number",
          "null"
        ]
      },
      "appDefinitionId": {
        "type": "string"
      },
      "groupName": {
        "type": "string"
      },
      "pages": {
        "type": "array",
        "items": {
          "type": [
            "string"
          ]
        },
        "default": []
      }
    }
  },
  "PagesGroupCollection": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "groups": {
        "default": [],
        "type": [
          "array",
          "null"
        ],
        "items": [
          {
            "type": [
              "null",
              "string"
            ]
          }
        ]
      }
    }
  },
  "PayPalButton": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "merchantID": {
        "type": "string",
        "default": "",
        "description": "some amazing description"
      }
    }
  },
  "PermaLink": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "appType": {
        "enum": [
          "ListsApps",
          "ThirdPartyApps"
        ]
      },
      "dataItemRef": {
        "default": "",
        "type": [
          "null",
          "string"
        ]
      },
      "mutableSeoTitle": {
        "type": "string"
      },
      "correctPermaLinkRef": {
        "type": [
          "null",
          "string"
        ]
      }
    },
    "required": [
      "appType"
    ]
  },
  "PinterestFollow": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "urlChoice": {
        "type": "string",
        "default": "pinterest/",
        "description": ""
      },
      "label": {
        "type": "string",
        "default": "Pinterest",
        "description": ""
      }
    }
  },
  "SelectableList": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "direction": {
        "description": "direction of the component",
        "type": "string",
        "enum": [
          "ltr",
          "rtl",
          "inherit"
        ]
      },
      "labelDirection": {
        "description": "direction of the label",
        "type": "string",
        "enum": [
          "ltr",
          "rtl",
          "inherit"
        ]
      },
      "inputDirection": {
        "description": "direction of the input",
        "type": "string",
        "enum": [
          "ltr",
          "rtl",
          "inherit"
        ]
      },
      "dropdownDirection": {
        "description": "direction of the dropdown",
        "type": "string",
        "enum": [
          "ltr",
          "rtl",
          "inherit"
        ]
      },
      "errorDirection": {
        "description": "direction of the error",
        "type": "string",
        "enum": [
          "ltr",
          "rtl",
          "inherit"
        ]
      },
      "options": {
        "description": "a list of SelectOption data items",
        "default": [],
        "type": [
          "array",
          "null"
        ],
        "items": [
          {
            "type": [
              "null",
              "string"
            ]
          }
        ]
      },
      "label": {
        "type": [
          "null",
          "string"
        ],
        "default": "",
        "maxLength": 400
      },
      "placeholder": {
        "type": "object",
        "properties": {
          "value": {
            "type": "string",
            "default": "-1",
            "description": "the value of the placeholder option",
            "maxLength": 400
          },
          "text": {
            "type": "string",
            "default": "",
            "description": "the text of the placeholder option",
            "maxLength": 400
          }
        },
        "additionalProperties": false
      },
      "value": {
        "type": "string",
        "default": "",
        "maxLength": 4000
      },
      "name": {
        "type": "string",
        "maxLength": 400
      },
      "formGroup": {
        "type": "string",
        "description": "form group that this component belongs to",
        "maxLength": 4000
      }
    }
  },
  "SelectOption": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "value": {
        "type": "string",
        "default": "",
        "maxLength": 400
      },
      "text": {
        "type": "string",
        "default": "",
        "maxLength": 400
      },
      "selectedText": {
        "type": "string",
        "maxLength": 400
      },
      "disabled": {
        "type": "boolean"
      },
      "description": {
        "type": "string",
        "maxLength": 100
      }
    }
  },
  "RadioButton": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "label": {
        "type": "string",
        "default": "",
        "maxLength": 400
      },
      "value": {
        "type": "string",
        "default": "",
        "maxLength": 4000
      },
      "name": {
        "type": "string",
        "maxLength": 400
      },
      "formGroup": {
        "type": "string",
        "description": "form group that this component belongs to",
        "maxLength": 4000
      }
    }
  },
  "RadioGroup": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "direction": {
        "type": [
          "string"
        ],
        "enum": [
          "ltr",
          "rtl",
          "inherit"
        ],
        "description": "direction"
      },
      "labelDirection": {
        "type": [
          "string"
        ],
        "enum": [
          "ltr",
          "rtl",
          "inherit"
        ],
        "description": "direction"
      },
      "optionsDirection": {
        "type": [
          "string"
        ],
        "enum": [
          "ltr",
          "rtl",
          "inherit"
        ],
        "description": "direction"
      },
      "defaultValue": {
        "type": [
          "null",
          "string"
        ]
      },
      "options": {
        "description": "a list of RadioButton data items",
        "default": [],
        "type": [
          "array",
          "null"
        ],
        "items": [
          {
            "type": [
              "null",
              "string"
            ]
          }
        ]
      },
      "label": {
        "type": [
          "null",
          "string"
        ],
        "default": "",
        "maxLength": 400
      },
      "placeholder": {
        "type": "object",
        "properties": {
          "value": {
            "type": "string",
            "default": "-1",
            "description": "the value of the placeholder option",
            "maxLength": 400
          },
          "text": {
            "type": "string",
            "default": "",
            "description": "the text of the placeholder option",
            "maxLength": 400
          }
        },
        "additionalProperties": false
      },
      "value": {
        "type": "string",
        "default": "",
        "maxLength": 4000
      },
      "name": {
        "type": "string",
        "maxLength": 400
      },
      "formGroup": {
        "type": "string",
        "description": "form group that this component belongs to",
        "maxLength": 4000
      }
    }
  },
  "CheckboxGroup": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "direction": {
        "type": [
          "string"
        ],
        "enum": [
          "ltr",
          "rtl",
          "inherit"
        ],
        "description": "direction"
      },
      "labelDirection": {
        "type": [
          "string"
        ],
        "enum": [
          "ltr",
          "rtl",
          "inherit"
        ],
        "description": "direction"
      },
      "optionsDirection": {
        "type": [
          "string"
        ],
        "enum": [
          "ltr",
          "rtl",
          "inherit"
        ],
        "description": "direction"
      },
      "options": {
        "description": "a list of CheckboxInput data items",
        "default": [],
        "type": [
          "array",
          "null"
        ],
        "items": [
          {
            "type": [
              "null",
              "string"
            ]
          }
        ]
      },
      "label": {
        "type": [
          "null",
          "string"
        ],
        "default": "",
        "maxLength": 4000
      },
      "name": {
        "type": "string",
        "maxLength": 400
      },
      "formGroup": {
        "type": "string",
        "description": "form group that this component belongs to",
        "maxLength": 4000
      }
    }
  },
  "FileUploader": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "buttonLabel": {
        "type": "string",
        "default": "Upload File",
        "maxLength": 500
      },
      "placeholderLabel": {
        "type": "string",
        "default": "Max File Size 15MG",
        "maxLength": 500
      },
      "label": {
        "type": [
          "null",
          "string"
        ],
        "default": "",
        "maxLength": 400
      },
      "direction": {
        "type": [
          "string"
        ],
        "enum": [
          "ltr",
          "rtl",
          "inherit"
        ],
        "description": "direction"
      },
      "labelDirection": {
        "type": [
          "string"
        ],
        "enum": [
          "ltr",
          "rtl",
          "inherit"
        ],
        "description": "direction"
      },
      "buttonLabelDirection": {
        "type": [
          "string"
        ],
        "enum": [
          "ltr",
          "rtl",
          "inherit"
        ],
        "description": "direction"
      },
      "filesDirection": {
        "type": [
          "string"
        ],
        "enum": [
          "ltr",
          "rtl",
          "inherit"
        ],
        "description": "direction"
      },
      "iconPosition": {
        "type": [
          "string"
        ],
        "enum": [
          "row",
          "rowReverse",
          "column",
          "columnReverse"
        ],
        "description": "Flex direction"
      }
    }
  },
  "UploadName": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      }
    }
  },
  "SiteButtonA11y": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "pressed": {
        "type": "boolean"
      },
      "tabindex": {
        "type": "number",
        "minimum": -1,
        "maximum": 0
      },
      "label": {
        "type": "string",
        "maxLength": 1000
      },
      "live": {
        "type": "string",
        "enum": [
          "polite",
          "assertive"
        ]
      },
      "haspopup": {
        "type": "string",
        "enum": [
          "true",
          "false",
          "menu",
          "dialog",
          "listbox",
          "tree",
          "grid"
        ]
      },
      "expanded": {
        "type": "boolean"
      },
      "disabled": {
        "type": "boolean"
      }
    }
  },
  "SiteButton": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "linkType": {
        "type": "string",
        "enum": [
          "SMS",
          "CALL",
          "SKYPE",
          "MAP",
          "EMAIL",
          "FACEBOOK",
          "FLICKR",
          "BLOGGER",
          "MYSPACE",
          "LINKEDIN",
          "TWITTER",
          "TUMBLR",
          "YOUTUBE",
          "VIMEO",
          "PAGE",
          "FREE_LINK",
          "TEXT",
          "DELICIOUS",
          "WEBSITE",
          "DOCUMENT",
          "ADMIN_LOGIN",
          "LOGIN"
        ],
        "default": "FREE_LINK"
      },
      "href": {
        "type": "string"
      },
      "text": {
        "type": "string",
        "maxLength": 1200
      },
      "target": {
        "type": "string"
      },
      "icon": {
        "type": "string"
      },
      "label": {
        "type": "string",
        "default": "MY BUTTON"
      }
    }
  },
  "SoundCloudWidget": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "url": {
        "type": "string",
        "default": ""
      },
      "showArtWork": {
        "type": "boolean",
        "default": true
      },
      "autoPlay": {
        "type": "boolean",
        "default": false
      },
      "embedSource": {
        "type": "string",
        "default": ""
      }
    }
  },
  "StyledTextA11y": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "label": {
        "type": "string",
        "maxLength": 1000
      },
      "live": {
        "type": "string",
        "enum": [
          "polite",
          "assertive"
        ]
      },
      "level": {
        "type": "number",
        "minimum": 1,
        "maximum": 6
      },
      "role": {
        "type": "string",
        "enum": [
          "heading",
          "status",
          "alert"
        ]
      },
      "atomic": {
        "type": "boolean"
      },
      "hidden": {
        "type": "boolean"
      },
      "current": {
        "type": "string",
        "enum": [
          "step",
          "page",
          "true",
          "false"
        ]
      }
    }
  },
  "StyledText": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "text": {
        "type": "string",
        "maxLength": 120000,
        "default": "<p class='font_7'></p>",
        "not": {
          "pattern": "<script"
        }
      },
      "stylesMapId": {
        "type": "string"
      },
      "linkList": {
        "type": [
          "array",
          "null"
        ],
        "items": [
          {
            "type": [
              "null",
              "string"
            ]
          }
        ]
      },
      "a11y": {
        "type": [
          "null",
          "string"
        ]
      }
    }
  },
  "StyledTextLinkHelper": {
    "type": "object",
    "properties": {
      "link": {
        "pattern": "^$|^#",
        "type": [
          "null",
          "string"
        ]
      }
    },
    "additionalProperties": false
  },
  "SvgShape": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "link": {
        "pattern": "^$|^#",
        "type": [
          "null",
          "string"
        ]
      },
      "alt": {
        "type": "string"
      }
    }
  },
  "VectorImage": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "link": {
        "description": "Reference to a link associated with the vector image.",
        "pattern": "^$|^#",
        "type": [
          "null",
          "string"
        ]
      },
      "alt": {
        "type": "string",
        "description": "Alternative text for the vector image (for accessibility purposes).",
        "default": ""
      },
      "decorative": {
        "type": "boolean"
      },
      "title": {
        "type": "string",
        "maxLength": 100,
        "description": "Title or caption for the vector image."
      },
      "svgId": {
        "type": "string",
        "maxLength": 100,
        "description": "Identifier for the SVG image."
      }
    }
  },
  "Video": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "videoId": {
        "type": "string"
      },
      "userId": {
        "type": "string"
      },
      "posterImage": {
        "type": [
          "null",
          "string"
        ]
      },
      "videoType": {
        "type": "string",
        "enum": [
          "YOUTUBE",
          "VIMEO",
          "FACEBOOK",
          "DAILYMOTION"
        ],
        "default": "YOUTUBE"
      }
    }
  },
  "VKShareButton": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "style": {
        "type": "string",
        "enum": [
          "Button",
          "ButtonWithoutCounter",
          "Link",
          "LinkWithoutIcon",
          "Icon"
        ],
        "default": "Button",
        "description": "the layout of the button"
      },
      "text": {
        "type": "string",
        "default": "Share",
        "description": "the text of the Button"
      },
      "isHttpsEnabled": {
        "type": "boolean",
        "default": false
      },
      "urlFormat": {
        "type": "string",
        "enum": [
          "hashBang",
          "slash"
        ],
        "default": "slash"
      }
    }
  },
  "ButtonWithIcon": {
    "type": "object",
    "properties": {
      "label": {
        "type": "string",
        "format": "resourceKey"
      },
      "toggleMode": {
        "type": "boolean"
      },
      "disabled": {
        "type": "boolean"
      },
      "iconSrc": {
        "type": "string"
      },
      "iconSize": {
        "type": "object",
        "additionalProperties": true
      },
      "spriteOffset": {
        "type": "object",
        "additionalProperties": true
      },
      "command": {
        "type": "string"
      },
      "commandParameter": {
        "type": "string"
      },
      "action": {
        "type": "string"
      }
    },
    "additionalProperties": false
  },
  "EditorPreferences": {
    "type": "object",
    "properties": {
      "dontShowAgainTooltips": {
        "type": [
          "null",
          "array"
        ]
      },
      "dontShowAgainDialogs": {
        "type": [
          "null",
          "array"
        ]
      }
    },
    "additionalProperties": false
  },
  "TPAWidget": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "applicationId": {
        "type": "string",
        "default": "",
        "description": "application ID"
      },
      "appDefinitionId": {
        "type": "string",
        "default": "",
        "description": "app Defitintion ID"
      },
      "widgetId": {
        "type": "string",
        "default": "",
        "description": "some amazing description"
      },
      "referenceId": {
        "type": "string"
      },
      "usesCssPerBreakpoint": {
        "type": [
          "boolean"
        ],
        "description": "does the TPA supports CSS Per breakpoint"
      },
      "tpaData": {
        "type": [
          "null",
          "string"
        ]
      }
    }
  },
  "TPAData": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "content": {
        "type": "string",
        "default": "",
        "description": "storage for app data",
        "maxLength": 4000
      }
    }
  },
  "TPAGlobalData": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "content": {
        "type": "string",
        "default": "",
        "description": "storage for app data"
      },
      "appDefinitionId": {
        "type": "string",
        "default": "",
        "description": "app Definition ID"
      }
    }
  },
  "TPA": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "applicationId": {
        "type": "string",
        "default": "",
        "description": "application ID"
      },
      "appDefinitionId": {
        "type": "string",
        "default": "",
        "description": "app Defitintion ID"
      },
      "referenceId": {
        "type": "string"
      },
      "widgetId": {
        "type": "string",
        "default": "",
        "description": "widget id"
      },
      "usesCssPerBreakpoint": {
        "type": [
          "boolean"
        ],
        "description": "does the TPA supports CSS Per breakpoint"
      },
      "tpaData": {
        "type": [
          "null",
          "string"
        ]
      }
    }
  },
  "TPASection": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "applicationId": {
        "type": "string",
        "default": "",
        "description": "application ID"
      },
      "referenceId": {
        "type": "string"
      },
      "usesCssPerBreakpoint": {
        "type": [
          "boolean"
        ],
        "description": "does the TPA supports CSS Per breakpoint"
      },
      "tpaData": {
        "type": [
          "null",
          "string"
        ]
      }
    }
  },
  "TPAMultiSection": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "applicationId": {
        "type": "string",
        "default": "",
        "description": "application ID"
      },
      "appDefinitionId": {
        "type": "string",
        "default": "",
        "description": "app Defitintion ID"
      },
      "widgetId": {
        "type": "string",
        "default": "",
        "description": "hidden tpaSection part of multi section app"
      },
      "referenceId": {
        "type": "string"
      },
      "usesCssPerBreakpoint": {
        "type": [
          "boolean"
        ],
        "description": "does the TPA supports CSS Per breakpoint"
      },
      "tpaData": {
        "type": [
          "null",
          "string"
        ]
      }
    }
  },
  "RssButton": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "image": {
        "type": [
          "null",
          "string"
        ]
      },
      "link": {
        "pattern": "^$|^#",
        "type": [
          "null",
          "string"
        ]
      }
    }
  },
  "AppPart": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "appInnerID": {
        "type": [
          "string",
          "number"
        ]
      },
      "appLogicParams": {
        "type": "object",
        "default": {},
        "additionalProperties": true
      },
      "appLogicCustomizations": {
        "type": "array",
        "items": {
          "type": "object",
          "properties": {
            "fieldId": {
              "type": "string"
            },
            "forType": {
              "type": "string"
            },
            "format": {
              "type": "string"
            },
            "key": {
              "type": "string"
            },
            "type": {
              "type": "string"
            },
            "view": {
              "type": "string"
            },
            "mode": {
              "type": [
                "string",
                "null"
              ]
            },
            "value": {
              "type": [
                "string",
                "null"
              ]
            }
          },
          "additionalProperties": false
        },
        "default": []
      },
      "appPartName": {
        "type": "string"
      },
      "viewName": {
        "type": "string"
      }
    }
  },
  "AppPartCustomization": {
    "type": "object",
    "properties": {
      "fieldId": {
        "type": "string"
      },
      "forType": {
        "type": "string"
      },
      "format": {
        "type": "string"
      },
      "key": {
        "type": "string"
      },
      "type": {
        "type": "string"
      },
      "view": {
        "type": "string"
      },
      "mode": {
        "type": [
          "string",
          "null"
        ]
      },
      "value": {
        "type": [
          "string",
          "null"
        ]
      }
    },
    "additionalProperties": false
  },
  "AppPage": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "appPageId": {
        "type": "string",
        "default": ""
      },
      "appInnerID": {
        "type": [
          "string",
          "number"
        ],
        "default": ""
      },
      "appPageType": {
        "type": "string"
      },
      "repeaterPage": {
        "type": "boolean",
        "default": false
      },
      "title": {
        "type": "string",
        "minLength": 1,
        "maxLength": 100
      },
      "hideTitle": {
        "type": "boolean"
      },
      "icon": {
        "type": "string"
      },
      "windowTitle": {
        "type": "string",
        "minLength": 1,
        "maxLength": 512
      },
      "descriptionSEO": {
        "type": "string",
        "maxLength": 1024
      },
      "advancedSeoData": {
        "type": "string",
        "maxLength": 10000
      },
      "metaKeywordsSEO": {
        "type": "string",
        "maxLength": 512
      },
      "pageTitleSEO": {
        "type": "string"
      },
      "pageUriSEO": {
        "type": "string"
      },
      "hidePage": {
        "type": "boolean"
      },
      "underConstruction": {
        "type": "boolean"
      },
      "tpaApplicationId": {
        "type": "number"
      },
      "appDefinitionId": {
        "type": "string"
      },
      "managingAppDefId": {
        "type": [
          "string",
          "null"
        ]
      },
      "tpaPageId": {
        "type": "string"
      },
      "parentPageId": {
        "type": [
          "null",
          "string"
        ]
      },
      "pageSecurity": {
        "type": [
          "object",
          "null"
        ],
        "default": {
          "requireLogin": false,
          "passwordDigest": "",
          "dialogLanguage": ""
        },
        "properties": {
          "requireLogin": {
            "type": "boolean"
          },
          "passwordDigest": {
            "type": "string"
          },
          "dialogLanguage": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "indexable": {
        "type": "boolean",
        "default": true
      },
      "mobileHidePage": {
        "type": [
          "boolean",
          "null"
        ]
      },
      "pageBackgrounds": {
        "type": "object",
        "properties": {
          "desktop": {
            "type": "object",
            "properties": {
              "custom": {
                "type": "boolean"
              },
              "mediaSizing": {
                "type": "string",
                "enum": [
                  "document",
                  "viewport"
                ]
              },
              "ref": {
                "type": [
                  "null",
                  "string"
                ]
              },
              "isPreset": {
                "type": "boolean"
              }
            },
            "additionalProperties": false
          },
          "mobile": {
            "type": "object",
            "properties": {
              "custom": {
                "type": "boolean"
              },
              "mediaSizing": {
                "type": "string",
                "enum": [
                  "document",
                  "viewport"
                ],
                "default": "viewport"
              },
              "ref": {
                "type": [
                  "null",
                  "string"
                ]
              },
              "isPreset": {
                "type": "boolean"
              }
            },
            "additionalProperties": false
          }
        },
        "additionalProperties": false
      },
      "isLandingPage": {
        "type": "boolean",
        "default": false
      },
      "isMobileLandingPage": {
        "type": "boolean",
        "default": false
      },
      "isPopup": {
        "type": "boolean",
        "default": false
      },
      "translationData": {
        "type": "object",
        "properties": {
          "uriSEOTranslated": {
            "type": "boolean",
            "default": false
          }
        },
        "additionalProperties": false
      },
      "ogImage": {
        "type": [
          "string",
          "null"
        ]
      },
      "ogImageRef": {
        "type": [
          "null",
          "string"
        ]
      },
      "ignoreBottomBottomAnchors": {
        "type": [
          "boolean",
          "null"
        ]
      },
      "cacheMode": {
        "enum": [
          "auto",
          "manual",
          "disabled"
        ]
      },
      "cacheMaxAgeHours": {
        "type": [
          "number",
          "null"
        ],
        "multipleOf": 1
      }
    }
  },
  "AppBuilderComponent": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "appInnerID": {
        "type": [
          "string",
          "null"
        ]
      },
      "appPartName": {
        "type": "string"
      }
    }
  },
  "BoxSlideShow": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "direction": {
        "description": "direction of the component",
        "type": "string",
        "enum": [
          "ltr",
          "rtl",
          "inherit"
        ]
      }
    }
  },
  "BoxSlideShowSlide": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "title": {
        "type": "string"
      }
    }
  },
  "StripContainerSlideShow": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "direction": {
        "description": "direction of the component",
        "type": "string",
        "enum": [
          "ltr",
          "rtl",
          "inherit"
        ]
      }
    }
  },
  "StripContainerSlideShowSlide": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "title": {
        "type": "string"
      },
      "background": {
        "type": [
          "null",
          "string"
        ]
      }
    }
  },
  "VerticalAnchorsMenu": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "pageTopLabel": {
        "type": [
          "null",
          "string"
        ],
        "default": "Page Top"
      },
      "pageBottomLabel": {
        "type": [
          "null",
          "string"
        ],
        "default": "Page Bottom"
      },
      "hiddenAnchorIds": {
        "type": [
          "null",
          "object"
        ],
        "default": {}
      },
      "direction": {
        "type": [
          "string"
        ],
        "enum": [
          "ltr",
          "rtl",
          "inherit"
        ],
        "description": "direction"
      },
      "bulletPosition": {
        "type": [
          "string"
        ],
        "enum": [
          "row",
          "rowReverse",
          "column",
          "columnReverse"
        ],
        "description": "Flex direction"
      }
    }
  },
  "WFacebookComment": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "isHttpsEnabled": {
        "type": "boolean",
        "default": false
      },
      "urlFormat": {
        "type": "string",
        "enum": [
          "hashBang",
          "slash"
        ],
        "default": "slash"
      }
    }
  },
  "WFacebookLike": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "isHttpsEnabled": {
        "type": "boolean",
        "default": false
      },
      "urlFormat": {
        "type": "string",
        "enum": [
          "hashBang",
          "slash"
        ],
        "default": "slash"
      }
    }
  },
  "AppController": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "applicationId": {
        "type": "string",
        "maxLength": 100
      },
      "name": {
        "type": "string",
        "maxLength": 100,
        "default": ""
      },
      "controllerType": {
        "type": "string",
        "maxLength": 100
      },
      "settings": {
        "type": "string",
        "maxLength": 6000
      },
      "externalId": {
        "type": "string",
        "maxLength": 100
      }
    },
    "required": [
      "applicationId",
      "controllerType"
    ]
  },
  "RepeaterA11y": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "label": {
        "type": "string",
        "maxLength": 1000
      },
      "role": {
        "type": "string",
        "enum": [
          "region",
          "none",
          "radiogroup",
          "list",
          "group"
        ]
      }
    }
  },
  "Repeater": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "direction": {
        "description": "direction of the component",
        "type": "string",
        "enum": [
          "ltr",
          "rtl",
          "inherit"
        ]
      },
      "items": {
        "type": "array",
        "default": [],
        "items": {
          "type": "string"
        },
        "description": "Unique identifiers for items of the repeater"
      },
      "a11y": {
        "type": [
          "null",
          "string"
        ]
      }
    }
  },
  "RepeatedData": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "original": {
        "type": "object",
        "additionalProperties": true,
        "description": "the original data item of a component inside a repeater according to the specific component schema"
      },
      "overrides": {
        "type": "object",
        "additionalProperties": true,
        "description": "a map from itemId in a repeater to its data item according to the specific component schema"
      }
    }
  },
  "ImageButtonWithText": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "label": {
        "type": "string",
        "maxLength": 100
      },
      "icon": {
        "type": [
          "null",
          "string"
        ]
      },
      "predefinedClass": {
        "type": "string",
        "maxLength": 20
      }
    }
  },
  "Icon": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "url": {
        "type": "string"
      },
      "width": {
        "type": "number"
      },
      "height": {
        "type": "number"
      },
      "title": {
        "type": "string"
      }
    }
  },
  "WidgetRef": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "appDefinitionId": {
        "type": "string"
      },
      "widgetId": {
        "type": "string"
      },
      "variationId": {
        "type": [
          "string",
          "null"
        ]
      },
      "name": {
        "type": "string",
        "maxLength": 100
      }
    }
  },
  "InternalRef": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "rootCompId": {
        "type": [
          "string"
        ]
      },
      "pageId": {
        "type": "string"
      }
    }
  },
  "InternalBlocksRef": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "rootCompId": {
        "type": "string"
      },
      "pageId": {
        "type": "string"
      }
    }
  },
  "LightboxA11y": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "label": {
        "type": "string",
        "maxLength": 1000
      }
    }
  },
  "LightboxContainer": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "a11y": {
        "type": [
          "null",
          "string"
        ]
      }
    }
  },
  "ContainerA11y": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "tabindex": {
        "type": "number",
        "minimum": -1,
        "maximum": 0
      },
      "role": {
        "type": "string",
        "enum": [
          "region",
          "group",
          "none",
          "status",
          "alert",
          "nav",
          "list",
          "listitem",
          "tablist",
          "tab",
          "tabpanel",
          "menubar",
          "presentation",
          "heading"
        ]
      },
      "roledescription": {
        "type": "string",
        "maxLength": 100
      },
      "label": {
        "type": "string",
        "maxLength": 1000
      },
      "level": {
        "type": "number",
        "minimum": 1,
        "maximum": 6
      },
      "live": {
        "type": "string",
        "enum": [
          "polite",
          "assertive"
        ]
      },
      "atomic": {
        "type": "boolean"
      },
      "current": {
        "type": "string",
        "enum": [
          "step",
          "page",
          "true",
          "false"
        ],
        "maxLength": 10
      },
      "hidden": {
        "type": "boolean"
      },
      "relevant": {
        "type": "string",
        "enum": [
          "all",
          "additions",
          "text",
          "removals"
        ]
      }
    }
  },
  "ContainerData": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "a11y": {
        "type": [
          "null",
          "string"
        ]
      }
    }
  },
  "MediaBoxData": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "a11y": {
        "type": [
          "null",
          "string"
        ]
      }
    }
  },
  "SlotsPlaceholderData": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "interfaces": {
        "type": "array",
        "items": {
          "type": "string"
        },
        "maxItems": 20
      }
    },
    "required": [
      "interfaces"
    ]
  },
  "LinkType": {
    "type": "string",
    "enum": [
      "SMS",
      "CALL",
      "SKYPE",
      "MAP",
      "EMAIL",
      "FACEBOOK",
      "FLICKR",
      "BLOGGER",
      "MYSPACE",
      "LINKEDIN",
      "TWITTER",
      "TUMBLR",
      "YOUTUBE",
      "VIMEO",
      "PAGE",
      "FREE_LINK",
      "TEXT",
      "DELICIOUS",
      "WEBSITE",
      "DOCUMENT",
      "ADMIN_LOGIN",
      "LOGIN"
    ],
    "default": "FREE_LINK"
  },
  "UrlFormat": {
    "type": "string",
    "enum": [
      "hashBang",
      "slash"
    ],
    "default": "slash"
  },
  "MultiStateBoxDataA11y": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "label": {
        "type": "string",
        "maxLength": 1000
      },
      "live": {
        "type": "string",
        "enum": [
          "polite",
          "assertive"
        ]
      },
      "tabindex": {
        "type": "number",
        "minimum": -1,
        "maximum": 0
      },
      "role": {
        "type": "string",
        "enum": [
          "region",
          "group",
          "tablist",
          "tab",
          "tabpanel",
          "alert",
          "status",
          "list",
          "menubar",
          "presentation",
          "none",
          "nav",
          "listitem"
        ]
      },
      "atomic": {
        "type": "boolean"
      },
      "hidden": {
        "type": "boolean"
      },
      "current": {
        "type": "string",
        "enum": [
          "step",
          "page",
          "true",
          "false",
          "location",
          "date",
          "time"
        ]
      },
      "expanded": {
        "type": "boolean"
      },
      "relevant": {
        "type": "string"
      },
      "busy": {
        "type": "boolean"
      },
      "owns": {
        "type": "string"
      }
    }
  },
  "MultiStateBoxData": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "defaultStateId": {
        "default": "FIRST_STATE",
        "type": [
          "null",
          "string"
        ]
      },
      "selectedStateId": {
        "type": [
          "null",
          "string"
        ]
      },
      "a11y": {
        "type": [
          "null",
          "string"
        ]
      }
    }
  },
  "AppsInstallState": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "stateMap": {
        "type": "object",
        "default": {},
        "additionalProperties": {
          "type": "object",
          "required": [
            "status"
          ],
          "properties": {
            "status": {
              "type": "string",
              "enum": [
                "INSTALLED",
                "REMOVED"
              ],
              "default": "INSTALLED"
            },
            "version": {
              "type": [
                "string",
                "null"
              ],
              "minLength": 1,
              "maxLength": 20
            },
            "codeReferenceId": {
              "type": [
                "string",
                "null"
              ],
              "minLength": 1,
              "maxLength": 40
            },
            "overrideCodeReferenceId": {
              "type": [
                "string",
                "null"
              ],
              "minLength": 1,
              "maxLength": 40
            }
          }
        },
        "properties": {}
      }
    }
  },
  "StateBoxA11y": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "label": {
        "type": "string",
        "maxLength": 1000
      },
      "live": {
        "type": "string",
        "enum": [
          "polite",
          "assertive"
        ]
      },
      "tabindex": {
        "type": "number",
        "minimum": -1,
        "maximum": 0
      },
      "role": {
        "type": "string",
        "enum": [
          "region",
          "group",
          "tablist",
          "tab",
          "tabpanel",
          "alert",
          "status",
          "list",
          "menubar",
          "presentation",
          "none",
          "nav",
          "listitem"
        ]
      },
      "atomic": {
        "type": "boolean"
      },
      "hidden": {
        "type": "boolean"
      },
      "current": {
        "type": "string",
        "enum": [
          "step",
          "page",
          "true",
          "false",
          "location",
          "date",
          "time"
        ]
      },
      "expanded": {
        "type": "boolean"
      },
      "relevant": {
        "type": "string"
      },
      "busy": {
        "type": "boolean"
      },
      "owns": {
        "type": "string"
      }
    }
  },
  "StateBox": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "a11y": {
        "type": [
          "null",
          "string"
        ]
      }
    }
  },
  "StateBoxStateA11y": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "label": {
        "type": "string",
        "maxLength": 1000
      },
      "live": {
        "type": "string",
        "enum": [
          "polite",
          "assertive"
        ]
      },
      "tabindex": {
        "type": "number",
        "minimum": -1,
        "maximum": 0
      },
      "role": {
        "type": "string",
        "enum": [
          "region",
          "group",
          "tablist",
          "tab",
          "tabpanel",
          "alert",
          "status",
          "list",
          "menubar",
          "presentation",
          "none",
          "nav",
          "listitem"
        ]
      },
      "atomic": {
        "type": "boolean"
      },
      "hidden": {
        "type": "boolean"
      },
      "current": {
        "type": "string",
        "enum": [
          "step",
          "page",
          "true",
          "false",
          "location",
          "date",
          "time"
        ]
      },
      "expanded": {
        "type": "boolean"
      },
      "relevant": {
        "type": "string"
      },
      "busy": {
        "type": "boolean"
      },
      "owns": {
        "type": "string"
      }
    }
  },
  "StateBoxState": {
    "type": "object",
    "properties": {
      "a11y": {
        "type": [
          "null",
          "string"
        ]
      }
    },
    "additionalProperties": false
  },
  "Builder.MenuItem": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "link": {
        "pattern": "^$|^#",
        "type": [
          "null",
          "string"
        ]
      },
      "items": {
        "default": [],
        "type": [
          "array",
          "null"
        ],
        "items": [
          {
            "type": [
              "null",
              "string"
            ]
          }
        ]
      },
      "container": {
        "type": "string"
      },
      "label": {
        "type": "string"
      },
      "isVisible": {
        "type": "boolean",
        "default": true
      }
    }
  },
  "Builder.MenuItems": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "name": {
        "type": "string"
      },
      "appDefinitionId": {
        "type": "string"
      },
      "items": {
        "default": [],
        "type": [
          "array",
          "null"
        ],
        "items": [
          {
            "type": [
              "null",
              "string"
            ]
          }
        ]
      }
    }
  },
  "Builder.Image": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "uri": {
        "type": "string",
        "maxLength": 1000,
        "description": "Identifier or URL for the image."
      },
      "name": {
        "type": "string",
        "maxLength": 100,
        "description": "Human-readable filename to use for the image."
      },
      "width": {
        "type": "number"
      },
      "height": {
        "type": "number"
      },
      "alt": {
        "type": "string",
        "maxLength": 1000
      },
      "crop": {
        "type": "object",
        "required": [
          "width",
          "height",
          "x",
          "y"
        ],
        "properties": {
          "width": {
            "type": "number",
            "minimum": 0
          },
          "height": {
            "type": "number",
            "minimum": 0
          },
          "x": {
            "type": "number",
            "minimum": 0
          },
          "y": {
            "type": "number",
            "minimum": 0
          }
        },
        "additionalProperties": false
      }
    },
    "required": [
      "uri"
    ]
  },
  "Builder.Video": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "uri": {
        "type": "string",
        "description": "Unique identifier for the video media",
        "maxLength": 1000
      },
      "sources": {
        "type": "array",
        "description": "Available video sources in different qualities",
        "items": {
          "type": "object",
          "required": [
            "quality",
            "width",
            "height",
            "types"
          ],
          "properties": {
            "quality": {
              "type": "string",
              "enum": [
                "1080p",
                "720p",
                "480p",
                "360p"
              ],
              "description": "Quality level of the video source"
            },
            "width": {
              "type": "number",
              "description": "Width of the video in pixels"
            },
            "height": {
              "type": "number",
              "description": "Height of the video in pixels"
            },
            "types": {
              "type": "array",
              "description": "Available format types and their URIs for this quality",
              "items": {
                "type": "object",
                "required": [
                  "format",
                  "uri"
                ],
                "properties": {
                  "format": {
                    "type": "string",
                    "enum": [
                      "mp4",
                      "mp4-luminance"
                    ],
                    "description": "Video format type"
                  },
                  "uri": {
                    "type": "string",
                    "description": "URI to access the video file"
                  }
                },
                "additionalProperties": false
              }
            }
          },
          "additionalProperties": false
        }
      },
      "adaptiveSources": {
        "type": "array",
        "description": "Sources for adaptive streaming formats",
        "items": {
          "type": "object",
          "required": [
            "format",
            "uri"
          ],
          "properties": {
            "format": {
              "type": "string",
              "enum": [
                "hls",
                "dash"
              ],
              "description": "Adaptive streaming format"
            },
            "uri": {
              "type": "string",
              "description": "URI to access the stream manifest"
            }
          },
          "additionalProperties": false
        }
      },
      "hasAudio": {
        "type": "boolean",
        "description": "Whether the video contains an audio track"
      },
      "fps": {
        "type": "number",
        "description": "Frames per second of the video"
      },
      "poster": {
        "description": "Poster image for the video",
        "type": [
          "null",
          "string"
        ]
      },
      "duration": {
        "type": "number",
        "description": "Duration of the video in seconds"
      }
    },
    "required": [
      "uri"
    ]
  },
  "Builder.VectorArt": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "uri": {
        "type": "string"
      }
    },
    "required": [
      "uri"
    ]
  },
  "Builder.RichText": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "text": {
        "type": "string",
        "maxLength": 120000
      },
      "linkList": {
        "type": [
          "array",
          "null"
        ],
        "items": [
          {
            "type": [
              "null",
              "string"
            ]
          }
        ]
      }
    }
  },
  "mobui.MobuiButton": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "contentType": {
        "default": "Text",
        "enum": [
          "Text",
          "Icon",
          "Text and icon"
        ],
        "type": "string"
      },
      "label": {
        "default": "Button",
        "maxLength": 120,
        "type": "string"
      },
      "icon": {
        "type": [
          "null",
          "string"
        ]
      },
      "iconPosition": {
        "default": "Left",
        "enum": [
          "Left",
          "Right"
        ],
        "type": "string"
      },
      "buttonType": {
        "default": "Full",
        "enum": [
          "Full",
          "Outline",
          "Link"
        ],
        "type": "string"
      },
      "size": {
        "default": "Medium",
        "enum": [
          "Small",
          "Medium",
          "Large"
        ],
        "type": "string"
      }
    }
  },
  "mobui.MobuiDatePicker": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "label": {
        "default": "Select Date",
        "maxLength": 120,
        "type": "string"
      },
      "initialText": {
        "default": "today's date",
        "enum": [
          "today's date",
          "placeholder"
        ],
        "type": "string"
      },
      "placeholder": {
        "default": "",
        "maxLength": 120,
        "type": "string"
      },
      "icon": {
        "type": [
          "null",
          "string"
        ]
      },
      "fieldType": {
        "default": "form",
        "enum": [
          "form",
          "settings",
          "filter"
        ],
        "type": "string"
      },
      "pickerType": {
        "default": "calendar",
        "enum": [
          "wheel",
          "calendar"
        ],
        "type": "string"
      },
      "pickerTitle": {
        "default": "Select Date",
        "maxLength": 120,
        "type": "string"
      },
      "showPastDates": {
        "default": true,
        "type": "boolean"
      },
      "showFutureDates": {
        "default": true,
        "type": "boolean"
      },
      "wheelMode": {
        "default": "DD/MM/YY",
        "enum": [
          "DD/MM/YY",
          "MM/YY"
        ],
        "type": "string"
      },
      "firstDay": {
        "default": "Monday",
        "enum": [
          "Sunday",
          "Monday"
        ],
        "type": "string"
      },
      "disabledDaysOfWeek": {
        "default": [],
        "type": [
          "array"
        ],
        "items": [
          {
            "type": [
              "null",
              "string"
            ]
          }
        ]
      },
      "enabledDateRanges": {
        "default": [],
        "type": [
          "array"
        ],
        "items": [
          {
            "type": [
              "null",
              "string"
            ]
          }
        ]
      },
      "disabledDateRanges": {
        "default": [],
        "type": [
          "array"
        ],
        "items": [
          {
            "type": [
              "null",
              "string"
            ]
          }
        ]
      },
      "readOnly": {
        "default": false,
        "type": "boolean"
      },
      "required": {
        "default": false,
        "type": "boolean"
      },
      "requiredErrorMessage": {
        "default": "This field is required",
        "maxLength": 1200,
        "type": "string"
      },
      "validateOnStart": {
        "default": false,
        "type": "boolean"
      },
      "validateOnChange": {
        "default": false,
        "type": "boolean"
      },
      "disabledDates": {
        "default": [],
        "type": [
          "array"
        ],
        "items": [
          {
            "type": [
              "null",
              "string"
            ]
          }
        ]
      },
      "minDate": {
        "default": "",
        "maxLength": 120,
        "type": "string"
      },
      "maxDate": {
        "default": "",
        "maxLength": 120,
        "type": "string"
      },
      "timeZone": {
        "default": "",
        "maxLength": 120,
        "type": "string"
      }
    }
  },
  "defaultItemSchemaType": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "label": {
        "maxLength": 120,
        "type": "string"
      },
      "value": {
        "maxLength": 120,
        "type": "string"
      },
      "disabled": {
        "default": false,
        "type": "boolean"
      },
      "isDefault": {
        "default": false,
        "type": "boolean"
      },
      "unavailable": {
        "default": false,
        "type": "boolean"
      }
    },
    "required": [
      "label",
      "value"
    ]
  },
  "MobuiDateRangeType": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "label": {
        "maxLength": 120,
        "type": "string"
      },
      "value": {
        "maxLength": 120,
        "type": "string"
      },
      "disabled": {
        "default": false,
        "type": "boolean"
      },
      "isDefault": {
        "default": false,
        "type": "boolean"
      },
      "unavailable": {
        "default": false,
        "type": "boolean"
      },
      "startDate": {
        "default": "",
        "maxLength": 120,
        "type": "string"
      },
      "endDate": {
        "default": "",
        "maxLength": 120,
        "type": "string"
      }
    },
    "required": [
      "label",
      "value"
    ]
  },
  "mobui.MobuiImage": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "src": {
        "type": [
          "null",
          "string"
        ]
      },
      "isExternalSource": {
        "default": false,
        "type": "boolean"
      },
      "resizeMode": {
        "default": "cover",
        "enum": [
          "cover",
          "contain",
          "stretch",
          "repeat",
          "center"
        ],
        "type": "string"
      }
    }
  },
  "mobui.MobuiPicker": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "fieldType": {
        "default": "form",
        "enum": [
          "form",
          "filter",
          "settings"
        ],
        "type": "string"
      },
      "label": {
        "default": "Label",
        "maxLength": 120,
        "type": "string"
      },
      "placeholder": {
        "default": "Select an option",
        "maxLength": 120,
        "type": "string"
      },
      "pickerType": {
        "default": "fullScreen",
        "enum": [
          "fullScreen",
          "dialog"
        ],
        "type": "string"
      },
      "optionsDialogTitle": {
        "default": "Select an Option",
        "maxLength": 120,
        "type": "string"
      },
      "optionsDialogSubtitle": {
        "default": "",
        "maxLength": 120,
        "type": "string"
      },
      "hasItemSubtitle": {
        "default": false,
        "type": "boolean"
      },
      "isMultiselect": {
        "default": false,
        "type": "boolean"
      },
      "selectionLimit": {
        "default": 3,
        "type": "number",
        "multipleOf": 1
      },
      "hasSearchBar": {
        "default": false,
        "type": "boolean"
      },
      "readOnly": {
        "default": false,
        "type": "boolean"
      },
      "requiredErrorMessage": {
        "default": "Please fill out this field",
        "maxLength": 120,
        "type": "string"
      },
      "validateOnStart": {
        "default": false,
        "type": "boolean"
      },
      "validateOnChange": {
        "default": false,
        "type": "boolean"
      },
      "validateOnBlur": {
        "default": false,
        "type": "boolean"
      },
      "options": {
        "default": [],
        "type": [
          "array"
        ],
        "items": [
          {
            "type": [
              "null",
              "string"
            ]
          }
        ]
      }
    }
  },
  "MobuiPickerItemType": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "label": {
        "maxLength": 120,
        "type": "string"
      },
      "value": {
        "maxLength": 120,
        "type": "string"
      },
      "disabled": {
        "default": false,
        "type": "boolean"
      },
      "isDefault": {
        "default": false,
        "type": "boolean"
      },
      "unavailable": {
        "default": false,
        "type": "boolean"
      },
      "subtitle": {
        "default": "",
        "maxLength": 120,
        "type": "string"
      },
      "isSelected": {
        "default": false,
        "type": "boolean"
      }
    },
    "required": [
      "label",
      "value"
    ]
  },
  "mobui.MobuiSwitch": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "value": {
        "default": false,
        "type": "boolean"
      }
    }
  },
  "mobui.MobuiText": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "text": {
        "default": "Add Title",
        "maxLength": 1200,
        "type": "string"
      },
      "selectable": {
        "default": true,
        "type": "boolean"
      }
    }
  },
  "mobui.MobuiTextInput": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "inputType": {
        "default": "text",
        "enum": [
          "text",
          "password",
          "phone",
          "email",
          "url",
          "number"
        ],
        "type": "string"
      },
      "label": {
        "default": "Label",
        "maxLength": 120,
        "type": "string"
      },
      "placeholder": {
        "default": "",
        "maxLength": 120,
        "type": "string"
      },
      "initialValue": {
        "default": "",
        "maxLength": 120,
        "type": "string"
      },
      "hasCharLimit": {
        "default": false,
        "type": "boolean"
      },
      "maxInputLength": {
        "default": 300,
        "maximum": 120000,
        "type": "number",
        "multipleOf": 1
      },
      "prefixValue": {
        "default": "",
        "maxLength": 120,
        "type": "string"
      },
      "suffixValue": {
        "default": "",
        "maxLength": 120,
        "type": "string"
      },
      "requiredErrorMessage": {
        "default": "",
        "maxLength": 120,
        "type": "string"
      },
      "validatorErrorMessageValue": {
        "default": "",
        "maxLength": 120,
        "type": "string"
      },
      "validatorType": {
        "default": "none",
        "enum": [
          "none",
          "number",
          "email",
          "url",
          "required"
        ],
        "type": "string"
      },
      "textContentType": {
        "default": "",
        "maxLength": 120,
        "type": "string"
      },
      "autoComplete": {
        "default": "",
        "maxLength": 120,
        "type": "string"
      },
      "validateOnStart": {
        "default": false,
        "type": "boolean"
      },
      "validateOnChange": {
        "default": false,
        "type": "boolean"
      },
      "validateOnBlur": {
        "default": true,
        "type": "boolean"
      }
    }
  },
  "mobui.MobuiVideoPlayer": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "title": {
        "default": "I am a Title",
        "maxLength": 120,
        "type": "string"
      },
      "src": {
        "default": "https://video.wixstatic.com/video/11062b_5ae1557b0cb244ab80dabfa817f48caa/1080p/mp4/file.mp4",
        "maxLength": 1200,
        "type": "string"
      },
      "poster": {
        "type": [
          "null",
          "string"
        ]
      },
      "isPlaying": {
        "default": false,
        "type": "boolean"
      },
      "muteOnStart": {
        "default": false,
        "type": "boolean"
      },
      "playInLoop": {
        "default": false,
        "type": "boolean"
      },
      "enableFullScreen": {
        "default": true,
        "type": "boolean"
      },
      "enableCasting": {
        "default": false,
        "type": "boolean"
      },
      "showVideoSettings": {
        "default": false,
        "type": "boolean"
      }
    }
  },
  "mobui.MobuiMultiStateBoxData": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "defaultStateId": {
        "default": null,
        "type": [
          "null",
          "string"
        ]
      },
      "selectedStateId": {
        "default": null,
        "type": [
          "null",
          "string"
        ]
      }
    }
  },
  "wixui.ExternalComponent": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "url": {
        "default": "",
        "maxLength": 120,
        "type": "string"
      },
      "compProps": {
        "default": "{}",
        "maxLength": 120000,
        "type": "string"
      },
      "isTrusted": {
        "default": false,
        "type": "boolean"
      },
      "importKey": {
        "default": "",
        "maxLength": 120,
        "type": "string"
      }
    }
  },
  "wixui.HamburgerOverlay": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "showBackgroundOverlay": {
        "default": true,
        "type": "boolean"
      },
      "tapOutsideToClose": {
        "default": true,
        "type": "boolean"
      },
      "isMenuContainerFullscreen": {
        "default": false,
        "type": "boolean"
      }
    }
  },
  "wixui.Logo": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "isLoadingData": {
        "default": true,
        "type": "boolean"
      },
      "logoId": {
        "default": "",
        "maxLength": 120,
        "type": "string"
      },
      "alt": {
        "default": "Logo",
        "maxLength": 120,
        "type": "string"
      },
      "link": {
        "pattern": "^$|^#",
        "type": [
          "null",
          "string"
        ]
      },
      "preset": {
        "default": "original",
        "maxLength": 120,
        "type": "string"
      },
      "hasBackground": {
        "default": true,
        "type": "boolean"
      },
      "brandId": {
        "default": "",
        "maxLength": 120,
        "type": "string"
      },
      "backgroundColor": {
        "default": "",
        "maxLength": 120,
        "type": "string"
      },
      "logoUrl": {
        "default": "",
        "maxLength": 1200,
        "type": "string"
      }
    }
  },
  "wixui.LottieEmbed": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "animationUrl": {
        "default": "https://assets7.lottiefiles.com/packages/lf20_bh69rwvr.json",
        "maxLength": 1200,
        "type": "string"
      },
      "speed": {
        "default": 1,
        "minimum": 0,
        "type": "number"
      },
      "loop": {
        "default": true,
        "type": "boolean"
      },
      "autoplay": {
        "default": true,
        "type": "boolean"
      },
      "alt": {
        "default": "",
        "maxLength": 120,
        "type": "string"
      },
      "isDecorative": {
        "default": false,
        "type": "boolean"
      },
      "showPlaybackControl": {
        "default": false,
        "type": "boolean"
      }
    }
  },
  "wixui.ProductSpecification": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "items": {
        "default": [],
        "type": [
          "array"
        ],
        "items": [
          {
            "type": [
              "null",
              "string"
            ]
          }
        ]
      }
    }
  },
  "wixui.RangeSlider": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "label": {
        "default": "Set a range value",
        "maxLength": 120,
        "type": "string"
      },
      "sliderType": {
        "default": "Continuous",
        "enum": [
          "Continuous",
          "Stepped"
        ],
        "type": "string"
      },
      "stepType": {
        "default": "Number",
        "enum": [
          "Number",
          "Value"
        ],
        "type": "string"
      },
      "step": {
        "default": 1,
        "type": "number",
        "multipleOf": 1
      },
      "direction": {
        "default": "ltr",
        "enum": [
          "ltr",
          "rtl"
        ],
        "type": "string"
      },
      "rootDirection": {
        "enum": [
          "ltr",
          "rtl",
          "inherit"
        ],
        "type": "string"
      },
      "labelDirection": {
        "enum": [
          "ltr",
          "rtl",
          "inherit"
        ],
        "type": "string"
      },
      "sliderDirection": {
        "enum": [
          "ltr",
          "rtl",
          "inherit"
        ],
        "type": "string"
      },
      "min": {
        "default": 0,
        "type": "number"
      },
      "max": {
        "default": 100,
        "type": "number"
      },
      "prefix": {
        "default": "",
        "maxLength": 120,
        "type": "string"
      },
      "suffix": {
        "default": "",
        "maxLength": 120,
        "type": "string"
      },
      "minValue": {
        "default": 0,
        "type": "number"
      },
      "maxValue": {
        "default": 0,
        "type": "number"
      },
      "thumbShape": {
        "default": "Circle",
        "enum": [
          "Circle",
          "Square",
          "Rectangle",
          "Bar"
        ],
        "type": "string"
      },
      "marksTickShape": {
        "default": "Lines",
        "enum": [
          "Lines",
          "Dots"
        ],
        "type": "string"
      },
      "thumbSize": {
        "default": 24,
        "type": "number",
        "multipleOf": 1
      },
      "readOnly": {
        "default": false,
        "type": "boolean"
      },
      "accessibleName": {
        "default": "",
        "maxLength": 120,
        "type": "string"
      }
    }
  },
  "wixui.Rive": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "animationFileUrl": {
        "default": "",
        "maxLength": 120,
        "type": "string"
      },
      "thumbnailFileUrl": {
        "default": "",
        "maxLength": 120,
        "type": "string"
      },
      "artboard": {
        "default": "",
        "maxLength": 120,
        "type": "string"
      },
      "stateMachine": {
        "default": "",
        "maxLength": 120,
        "type": "string"
      },
      "fit": {
        "default": "cover",
        "maxLength": 120,
        "type": "string"
      },
      "alignment": {
        "default": "center",
        "maxLength": 120,
        "type": "string"
      },
      "isAutoPlayOn": {
        "default": true,
        "type": "boolean"
      },
      "isTouchScrollEnabled": {
        "default": true,
        "type": "boolean"
      },
      "alt": {
        "default": "",
        "maxLength": 120,
        "type": "string"
      },
      "fileName": {
        "default": "",
        "maxLength": 120,
        "type": "string"
      },
      "isDecorative": {
        "default": true,
        "type": "boolean"
      }
    }
  },
  "wixui.ShareButtons": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "buttons": {
        "default": [],
        "type": [
          "array"
        ],
        "items": [
          {
            "type": [
              "null",
              "string"
            ]
          }
        ]
      },
      "pageToShare": {
        "default": "home",
        "maxLength": 1200,
        "type": "string"
      },
      "shareUrl": {
        "default": "",
        "maxLength": 1200,
        "type": "string"
      },
      "direction": {
        "enum": [
          "ltr",
          "rtl",
          "inherit"
        ],
        "type": "string"
      }
    }
  },
  "IShareButton": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "label": {
        "maxLength": 120,
        "type": "string"
      },
      "value": {
        "default": "",
        "maxLength": 120,
        "type": "string"
      },
      "disabled": {
        "default": false,
        "type": "boolean"
      },
      "isDefault": {
        "default": false,
        "type": "boolean"
      },
      "unavailable": {
        "default": false,
        "type": "boolean"
      },
      "platformId": {
        "default": "",
        "maxLength": 120,
        "type": "string"
      },
      "illustration": {
        "type": [
          "null",
          "string"
        ]
      },
      "isHidden": {
        "default": false,
        "type": "boolean"
      }
    },
    "required": [
      "label"
    ]
  },
  "wixui.SingleTab": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "tabId": {
        "maxLength": 120,
        "type": "string"
      },
      "label": {
        "default": "Tab",
        "maxLength": 120,
        "type": "string"
      },
      "isParentStretched": {
        "default": false,
        "type": "boolean"
      }
    },
    "required": [
      "tabId"
    ]
  },
  "AccordionContainerData": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "direction": {
        "type": [
          "string"
        ],
        "enum": [
          "ltr",
          "rtl",
          "inherit"
        ],
        "description": "direction"
      },
      "items": {
        "type": "array",
        "items": {
          "type": [
            "object"
          ],
          "additionalProperties": false,
          "properties": {
            "id": {
              "type": "string"
            },
            "label": {
              "type": "string"
            }
          }
        },
        "default": []
      }
    }
  },
  "AccordionItemData": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "isParentStretched": {
        "type": "boolean",
        "default": false
      }
    }
  },
  "AddressInput": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "direction": {
        "type": [
          "string"
        ],
        "enum": [
          "ltr",
          "rtl",
          "inherit"
        ],
        "description": "direction"
      },
      "labelDirection": {
        "type": [
          "string"
        ],
        "enum": [
          "ltr",
          "rtl",
          "inherit"
        ],
        "description": "direction"
      },
      "inputDirection": {
        "type": [
          "string"
        ],
        "enum": [
          "ltr",
          "rtl",
          "inherit"
        ],
        "description": "direction"
      },
      "optionsDirection": {
        "type": [
          "string"
        ],
        "enum": [
          "ltr",
          "rtl",
          "inherit"
        ],
        "description": "direction"
      },
      "locale": {
        "type": "string",
        "maxLength": 100
      },
      "googleMapsApiKey": {
        "type": "string",
        "maxLength": 400
      },
      "filter": {
        "type": "object",
        "properties": {
          "country": {
            "type": "string",
            "maxLength": 10
          }
        },
        "additionalProperties": false
      },
      "sorting": {
        "type": "object",
        "properties": {
          "location": {
            "type": "object",
            "properties": {
              "lat": {
                "type": "number"
              },
              "lng": {
                "type": "number"
              }
            },
            "additionalProperties": false
          },
          "radius": {
            "type": "number",
            "default": 100
          },
          "formatted": {
            "type": "string",
            "maxLength": 10
          }
        },
        "additionalProperties": false
      },
      "placeholder": {
        "type": "string",
        "description": "The value of the placeholder if chosen",
        "maxLength": 1000
      },
      "label": {
        "type": "string",
        "maxLength": 1000
      }
    }
  },
  "BoltComponentData": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      }
    },
    "anyOf": [
      {
        "properties": {},
        "additionalProperties": false
      }
    ]
  },
  "BreadcrumbsData": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "svgId": {
        "type": "string",
        "maxLength": 100
      },
      "menuRef": {
        "default": "#CUSTOM_MAIN_MENU",
        "type": [
          "null",
          "string"
        ]
      },
      "a11y": {
        "type": [
          "null",
          "string"
        ]
      },
      "direction": {
        "description": "direction of the component",
        "type": "string",
        "enum": [
          "ltr",
          "rtl",
          "inherit"
        ]
      },
      "itemDirection": {
        "description": "direction of the 1st (top) level menu items",
        "type": "string",
        "enum": [
          "ltr",
          "rtl",
          "inherit"
        ]
      },
      "submenuDirection": {
        "description": "direction of the 2nd level menu item (submenu)",
        "type": "string",
        "enum": [
          "ltr",
          "rtl",
          "inherit"
        ]
      },
      "submenuSubItemDirection": {
        "description": "direction of the 3rd level menu item (submenuSubItem)",
        "type": "string",
        "enum": [
          "ltr",
          "rtl",
          "inherit"
        ]
      }
    }
  },
  "Captcha": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "captchaType": {
        "type": "string",
        "enum": [
          "image",
          "audio"
        ],
        "default": "image",
        "description": "When set changes the type of the challenge (image or audio)"
      }
    }
  },
  "CollapsibleTextData": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "text": {
        "type": "string",
        "default": "",
        "maxLength": 120000
      },
      "readMoreText": {
        "type": "string",
        "default": "Read More",
        "maxLength": 1200
      },
      "readLessText": {
        "type": "string",
        "default": "Read Less",
        "maxLength": 1200
      },
      "link": {
        "pattern": "^$|^#",
        "type": [
          "null",
          "string"
        ]
      },
      "linkText": {
        "type": "string",
        "default": "Read More",
        "maxLength": 1200
      },
      "textDescription": {
        "type": "string",
        "default": "",
        "maxLength": 100
      },
      "tag": {
        "type": "string",
        "default": "p",
        "maxLength": 31
      },
      "direction": {
        "type": [
          "string"
        ],
        "enum": [
          "ltr",
          "rtl",
          "inherit"
        ],
        "description": "direction"
      },
      "textDirection": {
        "type": [
          "string"
        ],
        "enum": [
          "ltr",
          "rtl",
          "inherit"
        ],
        "description": "direction"
      },
      "buttonDirection": {
        "type": [
          "string"
        ],
        "enum": [
          "ltr",
          "rtl",
          "inherit"
        ],
        "description": "direction"
      }
    }
  },
  "ComboBoxInputData": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "direction": {
        "description": "direction of the component",
        "type": "string",
        "enum": [
          "ltr",
          "rtl",
          "inherit"
        ]
      },
      "labelDirection": {
        "description": "direction of the label",
        "type": "string",
        "enum": [
          "ltr",
          "rtl",
          "inherit"
        ]
      },
      "inputDirection": {
        "description": "direction of the input",
        "type": "string",
        "enum": [
          "ltr",
          "rtl",
          "inherit"
        ]
      },
      "dropdownDirection": {
        "description": "direction of the dropdown",
        "type": "string",
        "enum": [
          "ltr",
          "rtl",
          "inherit"
        ]
      },
      "errorDirection": {
        "description": "direction of the error",
        "type": "string",
        "enum": [
          "ltr",
          "rtl",
          "inherit"
        ]
      },
      "options": {
        "description": "a list of SelectOption data items",
        "default": [],
        "type": [
          "array",
          "null"
        ],
        "items": [
          {
            "type": [
              "null",
              "string"
            ]
          }
        ]
      },
      "label": {
        "type": [
          "null",
          "string"
        ],
        "default": "",
        "maxLength": 400
      },
      "placeholder": {
        "type": "object",
        "properties": {
          "value": {
            "type": "string",
            "default": "-1",
            "description": "the value of the placeholder option",
            "maxLength": 400
          },
          "text": {
            "type": "string",
            "default": "",
            "description": "the text of the placeholder option",
            "maxLength": 400
          }
        },
        "additionalProperties": false
      },
      "value": {
        "type": "string",
        "default": "",
        "maxLength": 4000
      },
      "name": {
        "type": "string",
        "maxLength": 400
      },
      "formGroup": {
        "type": "string",
        "description": "form group that this component belongs to",
        "maxLength": 4000
      }
    }
  },
  "CustomElement": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "tagName": {
        "type": "string",
        "default": "wix-default-custom-element"
      },
      "url": {
        "type": "string",
        "default": "https://static.parastorage.com/services/editor-elements-library/dist/assets/CustomElement/wixDefaultCustomElement.js"
      },
      "hostedInCorvid": {
        "type": "boolean",
        "default": false
      },
      "initialAttributes": {
        "type": "string",
        "default": "{}",
        "maxLength": 4096
      },
      "shouldReload": {
        "type": "boolean",
        "description": "if iframe should be reloaded on initialAttributes change"
      },
      "scriptType": {
        "type": "string",
        "enum": [
          "none",
          "module"
        ],
        "default": "none"
      },
      "appDefinitionId": {
        "type": "string",
        "maxLength": 36
      },
      "widgetId": {
        "type": "string",
        "maxLength": 36
      }
    }
  },
  "wixui.FastGallery": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "items": {
        "default": [],
        "type": [
          "array"
        ],
        "items": [
          {
            "type": [
              "null",
              "string"
            ]
          }
        ]
      },
      "itemClickAction": {
        "default": "ACTION",
        "enum": [
          "ACTION",
          "LINK",
          "NOTHING"
        ],
        "type": "string"
      },
      "downloadProtection": {
        "default": true,
        "type": "boolean"
      },
      "wixSDKItems": {
        "default": [],
        "type": [
          "array"
        ],
        "items": [
          {
            "type": [
              "null",
              "string"
            ]
          }
        ]
      }
    }
  },
  "wixui.HamburgerMenuContainer": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      }
    }
  },
  "wixui.HamburgerMenuRoot": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      }
    }
  },
  "ImageX": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "image": {
        "type": "object",
        "properties": {
          "uri": {
            "type": "string",
            "default": ""
          },
          "alt": {
            "type": "string",
            "default": ""
          },
          "name": {
            "type": "string",
            "maxLength": 100
          },
          "height": {
            "type": "number",
            "default": 200
          },
          "width": {
            "type": "number",
            "default": 200
          },
          "decorative": {
            "type": "boolean"
          }
        },
        "additionalProperties": false
      },
      "link": {
        "type": [
          "null",
          "string"
        ]
      },
      "scopedData": {
        "description": "ImageX data per breakpoint",
        "type": [
          "null",
          "array"
        ],
        "items": {
          "type": "object",
          "properties": {
            "breakpoint": {
              "type": "string"
            },
            "crop": {
              "type": "object",
              "required": [
                "x",
                "y",
                "width",
                "height"
              ],
              "properties": {
                "x": {
                  "type": "number",
                  "minimum": 0
                },
                "y": {
                  "type": "number",
                  "minimum": 0
                },
                "width": {
                  "type": "number",
                  "minimum": 0
                },
                "height": {
                  "type": "number",
                  "minimum": 0
                },
                "svgId": {
                  "type": "string",
                  "maxLength": 100
                },
                "rotate": {
                  "type": "number",
                  "minimum": 0,
                  "maximum": 359,
                  "description": "Image rotation degrees"
                },
                "flip": {
                  "type": "string",
                  "enum": [
                    "x",
                    "y",
                    "xy",
                    "none"
                  ],
                  "default": "none",
                  "description": "Image flip value"
                }
              },
              "additionalProperties": false
            },
            "focalPoint": {
              "type": "object",
              "required": [
                "x",
                "y"
              ],
              "properties": {
                "x": {
                  "type": "number",
                  "minimum": 0
                },
                "y": {
                  "type": "number",
                  "minimum": 0
                }
              },
              "additionalProperties": false
            },
            "displayMode": {
              "type": "string",
              "enum": [
                "fill",
                "fit",
                "fitWidth"
              ],
              "default": "fill"
            },
            "scrollEffect": {
              "type": "string",
              "enum": [
                "parallax",
                "fixed",
                "zoomIn",
                "fadeIn",
                "none"
              ]
            },
            "clickAction": {
              "type": "string",
              "enum": [
                "none",
                "goToLink"
              ]
            }
          },
          "additionalProperties": false
        }
      },
      "mask": {
        "type": [
          "object",
          "null"
        ],
        "properties": {
          "x": {
            "type": "number",
            "minimum": 0,
            "maximum": 100
          },
          "y": {
            "type": "number",
            "minimum": 0,
            "maximum": 100
          },
          "width": {
            "type": "number",
            "minimum": 0,
            "maximum": 100
          },
          "height": {
            "type": "number",
            "minimum": 0,
            "maximum": 100
          },
          "svgId": {
            "type": "string"
          },
          "flip": {
            "type": "string",
            "enum": [
              "x",
              "y",
              "xy",
              "none"
            ]
          },
          "rotate": {
            "type": "number",
            "minimum": 0,
            "maximum": 360
          },
          "mode": {
            "type": "string",
            "enum": [
              "alpha",
              "luminance"
            ]
          }
        },
        "additionalProperties": false
      },
      "parallaxSpeed": {
        "type": "number"
      },
      "parallaxDirection": {
        "type": "string",
        "enum": [
          "normal",
          "reverse"
        ]
      },
      "hasAnimation": {
        "type": "boolean"
      }
    }
  },
  "Crop": {
    "type": "object",
    "required": [
      "x",
      "y",
      "width",
      "height"
    ],
    "properties": {
      "x": {
        "type": "number",
        "minimum": 0
      },
      "y": {
        "type": "number",
        "minimum": 0
      },
      "width": {
        "type": "number",
        "minimum": 0
      },
      "height": {
        "type": "number",
        "minimum": 0
      },
      "svgId": {
        "type": "string",
        "maxLength": 100
      },
      "rotate": {
        "type": "number",
        "minimum": 0,
        "maximum": 359,
        "description": "Image rotation degrees"
      },
      "flip": {
        "type": "string",
        "enum": [
          "x",
          "y",
          "xy",
          "none"
        ],
        "default": "none",
        "description": "Image flip value"
      }
    },
    "additionalProperties": false
  },
  "FocalPoint": {
    "type": "object",
    "required": [
      "x",
      "y"
    ],
    "properties": {
      "x": {
        "type": "number",
        "minimum": 0
      },
      "y": {
        "type": "number",
        "minimum": 0
      }
    },
    "additionalProperties": false
  },
  "LanguageSelector": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "direction": {
        "type": [
          "string"
        ],
        "enum": [
          "ltr",
          "rtl",
          "inherit"
        ],
        "description": "direction"
      }
    }
  },
  "wixui.MegaMenuContainerItem": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "default": "wixui.MegaMenuContainerItem",
        "maxLength": 120,
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      }
    }
  },
  "MenuData": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "direction": {
        "description": "direction of the component",
        "type": "string",
        "enum": [
          "ltr",
          "rtl",
          "inherit"
        ]
      },
      "itemDirection": {
        "description": "direction of the 1st (top) level menu items",
        "type": "string",
        "enum": [
          "ltr",
          "rtl",
          "inherit"
        ]
      },
      "submenuDirection": {
        "description": "direction of the 2nd level menu item (submenu)",
        "type": "string",
        "enum": [
          "ltr",
          "rtl",
          "inherit"
        ]
      },
      "submenuItemDirection": {
        "type": [
          "string"
        ],
        "enum": [
          "ltr",
          "rtl",
          "inherit"
        ],
        "description": "direction"
      },
      "submenuSubItemDirection": {
        "description": "direction of the 3rd level menu item (submenuSubItem)",
        "type": "string",
        "enum": [
          "ltr",
          "rtl",
          "inherit"
        ]
      },
      "navAriaLabel": {
        "type": "string",
        "maxLength": 1000
      },
      "menuRef": {
        "default": "#CUSTOM_MAIN_MENU",
        "type": [
          "null",
          "string"
        ]
      },
      "a11y": {
        "type": [
          "null",
          "string"
        ]
      }
    }
  },
  "wixui.MenuList": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "menus": {
        "default": [],
        "type": [
          "array"
        ],
        "items": [
          {
            "type": [
              "null",
              "string"
            ]
          }
        ]
      }
    }
  },
  "MusicPlayerData": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "direction": {
        "type": [
          "string"
        ],
        "enum": [
          "ltr",
          "rtl",
          "inherit"
        ],
        "description": "direction"
      },
      "coverDirection": {
        "type": [
          "string"
        ],
        "enum": [
          "ltr",
          "rtl",
          "inherit"
        ],
        "description": "direction"
      },
      "textDirection": {
        "type": [
          "string"
        ],
        "enum": [
          "ltr",
          "rtl",
          "inherit"
        ],
        "description": "direction"
      },
      "audioRef": {
        "type": [
          "null",
          "string"
        ]
      },
      "audioUrl": {
        "type": [
          "string",
          "null"
        ],
        "maxLength": 256
      },
      "playListId": {
        "type": [
          "string",
          "null"
        ],
        "maxLength": 255
      },
      "playlist": {
        "type": "array",
        "items": {
          "type": "object",
          "properties": {
            "artistName": {
              "type": "string",
              "maxLength": 255,
              "default": "Unknown Artist"
            },
            "trackName": {
              "type": "string",
              "maxLength": 255,
              "default": "Unknown Track"
            },
            "url": {
              "type": [
                "string",
                "null"
              ],
              "maxLength": 2500
            },
            "cover": {
              "type": [
                "string",
                "null"
              ],
              "maxLength": 2500
            },
            "durationFormatted": {
              "type": [
                "string",
                "null"
              ],
              "maxLength": 16
            }
          },
          "additionalProperties": false
        },
        "default": []
      },
      "coverRef": {
        "type": [
          "null",
          "string"
        ]
      },
      "coverUrl": {
        "type": [
          "string",
          "null"
        ]
      },
      "artistName": {
        "type": "string",
        "default": "Unknown Artist",
        "maxLength": 255
      },
      "trackName": {
        "type": "string",
        "default": "Unknown Track",
        "maxLength": 255
      },
      "description": {
        "type": "string",
        "default": "",
        "maxLength": 1000
      }
    }
  },
  "WixAudio": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "uri": {
        "type": "string",
        "default": ""
      },
      "title": {
        "type": "string",
        "default": "",
        "maxLength": 100
      },
      "duration": {
        "type": "number"
      }
    }
  },
  "Pagination": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "totalPages": {
        "type": "number",
        "description": "The total number of pages displayed by the component"
      },
      "currentPage": {
        "type": "number",
        "default": 1,
        "description": "The the page number marked as current"
      },
      "nextText": {
        "type": "string",
        "default": "Next",
        "maxLength": 400,
        "description": "Text to appear in NEXT button"
      },
      "previousText": {
        "type": "string",
        "default": "Previous",
        "maxLength": 400,
        "description": "Text to appear in PREVIOUS button"
      },
      "firstText": {
        "type": "string",
        "default": "First",
        "maxLength": 400,
        "description": "Text to appear in FIRST button"
      },
      "lastText": {
        "type": "string",
        "default": "Last",
        "maxLength": 400,
        "description": "Text to appear in LAST button"
      },
      "nextAriaLabel": {
        "type": "string",
        "maxLength": 400,
        "description": "Accessible name for the NEXT button"
      },
      "previousAriaLabel": {
        "type": "string",
        "maxLength": 400,
        "description": "Accessible name for the PREVIOUS button"
      },
      "firstAriaLabel": {
        "type": "string",
        "maxLength": 400,
        "description": "Accessible name for the FIRST button"
      },
      "lastAriaLabel": {
        "type": "string",
        "maxLength": 400,
        "description": "Accessible name for the LAST button"
      },
      "direction": {
        "type": [
          "string"
        ],
        "enum": [
          "ltr",
          "rtl",
          "inherit"
        ],
        "description": "direction"
      },
      "a11y": {
        "type": [
          "null",
          "string"
        ]
      }
    }
  },
  "PaginationA11y": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "label": {
        "type": "string",
        "maxLength": 1000
      }
    }
  },
  "ProgressBar": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "value": {
        "type": "number",
        "description": "Current progress value"
      },
      "targetValue": {
        "type": "number",
        "default": 100,
        "description": "Progress target value to be defined as complete"
      },
      "label": {
        "type": "string",
        "maxLength": 1000
      },
      "direction": {
        "type": [
          "string"
        ],
        "enum": [
          "ltr",
          "rtl",
          "inherit"
        ],
        "description": "direction"
      },
      "labelDirection": {
        "type": [
          "string"
        ],
        "enum": [
          "ltr",
          "rtl",
          "inherit"
        ],
        "description": "direction"
      },
      "barDirection": {
        "type": [
          "string"
        ],
        "enum": [
          "ltr",
          "rtl",
          "inherit"
        ],
        "description": "direction"
      }
    }
  },
  "RatingsDisplay": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "direction": {
        "type": [
          "string"
        ],
        "enum": [
          "ltr",
          "rtl",
          "inherit"
        ],
        "description": "direction"
      },
      "labelDirection": {
        "type": [
          "string"
        ],
        "enum": [
          "ltr",
          "rtl",
          "inherit"
        ],
        "description": "direction"
      },
      "ratingsDirection": {
        "type": [
          "string"
        ],
        "enum": [
          "ltr",
          "rtl",
          "inherit"
        ],
        "description": "direction"
      },
      "rating": {
        "type": "number",
        "description": "The rating displayed by the component",
        "minimum": 1,
        "maximum": 5
      },
      "svgId": {
        "type": "string",
        "maxLength": 100
      },
      "numRatings": {
        "type": "number",
        "description": "The amount of ratings the rating is based on",
        "minimum": 0
      },
      "reviewsCountLabel": {
        "type": "string",
        "default": "Reviews",
        "maxLength": 400,
        "description": "Text that describes the numRatings value"
      },
      "noReviewsPlaceholder": {
        "type": "string",
        "default": "Be the first to rate this item",
        "maxLength": 1000,
        "description": "Placeholder text when there aren't any reviews"
      }
    }
  },
  "RatingsInput": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "value": {
        "type": [
          "number",
          "null"
        ],
        "description": "The rating value currently selected",
        "minimum": 0,
        "maximum": 5
      },
      "titleText": {
        "type": "string",
        "description": "the title before a value is selected",
        "maxLength": 300
      },
      "svgId": {
        "type": "string",
        "description": "the id of the svg that illustrates the rating",
        "maxLength": 100
      },
      "labels": {
        "type": "object",
        "description": "contains the labels for the different values. maps 1-5 as keys to strings",
        "default": {
          "1": "Bad",
          "2": "Fine",
          "3": "OK",
          "4": "Good",
          "5": "Great"
        },
        "additionalProperties": {
          "type": [
            "string",
            "number"
          ]
        }
      },
      "direction": {
        "type": [
          "string"
        ],
        "enum": [
          "ltr",
          "rtl",
          "inherit"
        ],
        "description": "direction"
      }
    }
  },
  "wixui.RichContentViewer": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "content": {
        "type": "object"
      },
      "trimEnabled": {
        "type": "boolean",
        "default": false
      },
      "trimMode": {
        "type": "string",
        "default": "paragraph",
        "maxLength": 100
      },
      "trimLengthParagraph": {
        "type": "number",
        "default": 3
      },
      "trimLengthWord": {
        "type": "number",
        "default": 10
      },
      "trimExclude": {
        "type": "string",
        "default": "plugins",
        "maxLength": 100
      },
      "trimEllipsisEnabled": {
        "type": "boolean",
        "default": true
      },
      "trimEllipsisExpandText": {
        "type": "string",
        "default": "Show More",
        "maxLength": 1200
      },
      "trimEllipsisCollapseText": {
        "type": "string",
        "default": "Show Less",
        "maxLength": 1200
      }
    }
  },
  "RichTextBox": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "maxLength": {
        "type": [
          "number",
          "null"
        ],
        "description": "maximum number of characters allowed"
      },
      "direction": {
        "type": [
          "string"
        ],
        "enum": [
          "ltr",
          "rtl",
          "inherit"
        ],
        "description": "direction"
      },
      "labelDirection": {
        "type": [
          "string"
        ],
        "enum": [
          "ltr",
          "rtl",
          "inherit"
        ],
        "description": "direction"
      },
      "inputDirection": {
        "type": [
          "string"
        ],
        "enum": [
          "ltr",
          "rtl",
          "inherit"
        ],
        "description": "direction"
      },
      "value": {
        "type": "string",
        "default": "",
        "maxLength": 4000
      },
      "name": {
        "type": "string",
        "maxLength": 400
      },
      "formGroup": {
        "type": "string",
        "description": "form group that this component belongs to",
        "maxLength": 4000
      }
    }
  },
  "SearchBox": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "placeholder": {
        "type": "string",
        "default": "Search...",
        "maxLength": 255
      },
      "suggestionsEnabled": {
        "type": "boolean",
        "default": true,
        "description": "Determines whether the suggestions disabled or not"
      },
      "clearButtonText": {
        "type": "string",
        "default": "Clear",
        "maxLength": 255
      },
      "displaySettingsToggles": {
        "type": "boolean",
        "default": true,
        "description": "Determines whether the settings toggles are displayed or not"
      }
    }
  },
  "Section": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "a11y": {
        "type": [
          "null",
          "string"
        ]
      }
    }
  },
  "SectionA11y": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "tabindex": {
        "type": "number",
        "minimum": -1,
        "maximum": 0
      },
      "label": {
        "type": "string",
        "maxLength": 1000
      },
      "live": {
        "type": "string",
        "enum": [
          "polite",
          "assertive"
        ]
      },
      "role": {
        "type": "string",
        "enum": [
          "heading",
          "alert",
          "status"
        ]
      },
      "atomic": {
        "type": "boolean"
      },
      "hidden": {
        "type": "boolean"
      },
      "current": {
        "type": "string",
        "enum": [
          "step",
          "page",
          "true",
          "false",
          "location",
          "date",
          "time"
        ]
      },
      "level": {
        "type": "number",
        "minimum": 1,
        "maximum": 6
      }
    }
  },
  "wixui.SelectableContainer": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      }
    }
  },
  "wixui.SelectableContainerInput": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      }
    }
  },
  "SelectionTagsList": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "options": {
        "description": "Array of items which behave like checkboxes and look similar to buttons",
        "default": [],
        "type": [
          "array"
        ],
        "items": [
          {
            "type": [
              "null",
              "string"
            ]
          }
        ]
      },
      "value": {
        "description": "Array with the values of the selected options",
        "type": "array",
        "items": {
          "type": "string"
        }
      },
      "direction": {
        "type": [
          "string"
        ],
        "enum": [
          "ltr",
          "rtl",
          "inherit"
        ],
        "description": "direction"
      },
      "labelDirection": {
        "type": [
          "string"
        ],
        "enum": [
          "ltr",
          "rtl",
          "inherit"
        ],
        "description": "direction"
      },
      "inputDirection": {
        "type": [
          "string"
        ],
        "enum": [
          "ltr",
          "rtl",
          "inherit"
        ],
        "description": "direction"
      }
    }
  },
  "SelectionTag": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "value": {
        "type": "string",
        "maxLength": 400
      },
      "label": {
        "type": "string",
        "maxLength": 400
      },
      "link": {
        "type": [
          "null",
          "string"
        ]
      },
      "rel": {
        "type": "string",
        "enum": [
          "nofollow"
        ]
      }
    }
  },
  "SignatureInput": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "titleText": {
        "type": "string",
        "description": "The title of the field",
        "maxLength": 400
      },
      "clearButtonText": {
        "type": "string",
        "description": "The undo signature text",
        "minLength": 1,
        "maxLength": 400
      },
      "direction": {
        "type": [
          "string"
        ],
        "enum": [
          "ltr",
          "rtl",
          "inherit"
        ],
        "description": "direction"
      },
      "labelDirection": {
        "type": [
          "string"
        ],
        "enum": [
          "ltr",
          "rtl",
          "inherit"
        ],
        "description": "direction"
      },
      "inputDirection": {
        "type": [
          "string"
        ],
        "enum": [
          "ltr",
          "rtl",
          "inherit"
        ],
        "description": "direction"
      },
      "buttonDirection": {
        "type": [
          "string"
        ],
        "enum": [
          "ltr",
          "rtl",
          "inherit"
        ],
        "description": "direction"
      },
      "radioButtonsDirection": {
        "type": [
          "string"
        ],
        "enum": [
          "ltr",
          "rtl",
          "inherit"
        ],
        "description": "direction"
      }
    }
  },
  "SiteButtonData": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "direction": {
        "description": "direction of the component",
        "type": "string",
        "enum": [
          "ltr",
          "rtl",
          "inherit"
        ]
      },
      "link": {
        "pattern": "^$|^#",
        "type": [
          "null",
          "string"
        ]
      },
      "label": {
        "type": "string",
        "default": "MY BUTTON"
      },
      "a11y": {
        "type": [
          "null",
          "string"
        ]
      }
    }
  },
  "Slider": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "direction": {
        "type": [
          "string"
        ],
        "enum": [
          "ltr",
          "rtl",
          "inherit"
        ],
        "description": "direction"
      },
      "labelDirection": {
        "type": [
          "string"
        ],
        "enum": [
          "ltr",
          "rtl",
          "inherit"
        ],
        "description": "direction"
      },
      "trackDirection": {
        "type": [
          "string"
        ],
        "enum": [
          "ltr",
          "rtl",
          "inherit"
        ],
        "description": "direction"
      },
      "tooltipDirection": {
        "type": [
          "string"
        ],
        "enum": [
          "ltr",
          "rtl",
          "inherit"
        ],
        "description": "direction"
      },
      "min": {
        "type": "number",
        "default": 0,
        "description": "Minimum value"
      },
      "max": {
        "type": "number",
        "default": 100,
        "description": "Maximum value"
      },
      "value": {
        "type": "number",
        "default": 50,
        "description": "Current value"
      },
      "step": {
        "type": "number",
        "default": 0,
        "description": "Step value"
      },
      "stepType": {
        "type": "string",
        "default": "value",
        "enum": [
          "value",
          "count"
        ],
        "description": "When set to 'value', step represents the value of each step. When set to 'count', step represents the total steps count"
      },
      "disabled": {
        "type": "boolean",
        "default": false,
        "description": "Determines whether the slider is disabled or not"
      },
      "readOnly": {
        "type": "boolean",
        "default": false,
        "description": "Determines whether the slider is read-only or not"
      },
      "label": {
        "type": [
          "null",
          "string"
        ],
        "description": "Label text",
        "maxLength": 1200
      }
    }
  },
  "wixui.Slideshow": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "default": "wixui.Slideshow",
        "maxLength": 120,
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "direction": {
        "enum": [
          "ltr",
          "rtl",
          "inherit"
        ],
        "type": "string"
      }
    }
  },
  "SocialAuth": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      }
    }
  },
  "StylableButton": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "link": {
        "type": [
          "null",
          "string"
        ]
      },
      "label": {
        "type": "string",
        "default": "MY BUTTON",
        "maxLength": 1200
      },
      "svgId": {
        "type": "string",
        "default": "",
        "maxLength": 100
      },
      "isIconAnimated": {
        "type": "boolean"
      },
      "animatedIcon": {
        "type": "object",
        "properties": {
          "svgIdAnimationSelected": {
            "type": "string",
            "maxLength": 100
          },
          "customAnimatedIcon": {
            "type": [
              "object"
            ],
            "properties": {
              "svgIdAnimationStart": {
                "type": "string",
                "maxLength": 100
              },
              "svgIdAnimationEnd": {
                "type": "string",
                "maxLength": 100
              },
              "svgIdAnimationSelected": {
                "type": "string",
                "maxLength": 100
              }
            },
            "additionalProperties": false
          },
          "animationDuration": {
            "type": "number"
          }
        },
        "additionalProperties": false
      },
      "a11y": {
        "type": [
          "null",
          "string"
        ]
      },
      "direction": {
        "type": [
          "string"
        ],
        "enum": [
          "ltr",
          "rtl",
          "inherit"
        ],
        "description": "direction"
      }
    }
  },
  "StylableButtonA11y": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "tabindex": {
        "type": "number",
        "minimum": -1,
        "maximum": 0
      },
      "pressed": {
        "type": "boolean"
      },
      "expanded": {
        "type": "boolean"
      },
      "disabled": {
        "type": "boolean"
      },
      "haspopup": {
        "type": "string",
        "enum": [
          "true",
          "false",
          "dialog",
          "menu"
        ]
      },
      "label": {
        "type": "string",
        "maxLength": 1000
      },
      "live": {
        "type": "string",
        "enum": [
          "polite",
          "assertive"
        ]
      }
    }
  },
  "Submenu": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "direction": {
        "type": [
          "string"
        ],
        "enum": [
          "ltr",
          "rtl",
          "inherit"
        ],
        "description": "direction"
      },
      "itemDirection": {
        "type": [
          "string"
        ],
        "enum": [
          "ltr",
          "rtl",
          "inherit"
        ],
        "description": "direction"
      },
      "subItemDirection": {
        "type": [
          "string"
        ],
        "enum": [
          "ltr",
          "rtl",
          "inherit"
        ],
        "description": "direction"
      }
    },
    "required": [
      "direction"
    ]
  },
  "SvgImage": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "decorative": {
        "type": "boolean"
      },
      "alt": {
        "type": "string",
        "description": "Alternative text for the vector image (for accessibility purposes).",
        "maxLength": 120
      },
      "displayMode": {
        "type": "string",
        "enum": [
          "fit",
          "stretch"
        ],
        "description": "should the shape maintain it's aspect ratio or stretch",
        "default": "fit"
      },
      "svgId": {
        "type": "string",
        "maxLength": 100,
        "description": "Identifier for the SVG image."
      },
      "link": {
        "description": "Reference to a link associated with the vector image.",
        "pattern": "^$|^#",
        "type": [
          "null",
          "string"
        ]
      }
    },
    "required": [
      "svgId"
    ]
  },
  "wixui.Tabs": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "tabIds": {
        "type": "array",
        "items": {
          "type": "string",
          "maxLength": 120
        }
      },
      "defaultTabId": {
        "type": "string",
        "default": "",
        "maxLength": 120
      },
      "a11y": {
        "type": [
          "null",
          "string"
        ]
      },
      "direction": {
        "type": [
          "string"
        ],
        "enum": [
          "ltr",
          "rtl",
          "inherit"
        ],
        "description": "direction"
      }
    }
  },
  "TabsA11y": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "tabindex": {
        "type": "number",
        "minimum": -1,
        "maximum": 0
      },
      "label": {
        "type": "string",
        "maxLength": 1000
      }
    }
  },
  "TextEffectsSharedData": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "text": {
        "type": "string",
        "maxLength": 500
      },
      "link": {
        "pattern": "^$|^#",
        "type": [
          "null",
          "string"
        ]
      },
      "isDecorative": {
        "type": "boolean"
      },
      "tagName": {
        "type": "string",
        "enum": [
          "h1",
          "h2",
          "h3",
          "h4",
          "h5",
          "h6",
          "blockquote",
          "div",
          "p"
        ],
        "default": "div"
      },
      "textDirection": {
        "type": [
          "string"
        ],
        "enum": [
          "ltr",
          "rtl",
          "inherit"
        ],
        "description": "direction",
        "default": "inherit"
      },
      "patternScope": {
        "type": "string",
        "enum": [
          "none",
          "character",
          "word"
        ],
        "default": "none"
      }
    }
  },
  "TextMarqueeData": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "movementDirection": {
        "type": "string",
        "description": "direction the text is moving to",
        "default": "rtl",
        "enum": [
          "rtl",
          "ltr"
        ]
      },
      "speed": {
        "type": "number",
        "description": "speed of the animation in pixels per second"
      },
      "pauseOnHover": {
        "type": "boolean",
        "description": "pause animation on hover"
      },
      "textDirection": {
        "type": "string",
        "default": "ltr",
        "enum": [
          "ltr",
          "rtl"
        ]
      },
      "headingLevel": {
        "type": "number",
        "maximum": 6,
        "minimum": 0,
        "description": "Heading level to wrap the component (deprecated)"
      },
      "isDecorative": {
        "type": "boolean"
      },
      "tagName": {
        "type": "string",
        "enum": [
          "h1",
          "h2",
          "h3",
          "h4",
          "h5",
          "h6",
          "blockquote",
          "div",
          "p"
        ],
        "description": "Semantic tag name to wrap the component"
      },
      "svgId": {
        "type": "string"
      },
      "items": {
        "default": [],
        "description": "array of marquee items",
        "type": [
          "array"
        ],
        "items": [
          {
            "type": [
              "null",
              "string"
            ]
          }
        ]
      }
    },
    "required": [
      "items",
      "speed"
    ]
  },
  "TextMarqueeItem": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "link": {
        "pattern": "^$|^#",
        "type": [
          "null",
          "string"
        ]
      },
      "text": {
        "type": "string",
        "maxLength": 500
      }
    },
    "required": [
      "text"
    ]
  },
  "TextFxData": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "text": {
        "type": "string",
        "maxLength": 450
      },
      "headingLevel": {
        "type": "number",
        "minimum": 0,
        "maximum": 6,
        "description": "Heading level to wrap the component (deprecated)"
      },
      "isDecorative": {
        "type": "boolean"
      },
      "direction": {
        "type": "string",
        "enum": [
          "ltr",
          "rtl"
        ],
        "default": "ltr"
      },
      "link": {
        "pattern": "^$|^#",
        "type": [
          "null",
          "string"
        ]
      },
      "tagName": {
        "type": "string",
        "enum": [
          "h1",
          "h2",
          "h3",
          "h4",
          "h5",
          "h6",
          "blockquote",
          "div",
          "p"
        ],
        "description": "Semantic tag name to wrap the component"
      }
    }
  },
  "TextOnPathData": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "isDecorative": {
        "type": "boolean"
      },
      "text": {
        "type": "string",
        "description": "text",
        "maxLength": 500
      },
      "path": {
        "type": "string",
        "description": "path"
      },
      "pathLength": {
        "type": "number",
        "description": "Path length"
      },
      "viewBox": {
        "type": "string",
        "description": "View box"
      },
      "speed": {
        "type": "number",
        "description": "Speed",
        "default": 3
      },
      "movementDirection": {
        "type": "string",
        "description": "Direction the text is moving to",
        "default": "forward",
        "enum": [
          "forward",
          "reverse"
        ]
      },
      "pauseOnHover": {
        "type": "boolean",
        "description": "Pause animation on hover"
      },
      "direction": {
        "type": "string",
        "default": "ltr",
        "enum": [
          "ltr",
          "rtl"
        ]
      },
      "tagName": {
        "type": "string",
        "enum": [
          "h1",
          "h2",
          "h3",
          "h4",
          "h5",
          "h6",
          "blockquote",
          "div"
        ],
        "description": "Semantic tag name to wrap the component"
      },
      "fillMode": {
        "type": "string",
        "enum": [
          "normal",
          "repeat",
          "justify"
        ],
        "default": "normal",
        "description": "How the text should be rendered on the path"
      },
      "link": {
        "description": "Reference to a link associated with the vector image.",
        "pattern": "^$|^#",
        "type": [
          "null",
          "string"
        ]
      },
      "startOffset": {
        "type": "number",
        "description": "Starting point of the text on the path",
        "minimum": 0,
        "maximum": 100
      },
      "fontSize": {
        "type": "number",
        "description": "Font size as a number in percent",
        "minimum": 0,
        "maximum": 100
      },
      "pathStrokeWidth": {
        "type": "number",
        "description": "Width of the path stroke in em units",
        "minimum": 0,
        "maximum": 3
      }
    }
  },
  "TextParticlesData": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "text": {
        "default": "TextParticles",
        "maxLength": 500,
        "type": "string"
      },
      "textDirection": {
        "type": [
          "string"
        ],
        "enum": [
          "ltr",
          "rtl",
          "inherit"
        ],
        "description": "direction",
        "default": "inherit"
      },
      "tagName": {
        "type": "string",
        "enum": [
          "h1",
          "h2",
          "h3",
          "h4",
          "h5",
          "h6",
          "blockquote",
          "div",
          "p"
        ],
        "default": "div"
      },
      "link": {
        "pattern": "^$|^#",
        "type": [
          "null",
          "string"
        ]
      },
      "isDecorative": {
        "type": "boolean"
      }
    }
  },
  "TimePickerData": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "direction": {
        "type": [
          "string"
        ],
        "enum": [
          "ltr",
          "rtl",
          "inherit"
        ],
        "description": "direction"
      },
      "labelDirection": {
        "type": [
          "string"
        ],
        "enum": [
          "ltr",
          "rtl",
          "inherit"
        ],
        "description": "direction"
      },
      "inputDirection": {
        "type": [
          "string"
        ],
        "enum": [
          "ltr",
          "rtl",
          "inherit"
        ],
        "description": "direction"
      },
      "placeholder": {
        "type": "string",
        "description": "The value of the placeholder if chosen",
        "maxLength": 1000
      },
      "step": {
        "type": "number",
        "minimum": 1,
        "maximum": 60,
        "default": 1,
        "description": "Increment step in minutes"
      },
      "label": {
        "type": "string",
        "maxLength": 1000
      },
      "margin": {
        "type": "number",
        "minimum": 1,
        "maximum": 30,
        "description": "Time picker layout label margin"
      },
      "disabledTimes": {
        "type": "array",
        "items": {
          "type": "object",
          "additionalProperties": false,
          "required": [
            "startTime",
            "endTime"
          ],
          "properties": {
            "startTime": {
              "type": "string",
              "maxLength": 100
            },
            "endTime": {
              "type": "string",
              "maxLength": 100
            }
          }
        },
        "default": [],
        "maxItems": 5,
        "description": "array of disabled times"
      },
      "value": {
        "type": "string",
        "default": "",
        "maxLength": 4000
      },
      "name": {
        "type": "string",
        "maxLength": 400
      },
      "formGroup": {
        "type": "string",
        "description": "form group that this component belongs to",
        "maxLength": 4000
      }
    }
  },
  "ToggleSwitch": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "checked": {
        "type": "boolean",
        "description": "The checked status of the input"
      },
      "direction": {
        "type": [
          "string"
        ],
        "enum": [
          "ltr",
          "rtl",
          "inherit"
        ],
        "description": "direction"
      },
      "value": {
        "type": "string",
        "default": "",
        "maxLength": 4000
      },
      "name": {
        "type": "string",
        "maxLength": 400
      },
      "formGroup": {
        "type": "string",
        "description": "form group that this component belongs to",
        "maxLength": 4000
      }
    }
  },
  "UnsupportedComponentData": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "migratedFrom": {
        "type": "string"
      }
    }
  },
  "VideoPlayer": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "videoType": {
        "type": "string",
        "enum": [
          "dailymotion",
          "facebook",
          "file",
          "twitch",
          "vimeo",
          "youtube"
        ],
        "default": "file"
      },
      "videoRef": {
        "type": [
          "null",
          "string"
        ]
      },
      "videoUrl": {
        "type": [
          "string",
          "null"
        ],
        "maxLength": 256
      },
      "posterUrl": {
        "type": [
          "string",
          "null"
        ]
      },
      "videoTitle": {
        "type": "string",
        "default": "",
        "maxLength": 255
      },
      "description": {
        "type": "string",
        "default": "",
        "maxLength": 1000,
        "description": "Video Description"
      },
      "logoRef": {
        "type": [
          "null",
          "string"
        ]
      }
    }
  },
  "dsgnsys.ControlTypes": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "shortString": {
        "default": "ShortString",
        "maxLength": 120,
        "type": "string"
      },
      "longString": {
        "default": "LongString",
        "maxLength": 1200,
        "type": "string"
      },
      "options": {
        "default": [],
        "type": [
          "array"
        ],
        "items": [
          {
            "type": [
              "null",
              "string"
            ]
          }
        ]
      },
      "dropdown": {
        "default": "Options 1",
        "enum": [
          "Options 1",
          "Options 2",
          "Options 3",
          "Options 4"
        ],
        "type": "string"
      },
      "radioButtons": {
        "default": "Options 1",
        "enum": [
          "Options 1",
          "Options 2",
          "Options 3",
          "Options 4"
        ],
        "type": "string"
      },
      "toggleSwitch": {
        "default": false,
        "type": "boolean"
      },
      "thumbnails": {
        "type": [
          "null",
          "string"
        ]
      },
      "link": {
        "pattern": "^$|^#",
        "type": [
          "null",
          "string"
        ]
      },
      "slider": {
        "default": 1,
        "minimum": 0,
        "maximum": 2,
        "type": "number",
        "multipleOf": 1
      },
      "numericInput": {
        "default": 0,
        "type": "number"
      },
      "colorPickerInput": {
        "default": "#EEE",
        "maxLength": 120000,
        "type": "string"
      },
      "selectedFont": {
        "default": "arial",
        "maxLength": 1200,
        "format": "font-family",
        "type": "string"
      }
    }
  },
  "dsgnsys.DashboardButton": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "label": {
        "default": "Save",
        "maxLength": 120,
        "type": "string"
      },
      "link": {
        "pattern": "^$|^#",
        "type": [
          "null",
          "string"
        ]
      },
      "skin": {
        "default": "Standard",
        "enum": [
          "Standard",
          "Light",
          "Destructive",
          "Premium",
          "Premium light",
          "Dark",
          "Transparent"
        ],
        "type": "string"
      },
      "showPrefix": {
        "default": false,
        "type": "boolean"
      },
      "prefixIcon": {
        "type": [
          "null",
          "string"
        ]
      },
      "showSuffix": {
        "default": false,
        "type": "boolean"
      },
      "suffixIcon": {
        "type": [
          "null",
          "string"
        ]
      },
      "disabled": {
        "default": false,
        "type": "boolean"
      },
      "size": {
        "default": "Medium",
        "enum": [
          "Tiny",
          "Small",
          "Medium",
          "Large"
        ],
        "type": "string"
      },
      "priority": {
        "default": "Primary",
        "enum": [
          "Primary",
          "Secondary"
        ],
        "type": "string"
      }
    },
    "required": [
      "label"
    ]
  },
  "dsgnsys.DashboardHeading": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "text": {
        "default": "Add Page title H1",
        "maxLength": 1200,
        "type": "string"
      },
      "size": {
        "default": "Page title H1",
        "enum": [
          "Page title H1",
          "Modal title H2",
          "Card title H3",
          "Section title H4",
          "Card section title H5",
          "Caption H6"
        ],
        "type": "string"
      },
      "invertColor": {
        "default": false,
        "type": "boolean"
      },
      "textAlignment": {
        "default": "Left",
        "enum": [
          "Left",
          "Center",
          "Right"
        ],
        "type": "string"
      }
    }
  },
  "dsgnsys.DashboardIconButton": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "icon": {
        "type": [
          "null",
          "string"
        ]
      },
      "tooltip": {
        "default": "More Actions",
        "maxLength": 120,
        "type": "string"
      },
      "link": {
        "pattern": "^$|^#",
        "type": [
          "null",
          "string"
        ]
      },
      "skin": {
        "default": "Standard",
        "enum": [
          "Standard",
          "Premium",
          "Light",
          "Transparent"
        ],
        "type": "string"
      },
      "disabled": {
        "default": false,
        "type": "boolean"
      },
      "size": {
        "default": "Medium",
        "enum": [
          "Tiny",
          "Small",
          "Medium",
          "Large"
        ],
        "type": "string"
      },
      "priority": {
        "default": "Secondary",
        "enum": [
          "Primary",
          "Secondary"
        ],
        "type": "string"
      }
    }
  },
  "dsgnsys.DashboardInfoIcon": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "tooltip": {
        "default": "This message explains the purpose of a feature.",
        "maxLength": 1200,
        "type": "string"
      },
      "addLink": {
        "default": false,
        "type": "boolean"
      },
      "tooltipLinkText": {
        "default": "Learn more",
        "maxLength": 120,
        "type": "string"
      },
      "tooltipLink": {
        "pattern": "^$|^#",
        "type": [
          "null",
          "string"
        ]
      },
      "size": {
        "default": "Medium",
        "enum": [
          "Small",
          "Medium"
        ],
        "type": "string"
      }
    }
  },
  "dsgnsys.DashboardInput": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "label": {
        "default": "Event name",
        "maxLength": 120,
        "type": "string"
      },
      "placeholder": {
        "default": "Enter your event name...",
        "maxLength": 120,
        "type": "string"
      },
      "value": {
        "default": "",
        "maxLength": 120,
        "type": "string"
      },
      "showTooltip": {
        "default": false,
        "type": "boolean"
      },
      "tooltip": {
        "default": "This message explains the purpose of a field.",
        "maxLength": 1200,
        "type": "string"
      },
      "showPrefix": {
        "default": false,
        "type": "boolean"
      },
      "prefixType": {
        "default": "Icon",
        "enum": [
          "Icon",
          "Text"
        ],
        "type": "string"
      },
      "prefixIcon": {
        "type": [
          "null",
          "string"
        ]
      },
      "prefixValue": {
        "default": "Units",
        "maxLength": 120,
        "type": "string"
      },
      "showSuffix": {
        "default": false,
        "type": "boolean"
      },
      "suffixType": {
        "default": "Icon",
        "enum": [
          "Icon",
          "Text"
        ],
        "type": "string"
      },
      "suffixIcon": {
        "type": [
          "null",
          "string"
        ]
      },
      "suffixValue": {
        "default": ".com",
        "maxLength": 120,
        "type": "string"
      },
      "required": {
        "default": false,
        "type": "boolean"
      },
      "setMaxLength": {
        "default": false,
        "type": "boolean"
      },
      "maxLength": {
        "default": 20,
        "type": "number",
        "multipleOf": 1
      },
      "disabled": {
        "default": false,
        "type": "boolean"
      },
      "readOnly": {
        "default": false,
        "type": "boolean"
      },
      "size": {
        "default": "Medium",
        "enum": [
          "Small",
          "Medium",
          "Large"
        ],
        "type": "string"
      },
      "border": {
        "default": "Default",
        "enum": [
          "Default",
          "Round",
          "Line",
          "None"
        ],
        "type": "string"
      },
      "labelPosition": {
        "default": "Top",
        "enum": [
          "Top",
          "Left",
          "Right"
        ],
        "type": "string"
      }
    }
  },
  "dsgnsys.DashboardNumberInput": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "label": {
        "default": "Number of tickets",
        "maxLength": 120,
        "type": "string"
      },
      "placeholder": {
        "default": "Enter a number...",
        "maxLength": 120,
        "type": "string"
      },
      "value": {
        "default": 25,
        "type": "number",
        "multipleOf": 1
      },
      "showTooltip": {
        "default": false,
        "type": "boolean"
      },
      "tooltip": {
        "default": "This message explains the purpose of a field.",
        "maxLength": 1200,
        "type": "string"
      },
      "showPrefix": {
        "default": false,
        "type": "boolean"
      },
      "prefixType": {
        "default": "Icon",
        "enum": [
          "Icon",
          "Text"
        ],
        "type": "string"
      },
      "prefixIcon": {
        "type": [
          "null",
          "string"
        ]
      },
      "prefixValue": {
        "default": "Units",
        "maxLength": 120,
        "type": "string"
      },
      "showSuffix": {
        "default": false,
        "type": "boolean"
      },
      "suffixType": {
        "default": "Icon",
        "enum": [
          "Icon",
          "Text"
        ],
        "type": "string"
      },
      "suffixIcon": {
        "type": [
          "null",
          "string"
        ]
      },
      "suffixValue": {
        "default": "%",
        "maxLength": 120,
        "type": "string"
      },
      "required": {
        "default": false,
        "type": "boolean"
      },
      "minAndMaxValues": {
        "default": false,
        "type": "boolean"
      },
      "min": {
        "default": 0,
        "type": "number",
        "multipleOf": 1
      },
      "max": {
        "default": 100,
        "type": "number",
        "multipleOf": 1
      },
      "stepSize": {
        "default": 1,
        "type": "number",
        "multipleOf": 1
      },
      "disabled": {
        "default": false,
        "type": "boolean"
      },
      "readOnly": {
        "default": false,
        "type": "boolean"
      },
      "size": {
        "default": "Medium",
        "enum": [
          "Small",
          "Medium",
          "Large"
        ],
        "type": "string"
      },
      "border": {
        "default": "Default",
        "enum": [
          "Default",
          "Round",
          "Line",
          "None"
        ],
        "type": "string"
      },
      "labelPlacement": {
        "default": "Top",
        "enum": [
          "Top",
          "Left",
          "Right"
        ],
        "type": "string"
      }
    }
  },
  "dsgnsys.DashboardText": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "text": {
        "default": "I’m a paragraph. Add your own text and edit me in settings. It’s easy.",
        "maxLength": 1200,
        "type": "string"
      },
      "preset": {
        "default": "Standard",
        "enum": [
          "Standard",
          "Standard secondary",
          "Light",
          "Light secondary",
          "Success",
          "Destructive",
          "Primary",
          "Premium",
          "Disabled"
        ],
        "type": "string"
      },
      "size": {
        "default": "Medium",
        "enum": [
          "Tiny",
          "Small",
          "Medium"
        ],
        "type": "string"
      },
      "weight": {
        "default": "Thin",
        "enum": [
          "Bold",
          "Normal",
          "Thin"
        ],
        "type": "string"
      },
      "textAlignment": {
        "default": "Left",
        "enum": [
          "Left",
          "Center",
          "Right"
        ],
        "type": "string"
      },
      "overflow": {
        "default": "Wrap",
        "enum": [
          "Wrap",
          "Ellipsis"
        ],
        "type": "string"
      },
      "maxLines": {
        "default": 1,
        "minimum": 1,
        "type": "number",
        "multipleOf": 1
      }
    }
  },
  "dsgnsys.DashboardTextButton": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "label": {
        "default": "View All",
        "maxLength": 120,
        "type": "string"
      },
      "link": {
        "pattern": "^$|^#",
        "type": [
          "null",
          "string"
        ]
      },
      "skin": {
        "default": "Standard",
        "enum": [
          "Standard",
          "Premium",
          "Light",
          "Dark",
          "Destructive"
        ],
        "type": "string"
      },
      "showPrefix": {
        "default": false,
        "type": "boolean"
      },
      "prefixIcon": {
        "type": [
          "null",
          "string"
        ]
      },
      "showSuffix": {
        "default": false,
        "type": "boolean"
      },
      "suffixIcon": {
        "type": [
          "null",
          "string"
        ]
      },
      "underline": {
        "default": "Never",
        "enum": [
          "Never",
          "On hover",
          "Always"
        ],
        "type": "string"
      },
      "disabled": {
        "default": false,
        "type": "boolean"
      },
      "size": {
        "default": "Medium",
        "enum": [
          "Tiny",
          "Small",
          "Medium"
        ],
        "type": "string"
      },
      "weight": {
        "default": "Regular",
        "enum": [
          "Regular",
          "Medium"
        ],
        "type": "string"
      }
    }
  },
  "dsgnsys.DashboardToggleSwitch": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "label": {
        "default": "Set a reminder",
        "maxLength": 120,
        "type": "string"
      },
      "checked": {
        "default": true,
        "type": "boolean"
      },
      "skin": {
        "default": "Standard",
        "enum": [
          "Standard",
          "Success",
          "Destructive"
        ],
        "type": "string"
      },
      "showTooltip": {
        "default": false,
        "type": "boolean"
      },
      "tooltip": {
        "default": "This message explains the purpose of a field.",
        "maxLength": 1200,
        "type": "string"
      },
      "disabled": {
        "default": false,
        "type": "boolean"
      },
      "size": {
        "default": "Large",
        "enum": [
          "Small",
          "Medium",
          "Large"
        ],
        "type": "string"
      },
      "labelPosition": {
        "default": "Right",
        "enum": [
          "Top",
          "Left",
          "Right"
        ],
        "type": "string"
      }
    }
  },
  "dsgnsys.SettingsPanelContainer": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "theme": {
        "default": "classic",
        "enum": [
          "classic",
          "responsive"
        ],
        "type": "string"
      },
      "debug": {
        "default": false,
        "type": "boolean"
      }
    }
  },
  "dsgnsys.WbuAccordion": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "label": {
        "default": "Label Example",
        "maxLength": 120,
        "type": "string"
      },
      "tooltip": {
        "default": "",
        "maxLength": 1200,
        "type": "string"
      },
      "openByDefault": {
        "default": false,
        "type": "boolean"
      }
    }
  },
  "dsgnsys.WbuBackButton": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "label": {
        "default": "Back",
        "maxLength": 120,
        "type": "string"
      }
    }
  },
  "dsgnsys.WbuButton": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "fieldTitle": {
        "default": "",
        "maxLength": 120,
        "type": "string"
      },
      "tooltipInfo": {
        "default": "",
        "maxLength": 1200,
        "type": "string"
      },
      "label": {
        "default": "Button",
        "maxLength": 120,
        "type": "string"
      },
      "skin": {
        "default": "standard",
        "enum": [
          "standard",
          "standard secondary",
          "premium",
          "premium secondary",
          "alert",
          "alert secondary",
          "inverted"
        ],
        "type": "string"
      },
      "size": {
        "default": "medium",
        "enum": [
          "small",
          "medium",
          "large"
        ],
        "type": "string"
      },
      "prefixIcon": {
        "type": [
          "null",
          "string"
        ]
      },
      "suffixIcon": {
        "type": [
          "null",
          "string"
        ]
      },
      "fullWidth": {
        "default": false,
        "type": "boolean"
      },
      "divider": {
        "default": "long",
        "enum": [
          "long",
          "short",
          "none"
        ],
        "type": "string"
      }
    }
  },
  "dsgnsys.WbuCheckboxGroup": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "fieldTitle": {
        "default": "Multiple Choices",
        "maxLength": 120,
        "type": "string"
      },
      "options": {
        "default": [],
        "type": [
          "array"
        ],
        "items": [
          {
            "type": [
              "null",
              "string"
            ]
          }
        ]
      },
      "tooltipInfo": {
        "default": "",
        "maxLength": 1200,
        "type": "string"
      },
      "divider": {
        "default": "long",
        "enum": [
          "long",
          "short",
          "none"
        ],
        "type": "string"
      }
    }
  },
  "dsgnsys.WbuColorPicker": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "label": {
        "default": "Opacity & Color",
        "maxLength": 120,
        "type": "string"
      },
      "tooltip": {
        "default": "",
        "maxLength": 1200,
        "type": "string"
      },
      "opacity": {
        "default": 100,
        "minimum": 0,
        "maximum": 100,
        "type": "number",
        "multipleOf": 1
      },
      "showPercentage": {
        "default": true,
        "type": "boolean"
      },
      "opacitySliderEnabled": {
        "default": true,
        "type": "boolean"
      },
      "color": {
        "default": "#EEE",
        "maxLength": 120000,
        "type": "string"
      },
      "divider": {
        "default": "long",
        "enum": [
          "long",
          "short",
          "none"
        ],
        "type": "string"
      }
    }
  },
  "dsgnsys.WbuColorSelector": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "label": {
        "default": "Color Selector",
        "maxLength": 120,
        "type": "string"
      },
      "color": {
        "default": "#EEE",
        "maxLength": 120000,
        "type": "string"
      },
      "divider": {
        "default": "long",
        "enum": [
          "long",
          "short",
          "none"
        ],
        "type": "string"
      }
    }
  },
  "dsgnsys.WbuColumnControllerControl": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "fieldTitle": {
        "default": "Column controller",
        "maxLength": 120,
        "type": "string"
      },
      "tooltipMessage": {
        "default": "",
        "maxLength": 1200,
        "type": "string"
      },
      "enableReorder": {
        "default": true,
        "type": "boolean"
      },
      "minimumValue": {
        "default": 1,
        "type": "number",
        "multipleOf": 1
      },
      "dividerType": {
        "default": "none",
        "enum": [
          "long",
          "short",
          "none"
        ],
        "type": "string"
      },
      "columns": {
        "default": [],
        "type": [
          "array"
        ],
        "items": [
          {
            "type": [
              "null",
              "string"
            ]
          }
        ]
      }
    }
  },
  "dsgnsys.WbuDatePicker": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "label": {
        "default": "Field Title",
        "maxLength": 120,
        "type": "string"
      },
      "tooltip": {
        "default": "",
        "maxLength": 1200,
        "type": "string"
      },
      "placeholder": {
        "default": "Choose a Date",
        "maxLength": 120,
        "type": "string"
      },
      "divider": {
        "default": "long",
        "enum": [
          "long",
          "short",
          "none"
        ],
        "type": "string"
      }
    }
  },
  "dsgnsys.WbuDrillDown": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "label": {
        "default": "Label Title",
        "maxLength": 120,
        "type": "string"
      },
      "description": {
        "default": "This is a description text",
        "maxLength": 1200,
        "type": "string"
      },
      "iconType": {
        "default": "None",
        "enum": [
          "None",
          "Info",
          "Alert"
        ],
        "type": "string"
      },
      "tooltip": {
        "default": "",
        "maxLength": 1200,
        "type": "string"
      }
    }
  },
  "dsgnsys.WbuDropdown": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "fieldTitle": {
        "default": "Dropdown",
        "maxLength": 120,
        "type": "string"
      },
      "options": {
        "default": [],
        "type": [
          "array"
        ],
        "items": [
          {
            "type": [
              "null",
              "string"
            ]
          }
        ]
      },
      "tooltipInfo": {
        "default": "",
        "maxLength": 1200,
        "type": "string"
      },
      "placeholder": {
        "default": "Choose an option",
        "maxLength": 120,
        "type": "string"
      },
      "divider": {
        "default": "long",
        "enum": [
          "long",
          "short",
          "none"
        ],
        "type": "string"
      }
    }
  },
  "dsgnsys.WbuEmptyState": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "label": {
        "default": "Link to Lightbox",
        "maxLength": 120,
        "type": "string"
      },
      "description": {
        "default": "Create your own lightboxes and link to them for any place in your site.",
        "maxLength": 1200,
        "type": "string"
      },
      "textButtonLabel": {
        "default": "Start Creating",
        "maxLength": 120,
        "type": "string"
      },
      "url": {
        "default": "",
        "maxLength": 120,
        "type": "string"
      },
      "illustration": {
        "type": [
          "null",
          "string"
        ]
      }
    }
  },
  "dsgnsys.WbuFontAndColorPicker": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "label": {
        "default": "Pick Font and Color",
        "maxLength": 120,
        "type": "string"
      },
      "tooltip": {
        "default": "",
        "maxLength": 1200,
        "type": "string"
      },
      "font": {
        "default": "arial",
        "maxLength": 1200,
        "format": "font-family",
        "type": "string"
      },
      "color": {
        "default": "#FFC233",
        "maxLength": 120000,
        "type": "string"
      },
      "divider": {
        "default": "long",
        "enum": [
          "long",
          "short",
          "none"
        ],
        "type": "string"
      }
    }
  },
  "dsgnsys.WbuHorizontalTabs": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "tabsStyle": {
        "default": "Folder",
        "enum": [
          "Folder",
          "Arrowed",
          "Arrowed Without a Line"
        ],
        "type": "string"
      },
      "options": {
        "default": [],
        "type": [
          "array"
        ],
        "items": [
          {
            "type": [
              "null",
              "string"
            ]
          }
        ]
      },
      "maxVisibleTabs": {
        "default": 3,
        "minimum": 1,
        "maximum": 10,
        "type": "number",
        "multipleOf": 1
      },
      "tabsToScroll": {
        "default": 3,
        "minimum": 1,
        "maximum": 10,
        "type": "number",
        "multipleOf": 1
      }
    }
  },
  "dsgnsys.WbuLeftTextButton": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "text": {
        "default": "Text Button",
        "maxLength": 120,
        "type": "string"
      },
      "url": {
        "default": "",
        "maxLength": 120,
        "type": "string"
      },
      "size": {
        "default": "medium",
        "enum": [
          "tiny",
          "small",
          "medium"
        ],
        "type": "string"
      },
      "skin": {
        "default": "standard",
        "enum": [
          "standard",
          "premium"
        ],
        "type": "string"
      },
      "weight": {
        "default": "normal",
        "enum": [
          "thin",
          "normal"
        ],
        "type": "string"
      },
      "prefixIcon": {
        "type": [
          "null",
          "string"
        ]
      },
      "suffixIcon": {
        "type": [
          "null",
          "string"
        ]
      },
      "divider": {
        "default": "long",
        "enum": [
          "long",
          "short",
          "none"
        ],
        "type": "string"
      }
    }
  },
  "dsgnsys.WbuMultilineTextInput": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "label": {
        "default": "Field Title",
        "maxLength": 120,
        "type": "string"
      },
      "tooltip": {
        "default": "",
        "maxLength": 120000,
        "type": "string"
      },
      "value": {
        "default": "",
        "maxLength": 1200,
        "type": "string"
      },
      "placeholder": {
        "default": "Write text here...",
        "maxLength": 1200,
        "type": "string"
      },
      "maxLength": {
        "default": 0,
        "type": "number",
        "multipleOf": 1
      },
      "closeOnEnterKeyPress": {
        "default": false,
        "type": "boolean"
      },
      "autoFocus": {
        "default": false,
        "type": "boolean"
      },
      "selectTextOnFocus": {
        "default": false,
        "type": "boolean"
      },
      "readOnly": {
        "default": false,
        "type": "boolean"
      },
      "usePatternValidation": {
        "default": false,
        "type": "boolean"
      },
      "regexPattern": {
        "default": "",
        "maxLength": 1200,
        "type": "string"
      },
      "validationMessage": {
        "default": "",
        "maxLength": 1200,
        "type": "string"
      },
      "divider": {
        "default": "long",
        "enum": [
          "long",
          "short",
          "none"
        ],
        "type": "string"
      }
    }
  },
  "dsgnsys.WbuNotificationBanner": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "label": {
        "default": "",
        "maxLength": 1200,
        "type": "string"
      },
      "skin": {
        "default": "standard",
        "enum": [
          "standard",
          "premium",
          "alert",
          "success"
        ],
        "type": "string"
      },
      "linkText": {
        "default": "",
        "maxLength": 120,
        "type": "string"
      },
      "linkUrl": {
        "default": "",
        "maxLength": 120,
        "type": "string"
      },
      "iconTooltipText": {
        "default": "",
        "maxLength": 1200,
        "type": "string"
      },
      "multiline": {
        "default": false,
        "type": "boolean"
      }
    }
  },
  "dsgnsys.WbuNumericInput": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "title": {
        "default": "",
        "maxLength": 120,
        "type": "string"
      },
      "value": {
        "default": 0,
        "type": "number"
      },
      "unitSuffix": {
        "default": "None",
        "enum": [
          "None",
          "Pixels",
          "Percentage",
          "Degrees"
        ],
        "type": "string"
      },
      "numberOfFractions": {
        "default": 2,
        "minimum": 0,
        "maximum": 2,
        "type": "number",
        "multipleOf": 1
      },
      "steps": {
        "default": 1,
        "minimum": 1,
        "maximum": 100,
        "type": "number",
        "multipleOf": 1
      },
      "stepControls": {
        "default": false,
        "type": "boolean"
      },
      "minValue": {
        "default": 0,
        "type": "number"
      },
      "maxValue": {
        "default": 100,
        "type": "number"
      },
      "divider": {
        "default": "long",
        "enum": [
          "long",
          "short",
          "none"
        ],
        "type": "string"
      }
    }
  },
  "dsgnsys.WbuRadioButtonGroup": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "fieldTitle": {
        "default": "Radio Buttons",
        "maxLength": 120,
        "type": "string"
      },
      "options": {
        "default": [],
        "type": [
          "array"
        ],
        "items": [
          {
            "type": [
              "null",
              "string"
            ]
          }
        ]
      },
      "tooltipInfo": {
        "default": "",
        "maxLength": 1200,
        "type": "string"
      },
      "divider": {
        "default": "long",
        "enum": [
          "long",
          "short",
          "none"
        ],
        "type": "string"
      }
    }
  },
  "dsgnsys.WbuRichText": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "richTextContent": {
        "default": "Your placeholder text goes here. Write, style and link it.",
        "maxLength": 120000,
        "type": "string"
      },
      "richTextLabel": {
        "default": "",
        "maxLength": 120,
        "type": "string"
      },
      "link": {
        "pattern": "^$|^#",
        "type": [
          "null",
          "string"
        ]
      },
      "richTextLink": {
        "default": "",
        "maxLength": 120,
        "type": "string"
      },
      "alignTextToCenter": {
        "default": false,
        "type": "boolean"
      },
      "divider": {
        "default": "long",
        "enum": [
          "long",
          "short",
          "none"
        ],
        "type": "string"
      }
    }
  },
  "dsgnsys.WbuSectionDivider": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "sectionTitle": {
        "default": "Section Divider",
        "maxLength": 120,
        "type": "string"
      },
      "tooltipInfo": {
        "default": "",
        "maxLength": 1200,
        "type": "string"
      }
    }
  },
  "dsgnsys.WbuSlider": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "fieldTitle": {
        "default": "Slider",
        "maxLength": 120,
        "type": "string"
      },
      "tooltipInfo": {
        "default": "",
        "maxLength": 1200,
        "type": "string"
      },
      "unitOfMeasurement": {
        "default": "number",
        "enum": [
          "number",
          "percentage",
          "pixels",
          "angle"
        ],
        "type": "string"
      },
      "defaultSelectedValue": {
        "default": 0,
        "type": "number",
        "multipleOf": 1
      },
      "minimumValue": {
        "default": 0,
        "type": "number",
        "multipleOf": 1
      },
      "maximumValue": {
        "default": 100,
        "type": "number",
        "multipleOf": 1
      },
      "stepValue": {
        "default": 1,
        "type": "number",
        "multipleOf": 1
      },
      "showNumericInput": {
        "default": true,
        "type": "boolean"
      },
      "divider": {
        "default": "long",
        "enum": [
          "long",
          "short",
          "none"
        ],
        "type": "string"
      }
    }
  },
  "dsgnsys.WbuTextInput": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "fieldTitle": {
        "default": "Text Input",
        "maxLength": 120,
        "type": "string"
      },
      "tooltipInfo": {
        "default": "",
        "maxLength": 1200,
        "type": "string"
      },
      "defaultText": {
        "default": "Write it here...",
        "maxLength": 120,
        "type": "string"
      },
      "placeholder": {
        "default": "Placeholder text",
        "maxLength": 120,
        "type": "string"
      },
      "prefix": {
        "default": "",
        "maxLength": 120,
        "type": "string"
      },
      "readOnly": {
        "default": false,
        "type": "boolean"
      },
      "autofocus": {
        "default": false,
        "type": "boolean"
      },
      "selectedOnFocus": {
        "default": true,
        "type": "boolean"
      },
      "charactersLimit": {
        "default": 100,
        "type": "number",
        "multipleOf": 1
      },
      "usePatternValidation": {
        "default": false,
        "type": "boolean"
      },
      "regexPattern": {
        "default": "",
        "maxLength": 1200,
        "type": "string"
      },
      "errorMessage": {
        "default": "",
        "maxLength": 1200,
        "type": "string"
      },
      "divider": {
        "default": "long",
        "enum": [
          "long",
          "short",
          "none"
        ],
        "type": "string"
      }
    }
  },
  "dsgnsys.WbuThumbnails": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "fieldTitle": {
        "default": "Field Title",
        "maxLength": 120,
        "type": "string"
      },
      "tooltipInfo": {
        "default": "",
        "maxLength": 1200,
        "type": "string"
      },
      "setNumberOfColumns": {
        "default": 3,
        "minimum": 1,
        "maximum": 5,
        "type": "number",
        "multipleOf": 1
      },
      "showEmptyThumbnail": {
        "default": false,
        "type": "boolean"
      },
      "thumbnailHeight": {
        "default": "Fixed ratio (1:1)",
        "enum": [
          "Fixed ratio (1:1)",
          "Fluid"
        ],
        "type": "string"
      },
      "displayLabels": {
        "default": true,
        "type": "boolean"
      },
      "options": {
        "default": [],
        "type": [
          "array"
        ],
        "items": [
          {
            "type": [
              "null",
              "string"
            ]
          }
        ]
      },
      "divider": {
        "default": "long",
        "enum": [
          "long",
          "short",
          "none"
        ],
        "type": "string"
      }
    },
    "required": [
      "options"
    ]
  },
  "ThumbnailItemData": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "label": {
        "maxLength": 120,
        "type": "string"
      },
      "value": {
        "maxLength": 120,
        "type": "string"
      },
      "disabled": {
        "default": false,
        "type": "boolean"
      },
      "isDefault": {
        "default": false,
        "type": "boolean"
      },
      "unavailable": {
        "default": false,
        "type": "boolean"
      },
      "illustration": {
        "type": [
          "null",
          "string"
        ]
      }
    },
    "required": [
      "label",
      "value"
    ]
  },
  "dsgnsys.WbuToggleSwitch": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "label": {
        "default": "Toggle Switch",
        "maxLength": 120,
        "type": "string"
      },
      "toggleSwitch": {
        "default": true,
        "type": "boolean"
      },
      "disabled": {
        "default": false,
        "type": "boolean"
      },
      "divider": {
        "default": "long",
        "enum": [
          "long",
          "short",
          "none"
        ],
        "type": "string"
      }
    }
  },
  "dsgnsys.WutAvatar": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "firstName": {
        "default": "",
        "maxLength": 120,
        "type": "string"
      },
      "lastName": {
        "default": "",
        "maxLength": 120,
        "type": "string"
      },
      "src": {
        "default": "",
        "maxLength": 1200,
        "type": "string"
      }
    }
  },
  "dsgnsys.WutAvatarGroup": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "maxAvatars": {
        "default": 5,
        "minimum": 1,
        "type": "number",
        "multipleOf": 1
      },
      "showHiddenAvatarCount": {
        "default": true,
        "type": "boolean"
      },
      "avatars": {
        "default": [],
        "type": [
          "array"
        ],
        "items": [
          {
            "type": [
              "null",
              "string"
            ]
          }
        ]
      }
    }
  },
  "dsgnsys.WutBadge": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "text": {
        "default": "My Badge",
        "maxLength": 120,
        "type": "string"
      },
      "icon": {
        "type": [
          "null",
          "string"
        ]
      },
      "composition": {
        "default": "TextAndIcon",
        "enum": [
          "TextAndIcon",
          "Text",
          "Icon",
          "None"
        ],
        "type": "string"
      },
      "alt": {
        "default": "",
        "maxLength": 120,
        "type": "string"
      }
    }
  },
  "dsgnsys.WutRadioButton": {
    "additionalProperties": false,
    "type": [
      "object"
    ],
    "properties": {
      "type": {
        "type": "string"
      },
      "id": {
        "type": "string"
      },
      "metaData": {
        "type": "object",
        "properties": {
          "pageId": {
            "type": "string"
          },
          "isPreset": {
            "type": "boolean"
          },
          "schemaVersion": {
            "type": "string"
          },
          "isHidden": {
            "type": "boolean"
          },
          "logicalName": {
            "type": "string"
          },
          "description": {
            "type": "string",
            "maxLength": 4000
          },
          "sig": {
            "type": "string"
          },
          "fragmentInstance": {
            "type": "string"
          }
        },
        "additionalProperties": false
      },
      "radioGroupName": {
        "default": "",
        "maxLength": 120,
        "type": "string"
      },
      "value": {
        "default": "",
        "maxLength": 120,
        "type": "string"
      },
      "checked": {
        "default": false,
        "type": "boolean"
      },
      "required": {
        "default": false,
        "type": "boolean"
      }
    },
    "required": [
      "value"
    ]
  }
}
